        // Lightweight toast notification for cart errors
        function showCartToast(msg) {
            var existing = document.getElementById('kinsora-toast');
            if (existing) existing.remove();
            var toast = document.createElement('div');
            toast.id = 'kinsora-toast';
            toast.textContent = msg || 'Something went wrong. Please try again.';
            toast.style.cssText = 'position:fixed;bottom:24px;left:50%;transform:translateX(-50%);background:#333;color:#fff;padding:12px 24px;border-radius:6px;font-family:var(--font-body,"Newsreader",Georgia,"Times New Roman",serif);font-size:13px;letter-spacing:0.02em;z-index:99999;opacity:0;transition:opacity 0.3s ease;';
            document.body.appendChild(toast);
            requestAnimationFrame(function() { toast.style.opacity = '1'; });
            setTimeout(function() {
                toast.style.opacity = '0';
                setTimeout(function() { toast.remove(); }, 300);
            }, 3000);
        }

        // Initialize global namespace
        window.Kinsora = window.Kinsora || {};

        // ────────────────────────────────────────────────────────────
        //   Cart-aware Buy 1, Get 1 Free projection
        // ────────────────────────────────────────────────────────────
        // The server-rendered BOGO bar owns the authoritative product
        // count. Native bundle components are included and complimentary gifts
        // are excluded. Legacy method/event names remain as compatibility
        // aliases for builder modules; their semantics are BOGO, never tiers.
        window.Kinsora.stackTier = (function() {
            var lastCartCount = null;

            function getCartCount() {
                var bar = document.querySelector('#shopify-section-stack-tier-bar [data-stier], [data-stier][data-n]');
                var count = bar ? parseInt(bar.getAttribute('data-n'), 10) : 0;
                return isNaN(count) || count < 0 ? 0 : count;
            }

            function getCartPrices() {
                var bar = document.querySelector('#shopify-section-stack-tier-bar [data-bogo-prices]');
                return String(bar ? bar.getAttribute('data-bogo-prices') || '' : '')
                    .split(',')
                    .map(function(value) { return parseInt(value, 10); })
                    .filter(function(value) { return !isNaN(value) && value > 0; });
            }

            function priceState(prices) {
                var sorted = (Array.isArray(prices) ? prices : [])
                    .map(function(value) { return Math.max(0, Math.round(Number(value) || 0)); })
                    .filter(function(value) { return value > 0; })
                    .sort(function(a, b) { return a - b; });
                var freeCount = (Math.floor(sorted.length / 3) * 2);
                var freePrices = sorted.slice(0, freeCount);
                var savings = freePrices.reduce(function(sum, value) { return sum + value; }, 0);
                var list = sorted.reduce(function(sum, value) { return sum + value; }, 0);
                return { count: sorted.length, freeCount: freeCount, savingsCents: savings, payCents: list - savings, listCents: list, prices: sorted, freePrices: freePrices };
            }

            function subtractPriceMultiset(prices, removals) {
                var remaining = (Array.isArray(prices) ? prices : []).slice();
                (Array.isArray(removals) ? removals : []).forEach(function(value) {
                    var index = remaining.indexOf(value);
                    if (index !== -1) remaining.splice(index, 1);
                });
                return remaining;
            }

            function pendingFreeIndexes(pendingPrices, state) {
                var prices = (Array.isArray(pendingPrices) ? pendingPrices : []).map(function(value) {
                    return Math.max(0, Math.round(Number(value) || 0));
                });
                var projected = state || priceState(prices);
                var freePrices = Array.isArray(projected.incrementalFreePrices)
                    ? projected.incrementalFreePrices.slice()
                    : priceState(prices).freePrices.slice();
                var indexes = prices.map(function() { return false; });

                freePrices.sort(function(a, b) { return a - b; }).forEach(function(freePrice) {
                    for (var i = 0; i < prices.length; i += 1) {
                        if (!indexes[i] && prices[i] === freePrice) {
                            indexes[i] = true;
                            break;
                        }
                    }
                });
                return indexes;
            }

            function stateForTotal(total) {
                var count = Math.max(0, parseInt(total, 10) || 0);
                var freeCount = (Math.floor(count / 3) * 2);
                var needsOne = count % 3 === 2;
                return {
                    count: count,
                    totalCount: count,
                    tier: freeCount,
                    discount: 0,
                    nextDiscount: null,
                    needed: 3 - (count % 3),
                    freeCount: freeCount,
                    needsOne: needsOne,
                    pairComplete: count > 0 && count % 3 === 0
                };
            }

            function project(pendingCount) {
                var pending = Math.max(0, parseInt(pendingCount, 10) || 0);
                var cart = getCartCount();
                var before = stateForTotal(cart);
                var result = stateForTotal(cart + pending);
                result.cart = before;
                result.cartCount = cart;
                result.pendingCount = pending;
                result.totalCount = cart + pending;
                result.incrementalFreeCount = Math.max(0, result.freeCount - before.freeCount);
                result.completesPair = result.incrementalFreeCount > 0;
                return result;
            }

            function projectPrices(pendingPrices) {
                var cartPrices = getCartPrices();
                var pending = Array.isArray(pendingPrices) ? pendingPrices : [];
                var before = priceState(cartPrices);
                var after = priceState(cartPrices.concat(pending));
                after.cart = before;
                after.cartCount = before.count;
                after.pendingCount = pending.length;
                after.totalCount = after.count;
                after.needsOne = after.count % 3 === 2;
                after.needed = 3 - (after.count % 3);
                after.incrementalPayCents = Math.max(0, after.payCents - before.payCents);
                after.incrementalSavingsCents = Math.max(0, after.savingsCents - before.savingsCents);
                after.incrementalFreePrices = subtractPriceMultiset(after.freePrices, before.freePrices);
                after.incrementalFreeCount = Math.max(0, after.freeCount - before.freeCount);
                after.completesPair = after.incrementalFreeCount > 0;
                return after;
            }

            function describeProjection(state, subject) {
                return 'Buy 1, Get 1 Free';
}

            function announce(force) {
                var count = getCartCount();
                if (!force && count === lastCartCount) return;
                lastCartCount = count;
                document.dispatchEvent(new CustomEvent('kinsora:cart-tier-updated', {
                    detail: { cartCount: count, bogo: stateForTotal(count) },
                    bubbles: true,
                    cancelable: false
                }));
                document.dispatchEvent(new CustomEvent('kinsora:cart-bogo-updated', {
                    detail: { cartCount: count, bogo: stateForTotal(count) },
                    bubbles: true,
                    cancelable: false
                }));
            }

            function observeBar() {
                var wrap = document.getElementById('shopify-section-stack-tier-bar');
                if (!wrap || typeof MutationObserver === 'undefined') {
                    announce(true);
                    return;
                }
                new MutationObserver(function() { announce(false); }).observe(wrap, {
                    subtree: true,
                    childList: true,
                    attributes: true,
                    attributeFilter: ['data-n']
                });
                announce(true);
            }

            if (document.readyState === 'loading') {
                document.addEventListener('DOMContentLoaded', observeBar, { once: true });
            } else {
                observeBar();
            }

            return {
                getCartCount: getCartCount,
                getCartPrices: getCartPrices,
                tierForTotal: stateForTotal,
                stateForTotal: stateForTotal,
                project: project,
                projectPrices: projectPrices,
                priceState: priceState,
                pendingFreeIndexes: pendingFreeIndexes,
                describeProjection: describeProjection,
                announce: announce,
                normalizeTiers: function() { return []; }
            };
        })();
        window.Kinsora.bogo = window.Kinsora.stackTier;

        window.Kinsora.refreshProjectedCards = function() {
            if (!window.Kinsora.stackTier) return;
            document.querySelectorAll('[data-kinsora-projected-card]').forEach(function(card) {
                var base = parseInt(card.getAttribute('data-kinsora-base-cents'), 10) || 0;
                var products = parseInt(card.getAttribute('data-kinsora-product-count'), 10) || 1;
                if (base <= 0) return;
                var projection = window.Kinsora.stackTier.project(products);
                var money = window.Kinsora.formatMoney || function(cents) { return '$' + (cents / 100).toFixed(2); };
                var compareNode = card.querySelector('[data-kinsora-card-compare]');
                var currentNode = card.querySelector('[data-kinsora-card-current]');
                var badgeNode = card.querySelector('[data-kinsora-card-badge]');
                if (compareNode) compareNode.textContent = money(base);
                if (currentNode) currentNode.textContent = money(base);
                if (badgeNode) {
                    badgeNode.textContent = 'Buy 1, Get 1 Free';
                    badgeNode.setAttribute('aria-label', 'Buy 1, Get 1 Free');
                }
                var terms = card.querySelector('[data-card-payment-terms]');
                if (terms) {
                    terms.setAttribute('data-kinsora-discount-pct', '0');
                    if (window.Kinsora.shopPayOverride) {
                        terms.querySelectorAll('shopify-payment-terms').forEach(function(widget) {
                            window.Kinsora.shopPayOverride.applyOverride(widget);
                        });
                    }
                }
            });
        };
        document.addEventListener('kinsora:cart-tier-updated', function() {
            window.Kinsora.refreshProjectedCards();
        });

        // Keep the PDP BOGO explainer in lockstep with cart mutations. Liquid
        // renders the correct initial state, while drawer changes happen without
        // a page navigation and therefore need the same authoritative tier event.
        window.Kinsora.refreshBogoLadders = function(cartCount) {
            var count = Math.max(0, parseInt(cartCount, 10) || 0);
            var needsOne = count % 3 === 2;
            document.querySelectorAll('[data-bogo-ladder]').forEach(function(card) {
                var heading = card.querySelector('.stack-ladder-card__lead strong');
                var message = card.querySelector('.stack-ladder-card__row');
                var note = card.querySelector('.stack-ladder-card__fine');
                if (heading) heading.textContent = card.getAttribute(needsOne ? 'data-heading-next' : 'data-heading-base') || '';
                if (message) message.textContent = card.getAttribute(needsOne ? 'data-message-next' : 'data-message-base') || '';
                if (note) note.textContent = card.getAttribute(needsOne ? 'data-note-next' : 'data-note-base') || '';
            });
        };
        document.addEventListener('kinsora:cart-tier-updated', function(event) {
            var detail = event && event.detail ? event.detail : {};
            window.Kinsora.refreshBogoLadders(detail.cartCount);
        });

        // ────────────────────────────────────────────────────────────
        //   Shop Pay Installments amount override
        // ────────────────────────────────────────────────────────────
        // Shopify's <shopify-payment-terms> widget computes installments from
        // the product price. BOGO does not assign one uniform percentage to
        // every product, so product-page installment messaging always stays on
        // the undiscounted item price; Shopify remains authoritative in cart.
        //
        // This module finds each rendered Shop Pay widget, reads our own
        // data-kinsora-base-cents + data-kinsora-discount-pct attributes,
        // computes the post-first-tier-discount installment, and rewrites
        // the displayed amount inside the widget's content. The Shop Pay
        // logo + the real "Learn more" modal are untouched — only the
        // dollar figure changes.
        //
        // Caveat:
        //   - If Shopify changes the widget's inner DOM, the
        //     regex may need updating.
        //   - Handles both light-DOM and open-shadow-DOM rendering.
        window.Kinsora.shopPayOverride = (function() {
            /* Match a formatted amount on either side of its currency marker.
               This covers CA$/A$, codes, and common non-dollar symbols. */
            var MONEY_RE = /(?:(?:[A-Z]{1,3}\$|[$€£¥₹₩฿₫₱₪₺₽₴₦₡₲₵₸₼₾₿]|[A-Z]{3}\s*)\s*-?\d[\d.,'’\u00A0\u202F ]*|-?\d[\d.,'’\u00A0\u202F ]*\s*(?:[A-Z]{3}|[$€£¥₹₩฿₫₱₪₺₽₴₦₡₲₵₸₼₾₿]))/;

            function formatMoney(cents) {
                // Delegate to the shop-level money formatter so multi-currency
                // shops render the right symbol / separators (set in theme.liquid).
                return (window.Kinsora && window.Kinsora.formatMoney)
                    ? window.Kinsora.formatMoney(cents)
                    : '$' + (cents / 100).toFixed(2);
            }

            // Find the [data-product-payment-terms] wrapper that owns this widget
            // (falls back to the nearest ancestor carrying our metadata).
            function wrapperOf(widget) {
                if (widget && widget.closest) {
                    var w = widget.closest('[data-product-payment-terms]');
                    if (w) return w;
                }
                var el = widget;
                while (el && el !== document.documentElement) {
                    if (el.getAttribute && (el.getAttribute('data-kinsora-base-cents') != null ||
                        (el.hasAttribute && el.hasAttribute('data-product-payment-terms')))) return el;
                    el = el.parentElement;
                }
                return null;
            }

            // Parse a rendered money string ("CA$68.00", "£1,234.50",
            // "1.234,56 €", "¥1,500", "KWD 10.000") to Shopify's integer
            // hundredths. Currency metadata distinguishes decimal marks from
            // grouping marks for zero-, two-, three-, and four-decimal currencies.
            function parseMoneyToCents(text) {
                if (!text) return NaN;
                var m = String(text).match(/\d[\d.,'’\u00A0\u202F ]*\d|\d/);
                if (!m) return NaN;
                var s = m[0].trim();
                var currencyData = window.Shopify && window.Shopify.currency;
                var currencyCode = (currencyData && currencyData.active) ||
                    (window.Kinsora && window.Kinsora.presentmentCurrency) ||
                    (window.Kinsora && window.Kinsora.shopCurrency) || 'USD';
                var fractionDigits = 2;
                try {
                    fractionDigits = new Intl.NumberFormat('en', {
                        style: 'currency',
                        currency: currencyCode
                    }).resolvedOptions().maximumFractionDigits;
                } catch (e) {}
                var dec = Math.max(s.lastIndexOf('.'), s.lastIndexOf(','));
                var after = dec === -1 ? -1 : s.length - dec - 1;
                var normalized;
                if (fractionDigits > 0 && dec !== -1 && after === fractionDigits) {
                    normalized = s.slice(0, dec).replace(/[^\d]/g, '') + '.' + s.slice(dec + 1).replace(/[^\d]/g, '');
                } else {
                    normalized = s.replace(/[^\d]/g, '');
                }
                var cents = Math.round(Number(normalized || '0') * 100);
                return isNaN(cents) ? NaN : cents;
            }

            // The DISPLAYED (discount-correct) price for a widget, in cents.
            // Prefer the live price node named by data-kinsora-price-source — the
            // exact "$54"/"$68"/"$101.50" the customer sees, which already reflects
            // the automatic tier discount and updates live on variant/bundle/stack
            // changes. Fall back to base-cents × (1 − pct) only when no source is
            // named or it isn't populated yet.
            function displayedCents(widget) {
                var wrap = wrapperOf(widget);
                if (!wrap) return NaN;
                var sel = wrap.getAttribute('data-kinsora-price-source');
                if (sel) {
                    var node = document.querySelector(sel);
                    if (node) {
                        var c = parseMoneyToCents(node.textContent);
                        if (!isNaN(c) && c > 0) return c;
                    }
                }
                var base = parseInt(wrap.getAttribute('data-kinsora-base-cents'), 10);
                var pct = parseFloat(wrap.getAttribute('data-kinsora-discount-pct')) || 0;
                if (!base || isNaN(base) || base <= 0) return NaN;
                return base * (1 - pct / 100);
            }

            function computeInstallment(widget) {
                var cents = displayedCents(widget);
                if (!cents || isNaN(cents) || cents <= 0) return null;
                return formatMoney(Math.round(cents / 4));
            }

            function widgetVariantIsEligible(widget) {
                if (!widget || !widget.getAttribute) return false;
                try {
                    var meta = JSON.parse(widget.getAttribute('shopify-meta') || '{}');
                    var variants = Array.isArray(meta.variants) ? meta.variants : [];
                    var variantId = String(widget.getAttribute('variant-id') || '');
                    var variant = variants.find(function(candidate) {
                        return String(candidate && candidate.id || '') === variantId;
                    }) || variants[0];
                    return !!variant && variant.eligible === true && variant.available !== false;
                } catch (e) {
                    return false;
                }
            }

            function replaceMoneyIn(root, newText) {
                if (!root) return false;
                // Threshold message ("...orders over $50") is not an installment price - never rewrite it.
                if (root.textContent && root.textContent.indexOf('orders over') > -1) return false;
                try {
                    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null, false);
                    var node;
                    while ((node = walker.nextNode())) {
                        if (MONEY_RE.test(node.textContent)) {
                            // If the text already matches what we want, skip
                            // (prevents infinite mutation loop).
                            if (node.textContent.indexOf(newText) !== -1 &&
                                node.textContent.match(MONEY_RE)[0] === newText) {
                                return true;
                            }
                            node.textContent = node.textContent.replace(MONEY_RE, newText);
                            return true;
                        }
                    }
                } catch (e) {
                    // Cross-origin or closed-shadow access blocked — bail quietly.
                }
                return false;
            }

            function applyOverride(widget) {
                if (!widget) return;
                var wrap = wrapperOf(widget);
                var newText = computeInstallment(widget);
                var replaced = false;
                var combinedAmount = wrap && wrap.querySelector('[data-combined-installment-amount]');
                var combinedReady = false;
                if (combinedAmount && newText) {
                    combinedAmount.textContent = newText;
                    combinedReady = !!(wrap &&
                        !wrap.hidden &&
                        widgetVariantIsEligible(widget));
                }
                if (newText) {
                    replaced = replaceMoneyIn(widget, newText);
                    if (!replaced && widget.shadowRoot) {
                        replaced = replaceMoneyIn(widget.shadowRoot, newText);
                    }
                }
                // Reveal the strip only once we've written the discount-correct
                // amount (replaced === true, incl. the idempotent already-correct
                // case) OR the widget is showing a native "orders over $X"
                // threshold message for cheap items — so the widget's own
                // list-price figure never flashes before ours lands.
                if (wrap && !wrap.classList.contains('kinsora-pt-ready')) {
                    var txt = widget.textContent || '';
                    if (widget.shadowRoot) txt += ' ' + widget.shadowRoot.textContent;
                    var nativeThresholdOnly = txt.indexOf('orders over') > -1 && !combinedAmount;
                    if (combinedReady || replaced || nativeThresholdOnly) {
                        wrap.classList.add('kinsora-pt-ready');
                    }
                }
            }

            function watchWidget(widget) {
                if (widget._kinsoraWatching) return;
                widget._kinsoraWatching = true;

                // Initial attempt — widget may already be hydrated.
                applyOverride(widget);

                // MutationObserver re-runs the override every time Shopify
                // re-renders the widget (e.g. after variant-id changes).
                var observer = new MutationObserver(function() {
                    applyOverride(widget);
                });
                observer.observe(widget, {
                    childList: true,
                    subtree: true,
                    characterData: true,
                    attributes: true,
                    attributeFilter: ['shopify-meta', 'variant-id']
                });
                if (widget.shadowRoot) {
                    observer.observe(widget.shadowRoot, {
                        childList: true,
                        subtree: true,
                        characterData: true
                    });
                }
                widget._kinsoraObserver = observer;

                // Also re-run when the displayed price itself changes (variant
                // switch, bundle edits, Build-a-Stack updates). Those mutate the
                // price node — not the widget — so the widget observer alone
                // wouldn't catch them.
                var wrap = wrapperOf(widget);
                var sel = wrap && wrap.getAttribute('data-kinsora-price-source');
                if (sel) {
                    var priceNode = document.querySelector(sel);
                    if (priceNode) {
                        var priceObserver = new MutationObserver(function() {
                            applyOverride(widget);
                        });
                        priceObserver.observe(priceNode, {
                            childList: true,
                            subtree: true,
                            characterData: true
                        });
                        widget._kinsoraPriceObserver = priceObserver;
                    }
                }
            }

            function scan() {
                document.querySelectorAll('shopify-payment-terms').forEach(watchWidget);
            }

            // Watch the whole document for newly added widgets (cart-drawer
            // re-renders via /?sections=, dynamic content, etc.).
            var pageObserver = new MutationObserver(function(mutations) {
                for (var i = 0; i < mutations.length; i++) {
                    var added = mutations[i].addedNodes;
                    for (var j = 0; j < added.length; j++) {
                        var node = added[j];
                        if (node.nodeType !== 1) continue;
                        if (node.tagName === 'SHOPIFY-PAYMENT-TERMS') {
                            watchWidget(node);
                        }
                        if (node.querySelectorAll) {
                            node.querySelectorAll('shopify-payment-terms').forEach(watchWidget);
                        }
                    }
                }
            });

            function start() {
                scan();
                // Scope the observer to where payment-terms widgets actually appear
                // (PDP price area + cart-drawer re-renders) instead of the whole
                // document, so it stops waking on header/nav/footer mutations.
                var roots = [];
                var _main = document.getElementById('MainContent');
                var _drawer = document.getElementById('cartDrawer');
                if (_main) roots.push(_main);
                if (_drawer) roots.push(_drawer);
                if (!roots.length) roots.push(document.body);
                roots.forEach(function(root) {
                    pageObserver.observe(root, { childList: true, subtree: true });
                });
            }

            if (document.readyState === 'loading') {
                document.addEventListener('DOMContentLoaded', start);
            } else {
                start();
            }

            return {
                scan: scan,
                applyOverride: applyOverride,
                parseMoneyToCents: parseMoneyToCents
            };
        })();

        // Shared helper — keeps the PDP Shop Pay widget pointed at the
        // selected variant. Updates the hidden form input (source of
        // truth for the form-wrapped pattern), the widget element's
        // variant-id, AND data-kinsora-base-cents on the WRAPPER div so
        // our override math uses the new variant's admin price.
        window.Kinsora.updatePaymentTerms = function(variantId, variantPriceCents) {
            if (!variantId) return;
            // Form-bound source of truth (form-wrapped pattern)
            var input = document.querySelector('[data-payment-terms-variant-id]');
            if (input) input.value = variantId;
            // Update any rendered shopify-payment-terms widgets
            document.querySelectorAll('[data-product-payment-terms] shopify-payment-terms').forEach(function(el) {
                el.setAttribute('variant-id', variantId);
            });
            // Refresh data-kinsora-base-cents on the wrapper so the
            // override re-computes against the new variant's price.
            if (variantPriceCents) {
                document.querySelectorAll('[data-product-payment-terms]').forEach(function(wrap) {
                    wrap.setAttribute('data-kinsora-base-cents', String(variantPriceCents));
                });
                // Re-apply override immediately for any already-rendered
                // widgets; mutation observer will pick up Shopify's
                // re-render asynchronously.
                document.querySelectorAll('[data-product-payment-terms] shopify-payment-terms').forEach(function(el) {
                    if (window.Kinsora.shopPayOverride) window.Kinsora.shopPayOverride.applyOverride(el);
                });
            }
        };

        // Global image error handler — replaces broken product images with the placeholder SVG
        (function() {
            document.addEventListener('error', function(e) {
                var el = e.target;
                if (el.tagName === 'IMG' && !el.dataset.fallbackApplied) {
                    el.dataset.fallbackApplied = 'true';
                    var fallback = el.dataset.fallbackSrc || (el.id === 'mainImage' ? ((window.Kinsora && window.Kinsora.fallbackImage) || window.kinsoraFallbackImage || '') : '');
                    el.removeAttribute('srcset');
                    el.removeAttribute('sizes');
                    if (fallback) {
                        el.src = fallback;
                    } else {
                        // No real image available — replace with Shopify placeholder SVG
                        var wrapper = document.createElement('div');
                        wrapper.style.cssText = 'width:100%;height:100%;';
                        var svgEl = document.querySelector('.product-placeholder-img, .placeholder-svg--product-1');
                        if (svgEl) {
                            wrapper.innerHTML = svgEl.outerHTML;
                            wrapper.firstChild.style.cssText = 'width:100%;height:100%;object-fit:cover;background:#EDE7E0;';
                        } else {
                            wrapper.style.background = '#EDE7E0';
                        }
                        el.parentNode.replaceChild(wrapper, el);
                    }
                }
            }, true);
        })();

        // Product images from Liquid (populated dynamically)
        var thumbImages = (window.Kinsora && window.Kinsora.productImages) || window.kinsoraProductImages || [];

        var currentImageIndex = 0;

        function switchImage(thumb, index) {
            if (window.Kinsora && typeof window.Kinsora.galleryGoTo === 'function') {
                window.Kinsora.galleryGoTo(index, true);
                return;
            }
            currentImageIndex = index;
            // Keep the gallery's source-of-truth index in sync so the
            // inline swipe controller and PhotoSwipe lightbox agree on
            // which slide is "current". Without this, clicking a
            // thumbnail would leave inline `idx` stale and the
            // next swipe would jump to the wrong slide.
            if (window.Kinsora) window.Kinsora.currentImageIndex = index;
            if (typeof window.currentImageIndex !== 'undefined') window.currentImageIndex = index;
            // Update thumbnails
            document.querySelectorAll('.thumbnail').forEach(function(t) {
                t.classList.remove('active');
                t.removeAttribute('aria-current');
            });
            var thumbEl = document.querySelector('.thumbnail[data-index="' + index + '"]');
            if (thumbEl) {
                thumbEl.classList.add('active');
                thumbEl.setAttribute('aria-current', 'true');
            }
            // Update main image (must remove srcset or browser ignores src change)
            if (thumbImages[index]) {
                var mainImg = document.getElementById('mainImage');
                if (mainImg) {
                    var source = window.Kinsora && window.Kinsora.galleryImageSource && window.Kinsora.galleryImageSource(thumbImages[index]);
                    if (source && source.srcset) { mainImg.sizes = source.sizes; mainImg.srcset = source.srcset; }
                    else mainImg.removeAttribute('srcset');
                    mainImg.src = source ? source.src : thumbImages[index];
                }
            }
        }

        // Throttle helper — limits function execution to once per interval
        function throttle(fn, delay) {
            var lastCall = 0;
            var raf = null;
            return function() {
                var now = Date.now();
                var args = arguments;
                var context = this;
                if (now - lastCall >= delay) {
                    lastCall = now;
                    fn.apply(context, args);
                } else if (!raf) {
                    raf = requestAnimationFrame(function() {
                        lastCall = Date.now();
                        raf = null;
                        fn.apply(context, args);
                    });
                }
            };
        }

        // Safe closest — SVG child elements and text nodes lack .closest()
        function safeClosest(target, selector) {
            if (!target || typeof target.closest !== 'function') {
                // Walk up from text nodes or SVG elements to find an HTMLElement
                var node = target ? target.parentElement || target.parentNode : null;
                while (node && typeof node.closest !== 'function') {
                    node = node.parentElement || node.parentNode;
                }
                return node ? node.closest(selector) : null;
            }
            return target.closest(selector);
        }

        // Product image zoom — track mouse position for transform-origin
        (function() {
            var mainImage = document.querySelector('.main-image');
            if (mainImage) {
                mainImage.addEventListener('mousemove', throttle(function(e) {
                    var rect = mainImage.getBoundingClientRect();
                    var x = ((e.clientX - rect.left) / rect.width) * 100;
                    var y = ((e.clientY - rect.top) / rect.height) * 100;
                    var img = mainImage.querySelector('img');
                    if (img) img.style.transformOrigin = x + '% ' + y + '%';
                }, 16));
                mainImage.addEventListener('mouseleave', function() {
                    var img = mainImage.querySelector('img');
                    if (img) img.style.transformOrigin = 'center center';
                });
            }
        })();

        function openMobileMenu() {
            var menu = document.getElementById('mobileMenu');
            var overlay = document.getElementById('mobileMenuOverlay');
            menu.classList.add('open');
            overlay.classList.add('open');
            document.body.style.overflow = 'hidden';
            var hamburger = document.getElementById('hamburger');
            if (hamburger) hamburger.setAttribute('aria-expanded', 'true');
            // Set inert on main content so screen readers can't escape the menu
            var main = document.getElementById('MainContent');
            if (main) main.setAttribute('inert', '');
            // Focus the close button
            var closeBtn = menu.querySelector('.mobile-menu-close');
            if (closeBtn) closeBtn.focus();
        }

        function toggleMobileSubmenu(el) {
            var group = el.parentElement;
            var isOpen = group.classList.contains('open');
            // Close all other submenus first
            document.querySelectorAll('.mobile-nav-group').forEach(function(g) {
                g.classList.remove('open');
            });
            // Toggle the clicked one
            if (!isOpen) group.classList.add('open');
        }

        function closeMobileMenu() {
            var menu = document.getElementById('mobileMenu');
            var overlay = document.getElementById('mobileMenuOverlay');
            menu.classList.remove('open');
            overlay.classList.remove('open');
            document.body.style.overflow = '';
            var hamburger = document.getElementById('hamburger');
            if (hamburger) hamburger.setAttribute('aria-expanded', 'false');
            // Remove inert from main content
            var main = document.getElementById('MainContent');
            if (main) main.removeAttribute('inert');
            // Return focus to the hamburger
            if (hamburger) hamburger.focus();
        }

        // Footer accordion toggle (mobile)
        document.querySelectorAll('.footer-column .footer-heading').forEach(function(heading) {
            heading.addEventListener('click', function() {
                if (window.innerWidth >= 1024) return;
                var col = this.parentElement;
                var isOpen = col.classList.contains('open');
                // Close all others
                document.querySelectorAll('.footer-column').forEach(function(c) { c.classList.remove('open'); });
                // Toggle clicked one
                if (!isOpen) col.classList.add('open');
                document.querySelectorAll('.footer-column').forEach(function(c) {
                    var h = c.querySelector('.footer-heading');
                    if (h) h.setAttribute('aria-expanded', c.classList.contains('open') ? 'true' : 'false');
                });
            });
        });

        var megaMenuTimer = null;

        function openMegaMenu() {
            clearTimeout(megaMenuTimer);
            var megaMenu = document.getElementById('megaMenu');
            megaMenu.classList.add('open');
            // Update aria-expanded on triggers
            document.querySelectorAll('.mega-menu-trigger').forEach(function(t) {
                t.setAttribute('aria-expanded', 'true');
            });
        }

        function closeMegaMenu() {
            clearTimeout(megaMenuTimer);
            // 600ms close delay. The CSS hover-bridges on .mega-menu-trigger
            // and .mega-menu now cover the geometric dead zone between the
            // trigger link and the panel, so the timer rarely fires
            // mid-traversal. The 600ms still helps if the cursor briefly
            // slips outside (e.g. into the header gap to the left/right
            // of the trigger) before re-entering. Re-entering either the
            // trigger or the area cancels this timer via clearTimeout
            // inside openMegaMenu().
            megaMenuTimer = setTimeout(function() {
                var megaMenu = document.getElementById('megaMenu');
                megaMenu.classList.remove('open');
                document.querySelectorAll('.mega-menu-trigger').forEach(function(t) {
                    t.setAttribute('aria-expanded', 'false');
                });
            }, 600);
        }

        function forceCloseMegaMenu() {
            clearTimeout(megaMenuTimer);
            var megaMenu = document.getElementById('megaMenu');
            megaMenu.classList.remove('open');
            document.querySelectorAll('.mega-menu-trigger').forEach(function(t) {
                t.setAttribute('aria-expanded', 'false');
            });
        }

        // Mega menu hover delegation (replaces inline onmouseenter/onmouseleave)
        //
        // Helper: is this DOM node inside the trigger row or the panel?
        function isInsideMegaMenu(node) {
            if (!node) return false;
            return !!(safeClosest(node, '[data-action="mega-menu-trigger"]') ||
                      safeClosest(node, '[data-action="mega-menu-area"]'));
        }

        // Scope the hover listeners to .main-nav (which contains BOTH the
        // mega-menu triggers and the #megaMenu panel) instead of document, so
        // they don't fire for every element hovered across the whole page.
        var _megaNav = document.querySelector('.main-nav');
        if (_megaNav) {
            _megaNav.addEventListener('mouseenter', function(e) {
                if (isInsideMegaMenu(e.target)) openMegaMenu();
            }, true);

            // CRITICAL: only close if the cursor is actually LEAVING the menu
            // system. mouseleave fires on every descendant of the menu when the
            // mouse moves between them; e.relatedTarget is the element the cursor
            // is moving INTO — if it's still inside the menu, suppress the close.
            _megaNav.addEventListener('mouseleave', function(e) {
                if (!isInsideMegaMenu(e.target)) return;
                if (isInsideMegaMenu(e.relatedTarget)) return;
                closeMegaMenu();
            }, true);
        }
        document.addEventListener('focusin', function(e) {
            var trigger = safeClosest(e.target, '[data-action="mega-menu-trigger"]');
            if (trigger) openMegaMenu();
            var closeEl = safeClosest(e.target, '[data-action="mega-menu-close"]');
            if (closeEl) forceCloseMegaMenu();
        }, true);

        // Section Rendering API helper — fetches new section HTML without full page reload
        function fetchCollectionSection(url, focusSelector) {
            var sectionEl = document.querySelector('[data-section-type="collection-template"]');
            if (!sectionEl) { window.location.href = url; return; }
            var sectionId = sectionEl.closest('.shopify-section').id.replace('shopify-section-', '');
            var fetchUrl = new URL(url, window.location.origin);
            fetchUrl.searchParams.set('sections', sectionId);
            sectionEl.style.opacity = '0.5';
            sectionEl.style.pointerEvents = 'none';
            fetch(fetchUrl.toString())
                .then(function(r) { return r.json(); })
                .then(function(data) {
                    var html = data[sectionId];
                    if (html) {
                        var temp = document.createElement('div');
                        temp.innerHTML = html;
                        var newSection = temp.querySelector('[data-section-type="collection-template"]');
                        if (newSection) {
                            sectionEl.innerHTML = newSection.innerHTML;
                        }
                        var currentSidebar = document.getElementById('filtersSidebar');
                        var newSidebar = temp.querySelector('#filtersSidebar');
                        if (currentSidebar && newSidebar) currentSidebar.replaceWith(newSidebar);
                        var currentOverlay = document.getElementById('filtersOverlay');
                        var newOverlay = temp.querySelector('#filtersOverlay');
                        if (currentOverlay && newOverlay) currentOverlay.replaceWith(newOverlay);
                        syncFilterDrawerAccessibility(document);
                        if (focusSelector) {
                            window.requestAnimationFrame(function() {
                                focusWithoutScroll(document.querySelector(focusSelector));
                            });
                        }
                    }
                    sectionEl.style.opacity = '';
                    sectionEl.style.pointerEvents = '';
                    window.history.replaceState({}, '', url);
                })
                .catch(function() {
                    window.location.href = url;
                });
        }

        // Sort dropdown change handler (uses Section Rendering API)
        document.addEventListener('change', function(e) {
            var sortSelect = safeClosest(e.target, '[data-action="sort-collection"]');
            if (sortSelect) {
                var url = new URL(window.location.href);
                url.searchParams.set('sort_by', sortSelect.value);
                fetchCollectionSection(url.toString(), '#sortBy');
            }

            // Variant select dropdowns in stack builder
            var variantSelect = safeClosest(e.target, '[data-action="change-variant"]');
            if (variantSelect) {
                onVariantSelectChange(variantSelect);
            }
        });

        // Close mega menu on Escape key
        document.addEventListener('keydown', function(e) {
            if (e.key === 'Escape') {
                var megaMenu = document.getElementById('megaMenu');
                if (megaMenu && megaMenu.classList.contains('open')) {
                    forceCloseMegaMenu();
                }
                // Also close cart drawer on Escape
                var cartDrawer = document.getElementById('cartDrawer');
                if (cartDrawer && cartDrawer.classList.contains('open')) {
                    closeCart();
                }
                // Also close mobile menu on Escape
                var mobileMenu = document.getElementById('mobileMenu');
                if (mobileMenu && mobileMenu.classList.contains('open')) {
                    closeMobileMenu();
                }
            }
        });

        // Keep mega menu open while focus is inside it
        (function() {
            var megaMenu = document.getElementById('megaMenu');
            if (megaMenu) {
                megaMenu.addEventListener('focusin', function() { openMegaMenu(); });
                megaMenu.addEventListener('focusout', function(e) {
                    if (!megaMenu.contains(e.relatedTarget)) closeMegaMenu();
                });
            }
        })();

        function switchBuyBoxTab(tab, type) {
            document.querySelectorAll('.tab').forEach(t => t.classList.remove('active'));
            tab.classList.add('active');

            var necklaceMode = document.getElementById('necklaceOnlyMode');
            var stackMode = document.getElementById('buildStackMode');

            currentMode = type;

            // Close any open dropdowns before switching
            closeAllDropdowns();

            // Reset added items in both modes to prevent stale state
            var necklacePendantItems = document.getElementById('necklacePendantItems');
            if (necklacePendantItems) necklacePendantItems.innerHTML = '';
            var secondaryNecklaceItems = document.getElementById('secondaryNecklaceItems');
            if (secondaryNecklaceItems) secondaryNecklaceItems.innerHTML = '';
            var pendantItems = document.getElementById('pendantItems');
            if (pendantItems) pendantItems.innerHTML = '';

            // IMPORTANT: must remove the .is-hidden class (which uses
            // display: none !important) BEFORE setting inline display.
            // Without this, the inline style is overridden by !important
            // and the panel stays hidden. The Liquid template starts
            // build-stack-mode with .is-hidden on non-bundle PDPs so the
            // first paint shows necklace-only — once the user clicks the
            // Build a Stack tab, we have to actually strip that class.
            if (type === 'necklace') {
                if (necklaceMode) {
                    necklaceMode.classList.remove('is-hidden');
                    necklaceMode.style.display = 'flex';
                }
                if (stackMode) {
                    stackMode.classList.add('is-hidden');
                    stackMode.style.display = 'none';
                }
            } else {
                if (necklaceMode) {
                    necklaceMode.classList.add('is-hidden');
                    necklaceMode.style.display = 'none';
                }
                if (stackMode) {
                    stackMode.classList.remove('is-hidden');
                    stackMode.style.display = 'flex';
                }
                // Refresh all dropdown displays with bundle pricing
                refreshAllDropdownPricing();
            }

            updatePriceDisplay();
            refreshAddButtons();
            requestAnimationFrame(syncDeleteButtonHeights);
        }

        /* ---- Variant lookup engine ---- */
        var variants = (window.Kinsora && window.Kinsora.variants) || window.kinsoraVariants || [];
        var optionNames = (window.Kinsora && window.Kinsora.optionNames) || window.kinsoraOptionNames || [];

        function getSelectedOptions() {
            var opts = {};
            // Option 1 (typically Metal) — from swatches
            var activeSwatch = document.querySelector('.swatch-item.active');
            if (activeSwatch && activeSwatch.dataset.value && optionNames.length > 0) {
                opts[optionNames[0]] = activeSwatch.dataset.value;
            }
            // Option 2 (typically Length) — from length buttons
            var activeLength = document.querySelector('.length-btn.active');
            if (activeLength && activeLength.dataset.value && optionNames.length > 1) {
                opts[optionNames[1]] = activeLength.dataset.value;
            }
            return opts;
        }

        function findMatchingVariant(opts) {
            for (var i = 0; i < variants.length; i++) {
                var v = variants[i];
                var match = true;
                for (var j = 0; j < optionNames.length; j++) {
                    var optName = optionNames[j];
                    if (opts[optName] && v.options[j] !== opts[optName]) {
                        match = false;
                        break;
                    }
                }
                if (match) return v;
            }
            return null;
        }

        /* Update displayed price when variant changes */
        function updateDisplayedPrice(variant) {
            // Skip on bundle PDPs — kinsora-bundle-init.js owns the price area
            if (window.Kinsora && window.Kinsora.isBundlePDP) {
                if (typeof window.Kinsora.refreshBundlePrice === 'function') {
                    window.Kinsora.refreshBundlePrice();
                }
                return;
            }
            var priceEl = document.querySelector('.product-price-current');
            var compareEl = document.querySelector('.product-price-compare');
            if (!variant || !priceEl) return;
            priceEl.textContent = window.Kinsora.formatMoney(variant.price * 100);
            if (compareEl && variant.compareAtPrice) {
                compareEl.textContent = window.Kinsora.formatMoney(variant.compareAtPrice * 100);
                compareEl.style.display = '';
            } else if (compareEl) {
                compareEl.style.display = 'none';
            }
        }

        function updateVariantSelection() {
            var opts = getSelectedOptions();
            var variant = findMatchingVariant(opts);
            if (!variant) return;

            // Update hidden variant ID for the add-to-cart form
            var idInput = document.getElementById('variantIdInput');
            if (idInput) idInput.value = variant.id;

            // Update Shopify's <shopify-payment-terms> widget variant-id
            // so the "Pay in 4 of $X" message reflects the selected
            // variant. We also pass the new variant's admin price in
            // cents so our override math (data-kinsora-base-cents)
            // tracks the variant switch.
            if (window.Kinsora && window.Kinsora.updatePaymentTerms) {
                window.Kinsora.updatePaymentTerms(variant.id, Math.round(variant.price * 100));
            }

            // Update price display
            var currentEl = document.querySelector('.product-price .price-current');
            var compareEl = document.querySelector('.product-price .price-compare');
            var saveEl = document.querySelector('.product-price .price-save');

            // Bundle PDPs own their own price math (see kinsora-bundle-init.js).
            // Skip the generic per-variant overwrite here so swapping metal /
            // length doesn't stomp the bundle's slashed total + Save badge.
            var _isBundle = window.Kinsora && window.Kinsora.isBundlePDP;
            if (!_isBundle && currentEl && currentMode === 'necklace') {
                // Sync the active base price, then re-run updatePriceDisplay() so the
                // stack/tier discount (slash + Save badge) is re-applied. Writing the
                // raw variant price here was wiping the discount on every variant change.
                if (window.Kinsora) window.Kinsora.activeVariantPrice = variant.price;
                window.kinsoraActiveVariantPrice = variant.price;
                var lockedBase = document.querySelector('#buildStackMode .dropdown-wrapper[data-base-locked="true"]');
                if (lockedBase) {
                    lockedBase.dataset.priceCents = Math.round(variant.price * 100);
                    lockedBase.dataset.priceUnit = 'cents';
                    lockedBase.dataset.variantId = variant.id;
                }
                updatePriceDisplay();
            } else if (_isBundle && window.Kinsora.refreshBundlePrice) {
                // Variant changed on a bundle PDP — re-render the bundle total
                // (extra wrapper variant switches can change extras subtotal).
                window.Kinsora.refreshBundlePrice();
            }

            // Update main product image if variant has one, and sync gallery state
            if (variant.featuredImage) {
                var thumbs = document.querySelectorAll('.thumbnail-strip .thumbnail');
                var featuredIndex = -1;
                thumbs.forEach(function(thumb, i) {
                    if (variant.featuredMediaId && String(thumb.dataset.mediaId) === String(variant.featuredMediaId)) {
                        featuredIndex = i;
                    }
                });
                if (featuredIndex >= 0 && window.Kinsora && typeof window.Kinsora.galleryGoTo === 'function') {
                    window.Kinsora.galleryGoTo(featuredIndex, true);
                } else if (window.Kinsora && typeof window.Kinsora.galleryShowImage === 'function') {
                    window.Kinsora.galleryShowImage(variant.featuredImage);
                } else {
                    var mainImg = document.getElementById('mainImage');
                    if (mainImg) {
                        var source = window.Kinsora && window.Kinsora.galleryImageSource && window.Kinsora.galleryImageSource(variant.featuredImage);
                        if (source && source.srcset) { mainImg.sizes = source.sizes; mainImg.srcset = source.srcset; }
                        else mainImg.removeAttribute('srcset');
                        mainImg.src = source ? source.src : variant.featuredImage;
                    }
                }
            }

            // Update add-to-cart button availability
            var atcBtn = document.querySelector('.add-to-cart');
            if (atcBtn) {
                if (variant.available) {
                    atcBtn.disabled = false;
                    atcBtn.textContent = document.querySelector('.add-to-cart').dataset.addText || 'Add To Cart';
                } else {
                    atcBtn.disabled = true;
                    atcBtn.textContent = 'SOLD OUT';
                }
            }

            // Update the URL without reloading so the browser reflects the chosen variant
            if (window.history && window.history.replaceState) {
                var newUrl = window.location.pathname + '?variant=' + variant.id;
                window.history.replaceState({ variant: variant.id }, '', newUrl);
            }

            // Store the active variant price for necklace-only mode price calculations
            if (window.Kinsora) window.Kinsora.activeVariantPrice = variant.price;
            window.kinsoraActiveVariantPrice = variant.price;
        }

        function selectSwatch(swatch) {
            document.querySelectorAll('.swatch-item').forEach(s => s.classList.remove('active'));
            swatch.classList.add('active');
            // Update the metal label text
            var metalLabel = document.getElementById('selectedMetalLabel');
            if (metalLabel && swatch.dataset.value) {
                metalLabel.textContent = swatch.dataset.value;
            }
            updateVariantSelection();
        }

        function selectLength(button) {
            document.querySelectorAll('.length-btn').forEach(b => b.classList.remove('active'));
            button.classList.add('active');
            updateVariantSelection();
        }

        // Re-calculate selected item totals whenever the cart BOGO state changes.
        document.addEventListener('kinsora:stack-updated', function() {
            updatePriceDisplay();
            refreshAllDropdownPricing();
        });

        // Shopify placeholder SVG — used when products have no uploaded images
        var PLACEHOLDER_SVG = document.querySelector('.product-placeholder-img, .placeholder-svg--product-1');
        var PLACEHOLDER_SVG_MARKUP = PLACEHOLDER_SVG ? PLACEHOLDER_SVG.outerHTML.replace(/class="[^"]*"/, 'style="width:100%;height:100%;object-fit:cover;background:#EDE7E0;"') : '<svg viewBox="0 0 525 525" style="width:100%;height:100%;background:#EDE7E0;" xmlns="http://www.w3.org/2000/svg"><rect width="525" height="525" fill="#EDE7E0"/></svg>';

        // Fallback image — uses the product's own photo, or the Shopify placeholder SVG
        function getFallbackImage() {
            return (window.Kinsora && window.Kinsora.fallbackImage) || window.kinsoraFallbackImage || (thumbImages && thumbImages[0]) || '';
        }
        function makeImgTag(src, alt, fallbackSrc) {
            var imgSrc = src || fallbackSrc || getFallbackImage();
            // If no real image URL exists, use the Shopify placeholder SVG
            if (!imgSrc) return PLACEHOLDER_SVG_MARKUP;
            var fb = fallbackSrc || getFallbackImage();
            var img = document.createElement('img');
            img.src = imgSrc;
            img.alt = alt || '';
            img.loading = 'lazy';
            img.decoding = 'async';
            img.style.cssText = 'width:100%;height:100%;object-fit:cover;';
            if (fb) {
                img.addEventListener('error', function() {
                    this.removeEventListener('error', arguments.callee);
                    this.src = fb;
                }, { once: true });
            }
            return img;
        }
        // Helper: safely set element content to a DOM node or placeholder SVG string
        function setImgContent(container, imgResult) {
            container.innerHTML = '';
            if (typeof imgResult === 'string') {
                // Only for PLACEHOLDER_SVG_MARKUP (trusted constant)
                container.innerHTML = imgResult;
            } else {
                container.appendChild(imgResult);
            }
        }

        // Dynamic product arrays — read from window LIVE each call so customizer re-renders pick up new data
        // Fail closed if the Liquid product payload is unavailable. Invented USD
        // fallback products can display the wrong item, price, and currency.
        var _necklaceFallback = [];
        var _pendantFallback = [];
        function getNecklaceOptions() { return (window.Kinsora && window.Kinsora.necklaces) || window.kinsoraNecklaces || _necklaceFallback; }
        function getPendantOptions() { return (window.Kinsora && window.Kinsora.pendants) || window.kinsoraPendants || _pendantFallback; }

        var stackOnlyMode = (window.Kinsora && window.Kinsora.stackOnlyMode) || false;
        var isBundlePDP   = (window.Kinsora && window.Kinsora.isBundlePDP)   || false;
        // currentMode drives several downstream branches (price calc, ATC
        // routing). Initialize to 'bundle' on bundle PDPs so any code that
        // checks `currentMode === 'necklace'` naturally returns false and
        // we don't have to remember to guard every callsite with
        // !isBundlePDP. switchBuyBoxTab() can still overwrite this if the
        // hidden bundle tabs are clicked programmatically, but those tabs
        // are display:none so customers can't trigger it.
        var currentMode = isBundlePDP ? 'bundle' : 'stack';

        function wrapperPriceCents(wrapper) {
            if (!wrapper) return 0;
            var raw = Number(wrapper.dataset.priceCents || 0);
            if (!raw || isNaN(raw)) return 0;
            if (wrapper.dataset.priceUnit === 'cents') return Math.max(0, Math.round(raw));
            // Backward compatibility for rows created by an older cached copy
            // of theme.js, which stored dollar values in data-price-cents.
            return raw < 1000 ? Math.round(raw * 100) : Math.round(raw);
        }

        function activeBasePriceCents() {
            var dollars = (window.Kinsora && window.Kinsora.activeVariantPrice || window.kinsoraActiveVariantPrice)
                || (variants.length > 0 ? variants[0].price : 0);
            return Math.max(0, Math.round(Number(dollars || 0) * 100));
        }

        function selectionPricingContext(mode) {
            var items = [];
            if (mode === 'necklace') {
                var basePrice = activeBasePriceCents();
                if (basePrice > 0) items.push({ wrapper: null, price: basePrice, isBase: true });
                document.querySelectorAll('#necklacePendantItems .dropdown-wrapper:not(.dropdown-wrapper--empty)').forEach(function(wrapper) {
                    var price = wrapperPriceCents(wrapper);
                    if (price > 0) items.push({ wrapper: wrapper, price: price, isBase: false });
                });
            } else {
                document.querySelectorAll('#buildStackMode .dropdown-wrapper:not(.dropdown-wrapper--empty)').forEach(function(wrapper) {
                    var price = wrapperPriceCents(wrapper);
                    if (price > 0) items.push({ wrapper: wrapper, price: price, isBase: wrapper.dataset.baseLocked === 'true' });
                });
            }

            var prices = items.map(function(item) { return item.price; });
            var projection = window.Kinsora && window.Kinsora.bogo && window.Kinsora.bogo.projectPrices
                ? window.Kinsora.bogo.projectPrices(prices)
                : (function() {
                    var sorted = prices.slice().sort(function(a, b) { return a - b; });
                    var freeCount = (Math.floor(sorted.length / 3) * 2);
                    var savings = sorted.slice(0, freeCount).reduce(function(total, price) { return total + price; }, 0);
                    var list = sorted.reduce(function(total, price) { return total + price; }, 0);
                    return { payCents: list - savings, incrementalPayCents: list - savings, freeCount: freeCount };
                })();
            var freeIndexes = window.Kinsora && window.Kinsora.bogo && window.Kinsora.bogo.pendingFreeIndexes
                ? window.Kinsora.bogo.pendingFreeIndexes(prices, projection)
                : prices.map(function(price, index) {
                    return prices.map(function(value, itemIndex) { return { price: value, index: itemIndex }; })
                        .sort(function(a, b) { return a.price - b.price; })
                        .slice(0, (Math.floor(prices.length / 3) * 2))
                        .some(function(item) { return item.index === index; });
                });
            return { items: items, prices: prices, projection: projection, freeIndexes: freeIndexes };
        }

        function renderSelectionRowPrices(context) {
            context.items.forEach(function(item, index) {
                if (!item.wrapper) return;
                var pricesEl = item.wrapper.querySelector('.dropdown-prices');
                if (!pricesEl) return;
                pricesEl.textContent = '';
                pricesEl.removeAttribute('aria-label');
                if (context.freeIndexes[index] === true) {
                    var originalEl = document.createElement('span');
                    originalEl.className = 'dropdown-price-original';
                    originalEl.textContent = window.Kinsora.formatMoney(item.price);
                    var freeEl = document.createElement('span');
                    freeEl.className = 'dropdown-price-discounted dropdown-price-free';
                    freeEl.textContent = 'FREE';
                    pricesEl.setAttribute('aria-label', window.Kinsora.formatMoney(item.price) + ', free with Buy 1, Get 1');
                    pricesEl.appendChild(originalEl);
                    pricesEl.appendChild(document.createTextNode(' '));
                    pricesEl.appendChild(freeEl);
                } else {
                    var currentPriceEl = document.createElement('span');
                    currentPriceEl.className = 'dropdown-price-discounted';
                    currentPriceEl.textContent = window.Kinsora.formatMoney(item.price);
                    pricesEl.appendChild(currentPriceEl);
                }
                item.wrapper.dataset.bogoProjectedFree = context.freeIndexes[index] === true ? 'true' : 'false';
            });
        }

        function updatePriceDisplay() {
            // Bundle PDPs render their own price via kinsora-bundle-init.js's
            // updateBundlePriceDisplay() — including the slashed compare price
            // and the "Save N%" badge. If the generic theme.js logic runs here
            // it overwrites the slashed price with the flat bundle product
            // price ($85), nuking the slash + badge. Defer to bundle-init.
            if (window.Kinsora && window.Kinsora.isBundlePDP) {
                if (typeof window.Kinsora.refreshBundlePrice === 'function') {
                    window.Kinsora.refreshBundlePrice();
                }
                return;
            }
            var priceEl = document.querySelector('.product-section .product-price');
            if (!priceEl) return; // PDP not in DOM yet
            var currentEl = priceEl.querySelector('.price-current');
            var compareEl = priceEl.querySelector('.price-compare');
            var saveEl = priceEl.querySelector('.price-save');
            if (!currentEl) return;
            // Create compare and save elements if they don't exist (non-sale products)
            // Compare-at goes BEFORE the current price (slash on the LEFT)
            if (!compareEl) {
                compareEl = document.createElement('span');
                compareEl.className = 'price-compare';
                compareEl.style.display = 'none';
                priceEl.insertBefore(compareEl, currentEl);
            }
            if (!saveEl) {
                saveEl = document.createElement('span');
                saveEl.className = 'price-save';
                saveEl.style.display = 'none';
                priceEl.appendChild(saveEl);
            }

            var context = selectionPricingContext(currentMode);
            var listCents = context.prices.reduce(function(total, price) { return total + price; }, 0);
            // Price only the products selected on this PDP. If completing a
            // pair makes a lower-priced product already in the cart free, do
            // not mislabel the product being viewed as partially discounted.
            var finalCents = context.prices.reduce(function(total, price, index) {
                return total + (context.freeIndexes[index] === true ? 0 : price);
            }, 0);
            var savingsCents = Math.max(0, listCents - finalCents);

            currentEl.textContent = finalCents === 0 && listCents > 0
                ? 'FREE'
                : window.Kinsora.formatMoney(finalCents);
            if (savingsCents > 0) {
                compareEl.textContent = window.Kinsora.formatMoney(listCents);
                compareEl.style.display = 'inline';
                saveEl.textContent = 'YOU SAVE ' + window.Kinsora.formatMoney(savingsCents);
                saveEl.style.display = 'inline';
            } else {
                compareEl.style.display = 'none';
                saveEl.style.display = 'none';
            }
            renderSelectionRowPrices(context);
        }

        // Get all currently selected items of a type across all dropdowns
        function getSelectedItems(type) {
            var selected = [];
            // Pick the container based on what's actually VISIBLE, not on the
            // currentMode JS variable. Bundle PDPs are pre-rendered into the
            // Build a Stack tab via kinsora-bundle-init.js's reframeTabs --
            // there's no tab click, so currentMode never flips off its initial
            // 'necklace' value. Reading display state directly fixes that
            // and matches the user's actual UI.
            var stackEl = document.getElementById('buildStackMode');
            var necklaceEl = document.getElementById('necklaceOnlyMode');
            var container;
            if (stackEl && stackEl.style.display !== 'none') {
                container = stackEl;
            } else if (necklaceEl && necklaceEl.style.display !== 'none') {
                container = necklaceEl;
            } else {
                container = currentMode === 'stack' ? stackEl : necklaceEl;
            }
            if (!container) return selected;
            // Exclude the locked base wrapper — it represents the current PDP product, not a companion choice
            var wrappers = container.querySelectorAll(`.dropdown-wrapper[data-type="${type}"]:not(.dropdown-wrapper--locked)`);
            wrappers.forEach(w => {
                var idx = w.dataset.selected;
                if (idx !== undefined && idx !== '') selected.push(parseInt(idx));
            });
            return selected;
        }

        // Format a product name with bundle pricing — returns a DocumentFragment (safe DOM)
        function formatProductName(name, price, showDiscount) {
            var frag = document.createDocumentFragment();
            var baseName = name.replace(/\s*\(\$\d+\)\s*$/, '');
            frag.appendChild(document.createTextNode(baseName + ' '));
            var priceSpan = document.createElement('span');
            priceSpan.className = 'dropdown-prices';
            var priceEl = document.createElement('span');
            priceEl.className = 'dropdown-price-discounted';
            priceEl.textContent = window.Kinsora.formatMoney(Math.round(price * 100));
            priceSpan.appendChild(priceEl);
            frag.appendChild(priceSpan);
            return frag;
        }
        // Helper: safely replace element content with a DocumentFragment
        function setFormattedName(el, frag) {
            el.innerHTML = '';
            el.appendChild(frag);
        }

        // Refresh all existing dropdown displays to show/hide strikethrough pricing
        function refreshAllDropdownPricing() {
            if (window.KinsoraBundleConfig && window.KinsoraBundleConfig.isBundle) return;
            renderSelectionRowPrices(selectionPricingContext('necklace'));
            renderSelectionRowPrices(selectionPricingContext('stack'));
        }

        // Build the options list with greyed-out already-selected items (safe DOM)
        function renderOptionsList(wrapper) {
            var type = wrapper.dataset.type;
            var options = type === 'necklace' ? getNecklaceOptions() : getPendantOptions();
            var currentSelected = parseInt(wrapper.dataset.selected);
            var allSelected = getSelectedItems(type);

            // Disable the locked base product (current PDP) in secondary dropdowns
            // so the user doesn't accidentally add the exact same product again.
            // BUT — if the base product has multiple variants (e.g., Paperclip Chain
            // in 16" and 20"), allow it because the user might want a different size.
            var baseLocked = document.querySelector('#buildStackMode .dropdown-wrapper--locked[data-type="' + type + '"]');
            var baseHandle = baseLocked && wrapper !== baseLocked ? baseLocked.dataset.baseHandle : null;

            var listEl = wrapper.querySelector('.dropdown-options-list');
            listEl.innerHTML = '';

            // Pre-compute disabled state for each option, then render available
            // options first and disabled options at the BOTTOM so the customer's
            // eye lands on selectable choices first.
            var orderedOptions = [];
            var disabledOptions = [];
            options.forEach(function(opt, i) {
                var sameAsBase = baseHandle && opt.handle === baseHandle;
                var hasMultipleVariants = opt.variants && opt.variants.length > 1;
                var availableVariantCount = (opt.variants && opt.variants.length)
                    ? opt.variants.filter(function (v) { return v.available; }).length
                    : 1;
                var slotsUsingThisProduct = sameAsBase ? 1 : 0;
                allSelected.forEach(function (selIdx) { if (selIdx === i) slotsUsingThisProduct++; });

                var isDisabled;
                var isOutOfStock = availableVariantCount === 0;
                if (i === currentSelected) {
                    isDisabled = false;
                } else if (isOutOfStock) {
                    // Product is entirely sold out (single-variant: that one variant
                    // is unavailable; multi-variant: all variants are unavailable).
                    // Gray it out + push to bottom so the customer's eye lands on
                    // pickable choices first, instead of clicking through and
                    // hitting an out-of-stock error at the cart-add step.
                    isDisabled = true;
                } else if (!hasMultipleVariants) {
                    isDisabled = slotsUsingThisProduct > 0;
                } else {
                    // Multi-variant: disabled only when every available variant is used
                    isDisabled = slotsUsingThisProduct >= availableVariantCount;
                }

                var entry = { opt: opt, i: i, isDisabled: isDisabled, isOutOfStock: isOutOfStock };
                if (isDisabled) disabledOptions.push(entry);
                else orderedOptions.push(entry);
            });
            orderedOptions = orderedOptions.concat(disabledOptions);

            orderedOptions.forEach(function(entry) {
                var opt = entry.opt;
                var i = entry.i;
                var isDisabled = entry.isDisabled;
                var isOutOfStock = entry.isOutOfStock;
                var optionDiv = document.createElement('div');
                optionDiv.className = 'dropdown-option' + (isDisabled ? ' disabled' : '') + (isOutOfStock ? ' dropdown-option--sold-out' : '');
                optionDiv.dataset.index = i;
                if (!isDisabled) {
                    optionDiv.dataset.action = 'select-option';
                    optionDiv.style.cursor = 'pointer';
                }

                var thumbDiv = document.createElement('div');
                thumbDiv.className = 'dropdown-option-thumb';
                setImgContent(thumbDiv, makeImgTag(opt.img, opt.name));

                var infoDiv = document.createElement('div');
                infoDiv.className = 'dropdown-option-info';
                var nameDiv = document.createElement('div');
                nameDiv.className = 'dropdown-option-name';
                nameDiv.appendChild(formatProductName(opt.name, opt.price, true));
                if (isOutOfStock) {
                    var soldOutBadge = document.createElement('span');
                    soldOutBadge.className = 'dropdown-option-sold-out-badge';
                    soldOutBadge.textContent = 'Sold out';
                    // .dropdown-prices is a flex container — append the badge
                    // INSIDE it so the badge sits on the same baseline row,
                    // immediately to the right of the discounted price. If we
                    // appended to nameDiv as a sibling, the flex container's
                    // own line wraps and the badge could end up below.
                    var pricesEl = nameDiv.querySelector('.dropdown-prices');
                    if (pricesEl) {
                        pricesEl.appendChild(soldOutBadge);
                    } else {
                        nameDiv.appendChild(soldOutBadge);
                    }
                }
                var subtitleDiv = document.createElement('div');
                subtitleDiv.className = 'dropdown-option-subtitle';
                subtitleDiv.textContent = opt.subtitle;

                infoDiv.appendChild(nameDiv);
                infoDiv.appendChild(subtitleDiv);
                optionDiv.appendChild(thumbDiv);
                optionDiv.appendChild(infoDiv);
                listEl.appendChild(optionDiv);
            });
        }

        // ===== VARIANT SELECTORS =====
        // Renders inline <select> dropdowns below a product dropdown when it has >1 variant.
        // Explicitly attached to window after definition so kinsora-bundle-init.js can call it
        // on the injected bundle pendant wrapper (which doesn't get the regular init-pass call).
        function renderVariantPills(wrapper) {
            // Remove any existing selectors
            var existing = wrapper.querySelector('.variant-selectors');
            if (existing) existing.remove();

            var type = wrapper.dataset.type;
            var options = type === 'necklace' ? getNecklaceOptions() : getPendantOptions();
            var isLockedBase = wrapper.dataset.baseLocked === 'true';
            var product;

            if (isLockedBase && wrapper.dataset.baseHandle) {
                // Locked base = current PDP product. Look up by handle so we use the
                // ACTUAL product's variants (not options[0] which is just the first
                // product in the collection — that was the bug showing wrong sizes).
                product = options.find(function (o) { return o.handle === wrapper.dataset.baseHandle; });
            } else {
                var index = parseInt(wrapper.dataset.selected);
                product = options[index];
            }

            // FALLBACK for locked-base wrappers: if the current PDP product isn't
            // in its companion collection (e.g. a pendant PDP where the pendant
            // isn't a member of the "pendants" collection block), synthesize the
            // product from window.Kinsora.variants + .optionNames. Without this
            // fallback the locked base would render with no Metal / Length pills.
            if ((!product || !product.variants || product.variants.length === 0)
                && isLockedBase
                && window.Kinsora
                && Array.isArray(window.Kinsora.variants)
                && window.Kinsora.variants.length > 0) {
                product = {
                    handle:   wrapper.dataset.baseHandle,
                    variants: window.Kinsora.variants.slice(),
                    optionNames: (window.Kinsora.optionNames || []).map(function (o) {
                        return (o && o.name) ? o.name : o;
                    })
                };
            }

            if (!product || !product.variants || product.variants.length === 0) return;

            // For non-locked wrappers, collect variant IDs already used in OTHER slots
            // that share this product handle (locked base + other secondary rows +
            // any companion rows in necklace-only mode). Pick a defaultVariant that's
            // not in that used-set, so a customer adding a second Paperclip Chain row
            // gets the OTHER length automatically.
            //
            // Span BOTH #buildStackMode and #necklaceOnlyMode -- on bracelet (and
            // pendant) PDPs the in-tab "Add Necklace" picker lives inside
            // #necklaceOnlyMode → #necklacePendantItems. Limiting to #buildStackMode
            // missed those, so adding a multi-variant chain twice in bracelet-only
            // mode produced two of the same variant.
            var defaultVariant = product.variants[0];
            var usedVariantIds = [];
            if (!isLockedBase) {
                var allWrappers = document.querySelectorAll(
                    '#buildStackMode .dropdown-wrapper[data-type="' + type + '"], ' +
                    '#necklaceOnlyMode .dropdown-wrapper[data-type="' + type + '"]'
                );
                allWrappers.forEach(function (other) {
                    if (other === wrapper) return;
                    var otherHandle;
                    if (other.dataset.baseLocked === 'true') {
                        otherHandle = other.dataset.baseHandle;
                    } else {
                        var oi = parseInt(other.dataset.selected);
                        var oo = options[oi];
                        otherHandle = oo ? oo.handle : null;
                    }
                    if (otherHandle === product.handle) {
                        var vid = parseInt(other.dataset.variantId);
                        if (vid && !isNaN(vid)) usedVariantIds.push(vid);
                    }
                });
                if (usedVariantIds.length > 0) {
                    var altVariant = product.variants.find(function (v) {
                        return usedVariantIds.indexOf(v.id) === -1 && v.available;
                    });
                    if (altVariant) defaultVariant = altVariant;
                }
            }

            var container = document.createElement('div');
            container.className = 'variant-selectors';

            var optNames = product.optionNames || [];
            optNames.forEach(function(optName, optIdx) {
                // Get unique values for this option
                var seen = {};
                var values = [];
                product.variants.forEach(function(v) {
                    var val = v.options[optIdx];
                    if (val && !seen[val]) {
                        seen[val] = true;
                        values.push(val);
                    }
                });

                // Skip Shopify's default placeholder option (products with no real variants
                // still expose options: ["Title"] and variant option value "Default Title")
                if (values.length === 0) return;
                if (values.length === 1 && values[0] === 'Default Title') return;

                var row = document.createElement('div');
                row.className = 'variant-select-row';

                var label = document.createElement('label');
                label.className = 'variant-select-label';
                label.textContent = optName;
                row.appendChild(label);

                if (values.length === 1) {
                    // Single-value option — render as read-only display so the customer
                    // can still see what they're getting (Metal: 18k Gold, Length: 20", etc.)
                    var readonly = document.createElement('div');
                    readonly.className = 'variant-readonly';
                    readonly.textContent = values[0];
                    row.appendChild(readonly);
                } else {
                    // Multi-value option — render as a real select dropdown
                    var selectWrap = document.createElement('div');
                    selectWrap.className = 'variant-select-wrap';

                    var select = document.createElement('select');
                    select.className = 'variant-select';
                    select.dataset.optionIndex = optIdx;
                    select.dataset.action = 'change-variant';

                    values.forEach(function(val) {
                        var option = document.createElement('option');
                        option.value = val;
                        option.textContent = val;

                        // Pre-select the value matching the chosen default variant
                        // (handles both "first available" and "different from base" cases)
                        if (defaultVariant && val === defaultVariant.options[optIdx]) {
                            option.selected = true;
                        }

                        // Availability check
                        var hasAvailable = product.variants.some(function(v) {
                            return v.options[optIdx] === val && v.available;
                        });
                        if (!hasAvailable) {
                            option.textContent = val + ' (Sold out)';
                            option.disabled = true;
                        }

                        // Mark every variant already used in another slot (locked
                        // base + any other secondary/companion rows for the same
                        // product) so the customer can't pick a duplicate. We
                        // disable per option-value: if every variant carrying
                        // this value is already taken, the value is grayed out.
                        if (usedVariantIds.length > 0) {
                            var usedThisVal = product.variants
                                .filter(function (v) { return v.options[optIdx] === val; })
                                .every(function (v) { return usedVariantIds.indexOf(v.id) !== -1; });
                            if (usedThisVal) {
                                option.textContent = val + ' (already added)';
                                option.disabled = true;
                            }
                        }

                        select.appendChild(option);
                    });

                    selectWrap.appendChild(select);
                    row.appendChild(selectWrap);
                }

                container.appendChild(row);
            });

            if (container.children.length === 0) {
                // No multi-variant rows — still set the variantId so add-to-cart works
                wrapper.dataset.variantId = defaultVariant.id;
                return;
            }

            wrapper.dataset.variantId = defaultVariant.id;
            wrapper.appendChild(container);
        }
        // Explicit window attachment so kinsora-bundle-init.js can reliably
        // call this on the injected bundle pendant wrapper. (In a defer'd
        // classic script, top-level function declarations SHOULD be on window
        // automatically, but a few combinations of Shopify's script handling
        // + browser quirks have made the implicit attachment unreliable in
        // practice — making it explicit is cheap insurance.)
        window.renderVariantPills = renderVariantPills;

        // Handle variant <select> change
        function onVariantSelectChange(selectEl) {
            var wrapper = safeClosest(selectEl, '.dropdown-wrapper');
            if (!wrapper) return;

            var type = wrapper.dataset.type;
            var options = type === 'necklace' ? getNecklaceOptions() : getPendantOptions();
            var product;
            // For the locked base, look up the actual PDP product by handle
            // (data-selected may be stale or "0", and we want the real product)
            if (wrapper.dataset.baseLocked === 'true' && wrapper.dataset.baseHandle) {
                product = options.find(function (o) { return o.handle === wrapper.dataset.baseHandle; });
            } else {
                var productIndex = parseInt(wrapper.dataset.selected);
                product = options[productIndex];
            }
            if (!product || !product.variants) return;

            // Collect selected values from all selects in this wrapper
            var selectedOptions = [];
            var container = wrapper.querySelector('.variant-selectors');
            if (!container) return;
            container.querySelectorAll('.variant-select').forEach(function(sel) {
                selectedOptions.push({
                    index: parseInt(sel.dataset.optionIndex),
                    value: sel.value
                });
            });

            // Find the matching variant
            var matchedVariant = null;
            for (var i = 0; i < product.variants.length; i++) {
                var v = product.variants[i];
                var match = true;
                for (var j = 0; j < selectedOptions.length; j++) {
                    if (v.options[selectedOptions[j].index] !== selectedOptions[j].value) {
                        match = false;
                        break;
                    }
                }
                if (match) { matchedVariant = v; break; }
            }

            if (matchedVariant) {
                wrapper.dataset.variantId = matchedVariant.id;
                wrapper.dataset.priceCents = Math.round(matchedVariant.price * 100);
                wrapper.dataset.priceUnit = 'cents';

                // Sync the page's hidden variantIdInput when the LOCKED BASE's variant
                // changes, so the Build-a-Stack ATC picks up the new variant and the
                // Tab 1 swatches stay in sync with what the customer chose here.
                if (wrapper.dataset.baseLocked === 'true') {
                    var hiddenVariantInput = document.getElementById('variantIdInput');
                    if (hiddenVariantInput) hiddenVariantInput.value = matchedVariant.id;
                    if (window.Kinsora) window.Kinsora.activeVariantPrice = matchedVariant.price;
                }

                // Update price if variant price differs
                if (matchedVariant.price !== product.price) {
                    var nameEl = wrapper.querySelector('.product-dropdown-name');
                    if (nameEl) {
                        setFormattedName(nameEl, formatProductName(product.name, matchedVariant.price, true));
                    }
                }

                // Update image if variant has one
                if (matchedVariant.img) {
                    var thumbEl = wrapper.querySelector('.product-dropdown-thumb');
                    if (thumbEl) setImgContent(thumbEl, makeImgTag(matchedVariant.img, product.name));
                }

                // Re-render variant pills on every OTHER slot for the same product
                // so their disabled states + auto-pick reflect this new selection.
                // Without this, two slots of the same multi-variant product could
                // both manually drift onto the same variant (creating a duplicate
                // line item on add-to-cart).
                var siblingSelector =
                    '#buildStackMode .dropdown-wrapper[data-type="' + type + '"], ' +
                    '#necklaceOnlyMode .dropdown-wrapper[data-type="' + type + '"]';
                document.querySelectorAll(siblingSelector).forEach(function (other) {
                    if (other === wrapper) return;
                    if (other.dataset.baseLocked === 'true') return;
                    var oi = parseInt(other.dataset.selected);
                    if (isNaN(oi) || !options[oi]) return;
                    if (options[oi].handle !== product.handle) return;
                    if (typeof renderVariantPills === 'function') renderVariantPills(other);
                });

                updatePriceDisplay();
            }
        }

        function toggleDropdown(wrapper) {
            var wasOpen = wrapper.classList.contains('open');
            var btn = wrapper.querySelector('.product-dropdown');

            // Close all dropdowns first
            closeAllDropdowns();

            if (!wasOpen) {
                renderOptionsList(wrapper);
                wrapper.classList.add('open');
                btn.classList.add('dropdown-open');
                if (btn.setAttribute) btn.setAttribute('aria-expanded', 'true');
            }
        }

        function selectOption(optionEl) {
            if (window.event) window.event.stopPropagation();
            var wrapper = optionEl.closest('.dropdown-wrapper');
            var type = wrapper.dataset.type;
            var index = parseInt(optionEl.dataset.index);

            // Prevent selecting a product already chosen in another dropdown
            var allSelected = getSelectedItems(type);
            var currentSelected = parseInt(wrapper.dataset.selected);
            if (allSelected.includes(index) && index !== currentSelected) return;

            var options = type === 'necklace' ? getNecklaceOptions() : getPendantOptions();
            var opt = options[index];

            // Block selection when the product is fully consumed across all slots
            // (matches renderOptionsList's disabled-rendering rule):
            //   single-variant + already used anywhere → block
            //   multi-variant + every variant already in some slot → block
            var baseLocked = document.querySelector('#buildStackMode .dropdown-wrapper--locked[data-type="' + type + '"]');
            var sameAsBase = baseLocked && wrapper !== baseLocked && baseLocked.dataset.baseHandle === opt.handle;
            var hasMultipleVariants = opt.variants && opt.variants.length > 1;
            var availableVariantCount = (opt.variants && opt.variants.length)
                ? opt.variants.filter(function (v) { return v.available; }).length
                : 1;
            var slotsUsingThisProduct = sameAsBase ? 1 : 0;
            allSelected.forEach(function (selIdx) { if (selIdx === index) slotsUsingThisProduct++; });
            // Block if the product is entirely sold out (defends against any
            // path that surfaces a sold-out option past the renderOptionsList
            // gray-out, e.g. an old cached DOM).
            if (availableVariantCount === 0 && index !== currentSelected) return;
            if (!hasMultipleVariants && slotsUsingThisProduct > 0 && index !== currentSelected) return;
            if (hasMultipleVariants && slotsUsingThisProduct >= availableVariantCount && index !== currentSelected) return;

            // Update the selected display (safe DOM)
            var dropdown = wrapper.querySelector('.product-dropdown');
            var thumbEl = dropdown.querySelector('.product-dropdown-thumb');
            setImgContent(thumbEl, makeImgTag(opt.img, opt.name));
            setFormattedName(dropdown.querySelector('.product-dropdown-name'), formatProductName(opt.name, opt.price, true));
            dropdown.querySelector('.product-dropdown-subtitle').textContent = opt.subtitle;
            wrapper.dataset.selected = index;
            wrapper.dataset.priceCents = Math.round(opt.price * 100);
            wrapper.dataset.priceUnit = 'cents';

            // Set default variant ID (first variant or only variant)
            if (opt.variants && opt.variants.length > 0) {
                wrapper.dataset.variantId = opt.variants[0].id;
            } else {
                wrapper.dataset.variantId = opt.variantId;
            }

            closeAllDropdowns();

            // Render variant pills if product has multiple variants
            renderVariantPills(wrapper);

            updatePriceDisplay();
            refreshAddButtons();
        }

        function closeAllDropdowns() {
            document.querySelectorAll('.dropdown-wrapper.open').forEach(function(w) {
                w.classList.remove('open');
                var btn = w.querySelector('.product-dropdown');
                btn.classList.remove('dropdown-open');
                if (btn.setAttribute) btn.setAttribute('aria-expanded', 'false');
            });
        }

        // Close dropdowns when clicking outside
        document.addEventListener('click', function(e) {
            if (!safeClosest(e.target, '.dropdown-wrapper')) {
                closeAllDropdowns();
            }
        });

        function createDropdownRow(type) {
            var options = type === 'necklace' ? getNecklaceOptions() : getPendantOptions();
            // Find the first non-selected option
            var allSelected = getSelectedItems(type);

            // Also skip the locked base product (current PDP) — unless it's a
            // multi-variant product, in which case we'll allow it (different size).
            var baseLocked = document.querySelector('#buildStackMode .dropdown-wrapper--locked[data-type="' + type + '"]');
            var baseHandle = baseLocked ? baseLocked.dataset.baseHandle : null;

            // Pick a default that isn't fully consumed yet.
            // A product is "fully consumed" when every available variant has been
            // taken by some slot (base + selected secondaries combined).
            function _slotsUsing(opt, i) {
                var same = baseHandle && opt.handle === baseHandle;
                var slots = same ? 1 : 0;
                allSelected.forEach(function (selIdx) { if (selIdx === i) slots++; });
                return slots;
            }
            function _avail(opt) {
                if (!opt.variants || !opt.variants.length) return 1;
                return opt.variants.filter(function (v) { return v.available; }).length;
            }
            var defaultIndex = -1;
            for (var i = 0; i < options.length; i++) {
                var opt = options[i];
                var multi = opt.variants && opt.variants.length > 1;
                var slots = _slotsUsing(opt, i);
                var avail = _avail(opt);
                if (!multi && slots > 0) continue;       // single-variant already used
                if (multi && slots >= avail) continue;   // multi-variant fully taken
                defaultIndex = i;
                break;
            }
            // Final fallback: anything not already selected
            if (defaultIndex === -1) {
                for (var j = 0; j < options.length; j++) {
                    if (!allSelected.includes(j)) { defaultIndex = j; break; }
                }
            }
            if (defaultIndex === -1) return null; // All options taken

            var defaultOpt = options[defaultIndex];

            var row = document.createElement('div');
            row.className = 'form-row';
            row.style.opacity = '0';
            row.style.transform = 'translateY(-8px)';

            // Build dropdown wrapper (safe DOM — no innerHTML with user data)
            var wrapperDiv = document.createElement('div');
            wrapperDiv.className = 'dropdown-wrapper';
            wrapperDiv.dataset.type = type;
            wrapperDiv.dataset.selected = defaultIndex;
            wrapperDiv.dataset.priceCents = Math.round(defaultOpt.price * 100);
            wrapperDiv.dataset.priceUnit = 'cents';
            wrapperDiv.style.flex = '1';

            var dropdownDiv = document.createElement('div');
            dropdownDiv.className = 'product-dropdown';
            dropdownDiv.dataset.action = 'toggle-dropdown';

            var thumbDiv = document.createElement('div');
            thumbDiv.className = 'product-dropdown-thumb';
            setImgContent(thumbDiv, makeImgTag(defaultOpt.img, defaultOpt.name));

            var contentDiv = document.createElement('div');
            contentDiv.className = 'product-dropdown-content';
            var nameDiv = document.createElement('div');
            nameDiv.className = 'product-dropdown-name';
            nameDiv.appendChild(formatProductName(defaultOpt.name, defaultOpt.price, true));
            var subtitleDiv = document.createElement('div');
            subtitleDiv.className = 'product-dropdown-subtitle';
            subtitleDiv.textContent = defaultOpt.subtitle;
            contentDiv.appendChild(nameDiv);
            contentDiv.appendChild(subtitleDiv);

            dropdownDiv.appendChild(thumbDiv);
            dropdownDiv.appendChild(contentDiv);
            // Chevron SVG (static markup — no user data)
            var chevronNS = 'http://www.w3.org/2000/svg';
            var chevronSvg = document.createElementNS(chevronNS, 'svg');
            chevronSvg.setAttribute('class', 'dropdown-chevron');
            chevronSvg.setAttribute('style', 'width:24px;height:24px;stroke:currentColor;');
            chevronSvg.setAttribute('viewBox', '0 0 24 24');
            chevronSvg.setAttribute('fill', 'none');
            chevronSvg.setAttribute('stroke-width', '1.5');
            var chevronPath = document.createElementNS(chevronNS, 'path');
            chevronPath.setAttribute('d', 'M6 9l6 6 6-6');
            chevronPath.setAttribute('stroke-linecap', 'round');
            chevronPath.setAttribute('stroke-linejoin', 'round');
            chevronSvg.appendChild(chevronPath);
            dropdownDiv.appendChild(chevronSvg);

            var optionsList = document.createElement('div');
            optionsList.className = 'dropdown-options-list';

            wrapperDiv.appendChild(dropdownDiv);
            wrapperDiv.appendChild(optionsList);

            // Set initial variant ID
            if (defaultOpt.variants && defaultOpt.variants.length > 0) {
                wrapperDiv.dataset.variantId = defaultOpt.variants[0].id;
            } else {
                wrapperDiv.dataset.variantId = defaultOpt.variantId;
            }

            // Render variant pills if product has multiple variants
            renderVariantPills(wrapperDiv);

            var deleteBtn = document.createElement('button');
            deleteBtn.className = 'delete-btn';
            deleteBtn.dataset.action = 'remove-dropdown-row';
            // Delete SVG (static markup — no user data)
            deleteBtn.innerHTML = '<svg class="delete-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M3 6h18M8 6V4a2 2 0 012-2h4a2 2 0 012 2v2m3 0v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6h12zM10 11v6M14 11v6"/></svg>';

            row.appendChild(wrapperDiv);
            row.appendChild(deleteBtn);
            requestAnimationFrame(() => {
                row.style.transition = 'all 0.2s ease';
                row.style.opacity = '1';
                row.style.transform = 'translateY(0)';
            });
            return row;
        }

        function removeDropdownRow(btn) {
            if (window.event) window.event.stopPropagation();
            var row = btn.closest('.form-row');
            // Remember what product handle this row was holding so we can
            // refresh sibling slots after the remove — freeing whichever
            // variant this row was using so the picker un-disables it.
            var removedWrapper = row && row.querySelector('.dropdown-wrapper');
            var removedType = removedWrapper && removedWrapper.dataset.type;
            var removedHandle = null;
            if (removedWrapper && removedType) {
                var rOpts = removedType === 'necklace' ? getNecklaceOptions() : getPendantOptions();
                var rIdx = parseInt(removedWrapper.dataset.selected);
                if (!isNaN(rIdx) && rOpts[rIdx]) removedHandle = rOpts[rIdx].handle;
            }
            row.style.opacity = '0';
            row.style.transform = 'translateY(-8px)';
            row.style.transition = 'all 0.2s ease';
            setTimeout(() => {
                row.remove();
                // Refresh remaining slots of the same product so the freed
                // variant becomes pickable again in their dropdowns.
                if (removedHandle && removedType && typeof renderVariantPills === 'function') {
                    var refreshSelector =
                        '#buildStackMode .dropdown-wrapper[data-type="' + removedType + '"], ' +
                        '#necklaceOnlyMode .dropdown-wrapper[data-type="' + removedType + '"]';
                    var rOpts2 = removedType === 'necklace' ? getNecklaceOptions() : getPendantOptions();
                    document.querySelectorAll(refreshSelector).forEach(function (other) {
                        if (other.dataset.baseLocked === 'true') return;
                        var oi2 = parseInt(other.dataset.selected);
                        if (isNaN(oi2) || !rOpts2[oi2]) return;
                        if (rOpts2[oi2].handle !== removedHandle) return;
                        renderVariantPills(other);
                    });
                }
                updatePriceDisplay();
                refreshAddButtons();
            }, 200);
        }

        // Stack cap settings — exposed to the theme editor so merchants can
        // tighten the stack-builder maximums per product page. Falls back to
        // sensible defaults (5 pendants / 6 secondary necklaces) if the
        // Liquid injection isn't present (older PDPs, stack-only template).
        var MAX_PENDANTS = (window.Kinsora && Number(window.Kinsora.maxPendants))            || 5;
        var MAX_SECONDARY_NECKLACES = (window.Kinsora && Number(window.Kinsora.maxNecklaces)) || 6;

        // Hide add-buttons when all products are selected, show when slots free up
        function refreshAddButtons() {
            var pendantOptions = getPendantOptions();
            var necklaceOptions = getNecklaceOptions();
            var pendantSelected = getSelectedItems('pendant');
            var necklaceSelected = getSelectedItems('necklace');

            // Count "fully consumed" products: a single-variant product is
            // consumed when one slot uses it; a multi-variant product is
            // consumed when every available variant is taken. This matches
            // createDropdownRow's pick logic so the Add button is visible
            // exactly when createDropdownRow would still be able to find a
            // pickable option. The previous math subtracted raw wrapper
            // count from product count, so adding the same multi-variant
            // chain in two different lengths counted as 2 against the
            // products total -- hiding Add Necklace early when a
            // single-variant chain like Pearl was still pickable.
            function _consumedCount(options, selected) {
                var consumed = 0;
                for (var i = 0; i < options.length; i++) {
                    var opt = options[i];
                    var availVariants = (opt && opt.variants && opt.variants.length)
                        ? opt.variants.filter(function (v) { return v.available; }).length
                        : 1;
                    if (availVariants <= 0) { consumed++; continue; } // entirely sold out
                    var slotsUsing = 0;
                    for (var s = 0; s < selected.length; s++) {
                        if (selected[s] === i) slotsUsing++;
                    }
                    if (slotsUsing >= availVariants) consumed++;
                }
                return consumed;
            }
            var pendantSlotsLeft = pendantOptions.length - _consumedCount(pendantOptions, pendantSelected);
            var necklaceSlotsLeft = necklaceOptions.length - _consumedCount(necklaceOptions, necklaceSelected);

            // OPEN-BASE GATING (stack-only template's "Build Your Stack" mode):
            // an empty base wrapper exists if the section was rendered with
            // open_base_picker on AND the customer hasn't picked yet. While
            // that's true, the upsell buttons + ATC are disabled so the
            // customer has to pick a base first.
            var emptyBase = document.querySelector('#buildStackMode .dropdown-wrapper--empty[data-type="necklace"]');
            var baseNotPicked = !!(emptyBase && (emptyBase.dataset.selected === undefined || emptyBase.dataset.selected === ''));

            var btn1 = document.getElementById('addPendantNecklaceBtn');
            if (btn1) {
                var btn1Companion = btn1.getAttribute('data-companion-type') || 'pendant';
                var slotsLeftForBtn1 = btn1Companion === 'necklace' ? necklaceSlotsLeft : pendantSlotsLeft;
                btn1.style.display = slotsLeftForBtn1 <= 0 ? 'none' : '';
            }

            var btn2 = document.getElementById('addPendantStackBtn');
            if (btn2) {
                btn2.style.display = pendantSlotsLeft <= 0 ? 'none' : '';
                btn2.disabled = baseNotPicked;
                btn2.classList.toggle('add-btn--disabled', baseNotPicked);
            }

            var btn3 = document.getElementById('addSecondaryNecklaceBtn');
            if (btn3) {
                btn3.style.display = necklaceSlotsLeft <= 0 ? 'none' : '';
                btn3.disabled = baseNotPicked;
                btn3.classList.toggle('add-btn--disabled', baseNotPicked);
            }

            // Gate the ATC button too. Use a "data-needs-base" attribute that
            // we can also use as a CSS hook if we want to style it differently.
            var atcBtn = document.querySelector('.add-to-cart[data-action="add-to-cart"]');
            if (atcBtn) {
                if (baseNotPicked) {
                    atcBtn.disabled = true;
                    atcBtn.setAttribute('data-needs-base', 'true');
                } else {
                    atcBtn.disabled = false;
                    atcBtn.removeAttribute('data-needs-base');
                }
                if (!baseNotPicked && currentMode === 'stack' && !isBundlePDP) {
                    var selectedTotal = 0;
                    document.querySelectorAll('#buildStackMode .dropdown-wrapper[data-type]').forEach(function(wrapper) {
                        if (wrapper.dataset.baseLocked === 'true' || wrapper.dataset.variantId) selectedTotal += 1;
                    });
                    atcBtn.textContent = atcBtn.dataset.addText || 'Add To Cart';
                }
            }

            // Pre-pick price block: keep .product-price--awaiting-pick on the
            // headline price container while the customer hasn't picked a
            // base. CSS hides the price spans + shows the "Build your stack
            // to see your total" placeholder. Once picked, removing the
            // modifier reveals the real (live-updated) price + slash + Save
            // badge that updatePriceDisplay populated.
            var priceBlock = document.querySelector('.product-section .product-price[data-open-base="true"]');
            if (priceBlock) {
                priceBlock.classList.toggle('product-price--awaiting-pick', baseNotPicked);
            }
            // Build a Stack: keep the installments wrapper hidden until a
            // base is picked. CSS hides .product-payment-terms--hidden;
            // the Shopify widget inside continues running normally.
            var stackInstallments = document.querySelector('[data-product-payment-terms]');
            if (stackInstallments) {
                stackInstallments.classList.toggle('product-payment-terms--hidden', baseNotPicked);
            }
        }

        // Auto-open the dropdown in a newly added row after the entrance animation, then scroll it into view
        function autoOpenNewRow(row) {
            var wrapper = row.querySelector('.dropdown-wrapper');
            if (wrapper) {
                setTimeout(function() {
                    toggleDropdown(wrapper);
                    setTimeout(function() {
                        var rect = wrapper.getBoundingClientRect();
                        var stickyOffset = 120;
                        var targetY = window.scrollY + rect.top - stickyOffset;
                        window.scrollTo({ top: Math.max(targetY, 0), behavior: 'smooth' });
                    }, 80);
                }, 250);
            }
        }

        function addPendantNecklaceMode() {
            var container = document.getElementById('necklacePendantItems');
            if (!container) return;
            // Companion type comes from the section setting (pendant by default; necklace when primary is pendant)
            var companionType = container.getAttribute('data-companion-type') || 'pendant';
            var maxSlots = companionType === 'necklace' ? MAX_SECONDARY_NECKLACES : MAX_PENDANTS;
            if (container.querySelectorAll('.dropdown-wrapper').length >= maxSlots) return;
            var newRow = createDropdownRow(companionType);
            if (!newRow) return;
            container.appendChild(newRow);
            updatePriceDisplay();
            refreshAddButtons();
            autoOpenNewRow(newRow);
        }

        function addPendantStackMode() {
            var container = document.getElementById('pendantItems');
            if (container.querySelectorAll('.dropdown-wrapper').length >= MAX_PENDANTS) return;
            var newRow = createDropdownRow('pendant');
            if (!newRow) return;
            container.appendChild(newRow);
            updatePriceDisplay();
            refreshAddButtons();
            autoOpenNewRow(newRow);
        }

        function addSecondaryNecklace() {
            var container = document.getElementById('secondaryNecklaceItems');
            if (container.querySelectorAll('.dropdown-wrapper').length >= MAX_SECONDARY_NECKLACES) return;
            var newRow = createDropdownRow('necklace');
            if (!newRow) return;
            container.appendChild(newRow);
            updatePriceDisplay();
            refreshAddButtons();
            autoOpenNewRow(newRow);
        }

        function toggleAccordion(header) {
            var content = header.nextElementSibling;
            if (!content) return;
            var expanded = header.classList.toggle('expanded');
            content.classList.toggle('expanded', expanded);
            if (header.hasAttribute('aria-expanded')) {
                header.setAttribute('aria-expanded', String(expanded));
                content.setAttribute('aria-hidden', String(!expanded));
                content.inert = !expanded;
            }
            if (content.hasAttribute('data-seo-set-content')) {
                content.style.maxHeight = expanded ? content.scrollHeight + 'px' : '0px';
            }
        }

        function resizeSetDetails() {
            document.querySelectorAll('[data-seo-set-content].expanded').forEach(function(content) {
                content.style.maxHeight = content.scrollHeight + 'px';
            });
        }

        document.addEventListener('kinsora:pdp-selection-changed', function(event) {
            var section = event.target.closest('.shopify-section');
            var details = section && section.querySelector('[data-seo-set-details]');
            if (!details || !event.detail || !event.detail.variantId) return;
            var found = false;
            details.querySelectorAll('[data-seo-set-list]').forEach(function(list) {
                var selected = list.getAttribute('data-variant-id') === String(event.detail.variantId);
                list.hidden = !selected;
                if (selected) found = true;
            });
            details.hidden = !found;
            resizeSetDetails();
        });
        window.addEventListener('resize', resizeSetDetails, { passive: true });

        // ── Announcement bar (native scroll-snap carousel with infinite loop) ──
        // Liquid renders [pre_0..pre_{N-1}, real_0..real_{N-1}, post_0..post_{N-1}].
        // Initial scrollLeft is set to N*w so real_0 is what's shown on load.
        // - Forward swipe past real_{N-1} into the post-clones → silent jump back by N.
        // - Backward swipe past real_0 into the pre-clones → silent jump forward by N.
        // Native browser scroll handles touch swipe — no custom touch handlers needed.
        var _abPaused = false;
        var _abWrapping = false;
        window.announcementTimer = null;

        function _abTrack() {
            return document.getElementById('announcementSlides');
        }

        function _abOriginalCount() {
            var t = _abTrack();
            if (!t) return 0;
            var n = parseInt(t.getAttribute('data-count'), 10);
            return isNaN(n) ? 0 : n;
        }

        function _abSlideWidth() {
            var t = _abTrack();
            return t ? t.clientWidth : 0;
        }

        function _abCurrentIndex() {
            var t = _abTrack();
            var w = _abSlideWidth();
            if (!t || w === 0) return 0;
            return Math.round(t.scrollLeft / w);
        }

        function rotateAnnouncement(direction) {
            var t = _abTrack();
            if (!t || _abWrapping) return;
            var N = _abOriginalCount();
            if (N < 2) return;
            var w = _abSlideWidth();
            if (w === 0) return;

            // With pre-clones, real slides live at indices N..2N-1. Just
            // smooth-scroll by one slot in either direction — the scroll
            // listener below handles the silent wrap when we cross into
            // pre-clones (< N) or post-clones (>= 2N).
            var current = _abCurrentIndex();
            var target = current + direction;
            t.scrollTo({ left: target * w, behavior: 'smooth' });
        }

        function resetAnnouncementTimer() {
            if (window.announcementTimer) clearInterval(window.announcementTimer);
            if (_abPaused) return;
            var t = _abTrack();
            if (!t || _abOriginalCount() < 2) return;
            var speed = parseInt(t.getAttribute('data-speed'), 10) * 1000 || 5000;
            window.announcementTimer = setInterval(function () {
                if (!_abPaused) rotateAnnouncement(1);
            }, speed);
        }

        // resetAnnouncementTimer is declared at global scope above, so it's already
        // accessible as window.resetAnnouncementTimer for cross-script use
        // (e.g. kinsora-stack-discounts.js restore). Do NOT wrap it — assigning a
        // wrapper to window.resetAnnouncementTimer would alias the global name and
        // cause infinite recursion when the wrapper calls resetAnnouncementTimer().


        document.addEventListener('DOMContentLoaded', function() {
            var slides = document.getElementById('announcementSlides');
            if (slides && _abOriginalCount() > 1) {
                // Park the carousel on the first real slide (index N) so
                // there's a clone set of width N*w to the LEFT for backward
                // swipe, and another to the right for forward swipe.
                var _setInitialPos = function () {
                    var N = _abOriginalCount();
                    var w = _abSlideWidth();
                    if (N < 2 || w === 0) return;
                    slides.style.scrollBehavior = 'auto';
                    slides.scrollLeft = N * w;
                    requestAnimationFrame(function () {
                        slides.style.scrollBehavior = '';
                    });
                };
                _setInitialPos();
                // Re-anchor on resize because w changes.
                window.addEventListener('resize', function () {
                    if (_abWrapping) return;
                    var N = _abOriginalCount();
                    var w = _abSlideWidth();
                    if (N < 2 || w === 0) return;
                    var current = _abCurrentIndex();
                    // Keep the same visible real slide centered after resize.
                    var realIndex = ((current - N) % N + N) % N;
                    _abWrapping = true;
                    slides.style.scrollBehavior = 'auto';
                    slides.scrollLeft = (N + realIndex) * w;
                    requestAnimationFrame(function () {
                        slides.style.scrollBehavior = '';
                        _abWrapping = false;
                    });
                });

                // Native scroll-snap handles touch swipe automatically — no custom handlers needed.
                resetAnnouncementTimer();
                // Pause the rotation timer while the tab is hidden — no need to
                // wake the main thread rotating a carousel nobody can see.
                document.addEventListener('visibilitychange', function() {
                    if (document.hidden) {
                        if (window.announcementTimer) clearInterval(window.announcementTimer);
                    } else {
                        resetAnnouncementTimer();
                    }
                });
                var abBar = slides.closest('.announcement-bar');

                // Silent-wrap whenever the user scrolls into either clone
                // set (pre-clones at [0..N-1] or post-clones at [2N..3N-1]).
                var _abScrollDebounce = null;
                slides.addEventListener('scroll', function () {
                    if (_abWrapping) return;
                    clearTimeout(_abScrollDebounce);
                    _abScrollDebounce = setTimeout(function () {
                        var N = _abOriginalCount();
                        var w = _abSlideWidth();
                        if (N < 2 || w === 0) return;
                        var current = _abCurrentIndex();
                        var jumpTo = null;
                        if (current >= 2 * N) {
                            // Forward into post-clones → jump back N slides.
                            jumpTo = current - N;
                        } else if (current < N) {
                            // Backward into pre-clones → jump forward N slides.
                            jumpTo = current + N;
                        }
                        if (jumpTo !== null) {
                            _abWrapping = true;
                            slides.style.scrollBehavior = 'auto';
                            slides.scrollLeft = jumpTo * w;
                            requestAnimationFrame(function () {
                                slides.style.scrollBehavior = '';
                                _abWrapping = false;
                            });
                        }
                    }, 180);
                }, { passive: true });

                // Pause on hover (WCAG 2.2.2)
                abBar.addEventListener('mouseenter', function() {
                    _abPaused = true;
                    if (window.announcementTimer) clearInterval(window.announcementTimer);
                });
                abBar.addEventListener('mouseleave', function() {
                    _abPaused = false;
                    resetAnnouncementTimer();
                });

                // Pause on focus within (keyboard users)
                abBar.addEventListener('focusin', function() {
                    _abPaused = true;
                    if (window.announcementTimer) clearInterval(window.announcementTimer);
                });
                abBar.addEventListener('focusout', function(e) {
                    if (!abBar.contains(e.relatedTarget)) {
                        _abPaused = false;
                        resetAnnouncementTimer();
                    }
                });
            }

            // Gallery swipe is owned by the inline #mainMediaContainer
            // controller rendered alongside the section (see snippets/
            // pdp-gallery-controller.liquid). Having a second handler here
            // produced double-fires that drifted the image vs the dots —
            // dot click only updated the inline `idx`, leaving this
            // handler's `currentImageIndex` stale, so the next swipe sent
            // the image to the wrong slide. Single owner = no drift.

            // Initialize variant selection on page load
            if (variants.length > 0) {
                // Set initial variant price from the first matching variant
                var initialOpts = getSelectedOptions();
                var initialVariant = findMatchingVariant(initialOpts);
                if (initialVariant) {
                    if (window.Kinsora) window.Kinsora.activeVariantPrice = initialVariant.price;
                    window.kinsoraActiveVariantPrice = initialVariant.price;
                } else {
                    if (window.Kinsora) window.Kinsora.activeVariantPrice = variants[0].price;
                    window.kinsoraActiveVariantPrice = variants[0].price;
                }
            }

            // Dynamic delivery date estimate
            var deliveryEl = document.getElementById('deliveryEstimate');
            if (deliveryEl) {
                var minDays = parseInt(deliveryEl.getAttribute('data-min-days')) || 5;
                var maxDays = parseInt(deliveryEl.getAttribute('data-max-days')) || 10;
                var months = ['January','February','March','April','May','June','July','August','September','October','November','December'];
                var now = new Date();
                function addBusinessDays(startDate, bizDays) {
                    var d = new Date(startDate.getTime());
                    var added = 0;
                    while (added < bizDays) {
                        d.setDate(d.getDate() + 1);
                        if (d.getDay() !== 0 && d.getDay() !== 6) { added++; }
                    }
                    return d;
                }
                var shipStart = addBusinessDays(now, 2); // 1-2 business days processing, worst case
                var minDate = addBusinessDays(shipStart, minDays);
                var maxDate = addBusinessDays(shipStart, maxDays);
                var minStr = months[minDate.getMonth()] + ' ' + minDate.getDate();
                var maxStr = (minDate.getMonth() === maxDate.getMonth()) ? maxDate.getDate() : months[maxDate.getMonth()] + ' ' + maxDate.getDate();
                deliveryEl.textContent = 'Arrives between ' + minStr + '–' + maxStr;
            }
        });

        function toggleFaqAccordion(button) {
            var answer = button.nextElementSibling;
            var isOpen = button.classList.contains('expanded');

            // Close all other FAQ items in the same section
            var faqSection = button.closest('.faq-list');
            faqSection.querySelectorAll('.faq-question.expanded').forEach(function(openBtn) {
                openBtn.classList.remove('expanded');
                openBtn.nextElementSibling.classList.remove('expanded');
            });

            // Toggle clicked item (if it wasn't already open)
            if (!isOpen) {
                button.classList.add('expanded');
                answer.classList.add('expanded');
            }
        }

        function toggleSubscription(toggle) {
            toggle.classList.toggle('active');
            var isActive = toggle.classList.contains('active');
            // Store subscription state for cart logic
            if (window.Kinsora) window.Kinsora.subscriptionEnabled = isActive;
            window.kinsoraSubscriptionEnabled = isActive;
            // Update visual feedback
            var card = toggle.closest('.charm-card');
            if (card) {
                card.style.opacity = isActive ? '1' : '0.6';
            }
        }


        // Reviews carousel JS is now self-contained in reviews.liquid section

        function toggleLifestyleAccordion(header) {
            var accordion = header.parentElement;
            var body = accordion.querySelector('.lifestyle-accordion-body');
            var icon = accordion.querySelector('.lifestyle-accordion-icon');
            var isOpen = body.classList.contains('open');

            // Close all others
            document.querySelectorAll('.lifestyle-accordion-body.open').forEach(b => {
                b.classList.remove('open');
                b.parentElement.querySelector('.lifestyle-accordion-icon').textContent = '+';
            });

            // Toggle current
            if (!isOpen) {
                body.classList.add('open');
                icon.textContent = '−';
            }
        }

        // Sync delete button heights with their sibling dropdowns
        function syncDeleteButtonHeights() {
            // Batch reads then writes to avoid layout thrash: read every
            // dropdown height first, then apply, so we don't force a reflow
            // per row by interleaving offsetHeight reads with style writes.
            var pairs = [];
            document.querySelectorAll('.form-row').forEach(function(row) {
                var dropdown = row.querySelector('.product-dropdown');
                var deleteBtn = row.querySelector('.delete-btn');
                if (dropdown && deleteBtn) {
                    pairs.push({ btn: deleteBtn, h: dropdown.offsetHeight });
                }
            });
            pairs.forEach(function(p) { p.btn.style.height = p.h + 'px'; });
        }

        // Run on load, resize, and after DOM changes
        window.addEventListener('resize', throttle(syncDeleteButtonHeights, 150));

        // Patch functions that add rows to also sync heights after render
        var origCreateDropdownRow = createDropdownRow;
        createDropdownRow = function(type) {
            var row = origCreateDropdownRow(type);
            if (!row) return null;
            requestAnimationFrame(() => {
                requestAnimationFrame(syncDeleteButtonHeights);
            });
            return row;
        };

        // Initialize price on load
        updatePriceDisplay();
        refreshAddButtons();

        // Render variant pills for any pre-existing dropdown-wrappers that have a selection
        document.querySelectorAll('.dropdown-wrapper[data-selected]').forEach(function(wrapper) {
            if (wrapper.dataset.selected !== '' && !isNaN(parseInt(wrapper.dataset.selected))) {
                renderVariantPills(wrapper);
            }
        });

        // Initial sync after page renders
        requestAnimationFrame(syncDeleteButtonHeights);

        // ===== CART SYSTEM (Shopify Cart API) =====
        // All cart state is managed server-side via Shopify AJAX Cart API.
        // No local cart array — every action syncs with /cart.js.

        function setCartDrawerAccessibility(drawer, isOpen) {
            if (!drawer) return;
            if (isOpen) {
                drawer.removeAttribute('aria-hidden');
                drawer.removeAttribute('inert');
            } else {
                drawer.setAttribute('aria-hidden', 'true');
                drawer.setAttribute('inert', '');
            }
        }

        function cartRedesignAccessibilityApi() {
            var api = window.KinsoraCartRedesign;
            return api && typeof api === 'object' ? api : null;
        }

        function focusWithoutScroll(node) {
            if (!node || typeof node.focus !== 'function') return false;
            try { node.focus({ preventScroll: true }); }
            catch (error) { node.focus(); }
            return document.activeElement === node || node.contains(document.activeElement);
        }

        function focusCartDrawerStart(drawer) {
            if (!drawer) return false;
            return focusWithoutScroll(
                drawer.querySelector('.cart-close-btn') ||
                drawer.querySelector('[tabindex="-1"]')
            );
        }

        function dispatchCartDrawerState(drawer, isOpen, reason) {
            if (!drawer || typeof window.CustomEvent !== 'function') return;
            document.dispatchEvent(new CustomEvent('kinsora:cart-drawer-updated', {
                detail: { drawer: drawer, open: !!isOpen, reason: reason || 'visibility' }
            }));
        }

        function openCart(options) {
            var overlay = document.getElementById('cartOverlay');
            var drawer = document.getElementById('cartDrawer');
            if (!drawer) return;
            var redesignApi = cartRedesignAccessibilityApi();
            if (redesignApi && typeof redesignApi.syncDrawerVisibility === 'function') {
                redesignApi.syncDrawerVisibility(true);
            }
            setCartDrawerAccessibility(drawer, true);
            if (overlay) overlay.classList.add('open');
            drawer.classList.add('open');
            document.body.style.overflow = 'hidden';
            // Keep the paired recommendation math synchronized when the drawer opens.
            try { syncUpsellPairOffer(); } catch (e) {}
            // skipVerification: the paid-add gate is still reconciling gifts.
            // Attaching to that promise toasts a false "checkout paused" failure
            // when the follow-up check is slow, which is the ATC hang the shopper
            // already got past by opening the drawer.
            if (!(options && options.skipVerification)) {
                try {
                    verifyServerRenderedCartQuietly('drawer-open')
                        .then(updateCartSurfacesFromSnapshot)
                        .catch(function(error) {
                            console.error('[Cart] drawer-open verification failed:', error);
                            showCartToast('Checkout is paused because your cart could not be verified. Please refresh and try again.');
                        });
                } catch (cartOpenVerificationError) {
                    console.error('[Cart] drawer-open verification failed:', cartOpenVerificationError);
                }
            }
            // Set inert on main content so screen readers can't escape the drawer
            var main = document.getElementById('MainContent');
            if (main) main.setAttribute('inert', '');
            // Focus the close button for accessibility
            focusCartDrawerStart(drawer);
            dispatchCartDrawerState(drawer, true, 'open');
        }

        function closeCart() {
            var overlay = document.getElementById('cartOverlay');
            var drawer = document.getElementById('cartDrawer');
            var redesignApi = cartRedesignAccessibilityApi();
            if (redesignApi && typeof redesignApi.syncDrawerVisibility === 'function') {
                redesignApi.syncDrawerVisibility(false);
            }
            if (overlay) overlay.classList.remove('open');
            if (drawer) drawer.classList.remove('open');
            document.body.style.overflow = '';
            // Remove inert from main content
            var main = document.getElementById('MainContent');
            if (main) main.removeAttribute('inert');
            var cartIcon = document.querySelector('.cart-icon-wrapper');
            focusWithoutScroll(cartIcon);
            if (drawer && drawer.contains(document.activeElement) && document.activeElement.blur) {
                document.activeElement.blur();
            }
            setCartDrawerAccessibility(drawer, false);
            dispatchCartDrawerState(drawer, false, 'close');
        }

        (function syncInitialCartDrawerAccessibility() {
            var initialDrawer = document.getElementById('cartDrawer');
            setCartDrawerAccessibility(initialDrawer, !!(initialDrawer && initialDrawer.classList.contains('open')));
        })();

        document.addEventListener('shopify:section:load', function(event) {
            var sectionTarget = event && event.target;
            var refreshedDrawer = sectionTarget && sectionTarget.querySelector
                ? sectionTarget.querySelector('#cartDrawer')
                : null;
            if (!refreshedDrawer) return;
            var isOpen = refreshedDrawer.classList.contains('open');
            setCartDrawerAccessibility(refreshedDrawer, isOpen);
            var redesignApi = cartRedesignAccessibilityApi();
            if (redesignApi && typeof redesignApi.afterDrawerReplace === 'function') {
                redesignApi.afterDrawerReplace({ drawer: refreshedDrawer, open: isOpen, restoreFocus: false });
            }
            dispatchCartDrawerState(refreshedDrawer, isOpen, 'section-load');
        });

        // Delegate the focus trap so it survives cart section replacement.
        document.addEventListener('keydown', function(e) {
            if (e.key !== 'Tab') return;
            var drawer = document.getElementById('cartDrawer');
            if (!drawer || !drawer.classList.contains('open')) return;
            if (drawer.querySelector('.ks-sheet:not([hidden])')) return;
            var focusable = Array.prototype.filter.call(
                drawer.querySelectorAll('button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'),
                function(node) {
                    return !node.hidden && node.offsetParent !== null && !node.closest('[hidden]');
                }
            );
            if (focusable.length === 0) return;
            var first = focusable[0];
            var last = focusable[focusable.length - 1];
            if (e.shiftKey) {
                if (document.activeElement === first) { e.preventDefault(); last.focus(); }
            } else if (document.activeElement === last) {
                e.preventDefault();
                first.focus();
            }
        });

        // Focus trap for mobile menu
        (function() {
            var menu = document.getElementById('mobileMenu');
            if (!menu) return;
            menu.addEventListener('keydown', function(e) {
                if (e.key !== 'Tab') return;
                var focusable = menu.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
                if (focusable.length === 0) return;
                var first = focusable[0];
                var last = focusable[focusable.length - 1];
                if (e.shiftKey) {
                    if (document.activeElement === first) { e.preventDefault(); last.focus(); }
                } else {
                    if (document.activeElement === last) { e.preventDefault(); first.focus(); }
                }
            });
        })();

        var filterDrawerTrigger = null;
        var filterDrawerIsolation = [];
        var filterDrawerBodyOverflow = null;

        function filterDrawerNodes() {
            return {
                sidebar: document.getElementById('filtersSidebar'),
                overlay: document.getElementById('filtersOverlay')
            };
        }

        function filterGroupPanel(toggle) {
            if (!toggle) return null;
            var controls = toggle.getAttribute('aria-controls');
            if (controls) {
                var controlled = document.getElementById(controls);
                if (controlled) return controlled;
            }
            return toggle.nextElementSibling;
        }

        function setFilterGroupExpanded(toggle, expanded) {
            var panel = filterGroupPanel(toggle);
            toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
            toggle.classList.toggle('collapsed', !expanded);
            var group = toggle.closest('.filter-group');
            if (group) group.classList.toggle('collapsed', !expanded);
            if (panel) {
                panel.hidden = !expanded;
                panel.style.display = '';
            }
        }

        function syncFilterGroupAccessibility(root) {
            var scope = root && root.querySelectorAll ? root : document;
            Array.prototype.forEach.call(scope.querySelectorAll('.filter-group-header[data-action="toggle-filter-group"]'), function(toggle) {
                var panel = filterGroupPanel(toggle);
                var declared = toggle.getAttribute('aria-expanded');
                var expanded = declared === null
                    ? !toggle.classList.contains('collapsed') && !(panel && panel.hidden)
                    : declared === 'true';
                setFilterGroupExpanded(toggle, expanded);
            });
        }

        function setFilterTriggerState(expanded) {
            document.querySelectorAll('[data-action="open-filters"]').forEach(function(trigger) {
                trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
            });
        }

        function addFilterIsolation(node) {
            if (!node || !node.setAttribute || node.hasAttribute('inert')) return;
            var tagName = node.tagName;
            if (tagName === 'SCRIPT' || tagName === 'STYLE' || tagName === 'LINK' || tagName === 'META') return;
            node.setAttribute('inert', '');
            filterDrawerIsolation.push(node);
        }

        function isolateFilterBackground(root, protectedNodes) {
            if (!root || !root.children) return;
            Array.prototype.forEach.call(root.children, function(child) {
                var protectsDrawer = protectedNodes.some(function(node) {
                    return child === node || child.contains(node);
                });
                if (!protectsDrawer) {
                    addFilterIsolation(child);
                    return;
                }
                if (protectedNodes.indexOf(child) === -1) {
                    isolateFilterBackground(child, protectedNodes);
                }
            });
        }

        function restoreFilterBackground() {
            filterDrawerIsolation.forEach(function(node) {
                node.removeAttribute('inert');
            });
            filterDrawerIsolation = [];
        }

        function filterFocusableElements(sidebar) {
            return Array.prototype.filter.call(
                sidebar.querySelectorAll('a[href], area[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), iframe, object, embed, [contenteditable="true"], [tabindex]:not([tabindex="-1"])'),
                function(node) {
                    if (node.hidden || node.closest('[hidden], [inert], [aria-hidden="true"]')) return false;
                    if (typeof window.getComputedStyle !== 'function') return true;
                    var style = window.getComputedStyle(node);
                    return style.display !== 'none' && style.visibility !== 'hidden';
                }
            );
        }

        function focusFilterDrawerStart(sidebar) {
            var target = sidebar.querySelector('[data-action="close-filters"]') ||
                sidebar.querySelector('[data-filter-drawer-title], .filters-sidebar-header h2, h2');
            if (!target) return false;
            if (!target.matches('button, a[href], input, select, textarea, [tabindex]')) {
                target.setAttribute('tabindex', '-1');
            }
            return focusWithoutScroll(target);
        }

        function openFilterDrawer(trigger) {
            var nodes = filterDrawerNodes();
            if (!nodes.sidebar) return;
            if (trigger && document.documentElement.contains(trigger)) filterDrawerTrigger = trigger;
            if (!filterDrawerTrigger) filterDrawerTrigger = document.querySelector('[data-action="open-filters"]');
            restoreFilterBackground();
            nodes.sidebar.removeAttribute('aria-hidden');
            nodes.sidebar.removeAttribute('inert');
            if (nodes.overlay) {
                nodes.overlay.setAttribute('aria-hidden', 'true');
                nodes.overlay.removeAttribute('inert');
            }
            isolateFilterBackground(document.body, [nodes.sidebar, nodes.overlay].filter(Boolean));
            if (filterDrawerBodyOverflow === null) filterDrawerBodyOverflow = document.body.style.overflow;
            setFilterTriggerState(true);
            nodes.sidebar.classList.add('open');
            if (nodes.overlay) nodes.overlay.classList.add('open');
            document.body.style.overflow = 'hidden';
            focusFilterDrawerStart(nodes.sidebar);
        }

        function closeFilterDrawer() {
            var nodes = filterDrawerNodes();
            if (nodes.sidebar) nodes.sidebar.classList.remove('open');
            if (nodes.overlay) nodes.overlay.classList.remove('open');
            restoreFilterBackground();
            if (filterDrawerBodyOverflow !== null) {
                document.body.style.overflow = filterDrawerBodyOverflow;
                filterDrawerBodyOverflow = null;
            }
            setFilterTriggerState(false);
            var returnTarget = filterDrawerTrigger;
            if (returnTarget && document.documentElement.contains(returnTarget)) {
                focusWithoutScroll(returnTarget);
            }
            if (nodes.sidebar && nodes.sidebar.contains(document.activeElement) && document.activeElement.blur) {
                document.activeElement.blur();
            }
            if (nodes.sidebar) {
                nodes.sidebar.setAttribute('aria-hidden', 'true');
                nodes.sidebar.setAttribute('inert', '');
            }
            if (nodes.overlay) {
                nodes.overlay.setAttribute('aria-hidden', 'true');
                nodes.overlay.setAttribute('inert', '');
            }
            filterDrawerTrigger = null;
        }

        function syncFilterDrawerAccessibility(root) {
            var nodes = filterDrawerNodes();
            if (!nodes.sidebar) return;
            var isOpen = nodes.sidebar.classList.contains('open');
            if (isOpen) {
                nodes.sidebar.removeAttribute('aria-hidden');
                nodes.sidebar.removeAttribute('inert');
            } else {
                nodes.sidebar.setAttribute('aria-hidden', 'true');
                nodes.sidebar.setAttribute('inert', '');
            }
            if (nodes.overlay) {
                nodes.overlay.setAttribute('aria-hidden', 'true');
                if (isOpen) nodes.overlay.removeAttribute('inert');
                else nodes.overlay.setAttribute('inert', '');
            }
            setFilterTriggerState(isOpen);
            syncFilterGroupAccessibility(root || document);
        }

        syncFilterDrawerAccessibility(document);

        document.addEventListener('shopify:section:load', function(event) {
            var target = event && event.target;
            if (!target || !target.querySelector || !target.querySelector('#filtersSidebar')) return;
            restoreFilterBackground();
            if (filterDrawerBodyOverflow !== null) {
                document.body.style.overflow = filterDrawerBodyOverflow;
                filterDrawerBodyOverflow = null;
            }
            filterDrawerTrigger = null;
            syncFilterDrawerAccessibility(target);
        });

        document.addEventListener('keydown', function(e) {
            if (e.key !== 'Tab') return;
            var sidebar = document.getElementById('filtersSidebar');
            if (!sidebar || !sidebar.classList.contains('open')) return;
            var focusable = filterFocusableElements(sidebar);
            if (focusable.length === 0) {
                e.preventDefault();
                focusFilterDrawerStart(sidebar);
                return;
            }
            var first = focusable[0];
            var last = focusable[focusable.length - 1];
            if (e.shiftKey && (document.activeElement === first || !sidebar.contains(document.activeElement))) {
                e.preventDefault();
                focusWithoutScroll(last);
            } else if (!e.shiftKey && (document.activeElement === last || !sidebar.contains(document.activeElement))) {
                e.preventDefault();
                focusWithoutScroll(first);
            }
        });

        // Close cart, mobile menu, or filter sidebar on Escape key
        document.addEventListener('keydown', function(e) {
            if (e.key === 'Escape') {
                var cartDrawer = document.getElementById('cartDrawer');
                var mobileMenu = document.getElementById('mobileMenu');
                var filtersSidebar = document.getElementById('filtersSidebar');
                if (cartDrawer && cartDrawer.classList.contains('open')) {
                    closeCart();
                } else if (mobileMenu && mobileMenu.classList.contains('open')) {
                    closeMobileMenu();
                } else if (filtersSidebar && filtersSidebar.classList.contains('open')) {
                    closeFilterDrawer();
                }
            }
        });

        function updateCartCount(count) {
            var badge = document.getElementById('cartCount');
            if (!badge) return;
            if (count > 0) {
                badge.textContent = count;
                badge.classList.remove('cart-count--hidden');
            } else {
                badge.classList.add('cart-count--hidden');
            }
        }

        /**
         * Fetch the real Shopify cart and re-render the drawer.
         * Called after every add / remove / qty change.
         * Fires both requests in parallel and cross-fades new content to avoid flash.
         */
        var _refreshPending = false;
        var _refreshPromise = null;
        var _refreshQueued = false;
        var _refreshQueuedStrict = false;
        var _cartRefreshGeneration = 0;
        // Always-restore helper so the cart body never gets stuck at opacity 0.5
        function _restoreCartBodyOpacity() {
            var b = document.getElementById('cartBody');
            if (b) b.style.opacity = '1';
        }
        // Safe JSON fetch: validates r.ok and parses defensively, so a Shopify
        // 5xx (e.g. a Liquid render error in cart-drawer.liquid) produces a
        // useful console message instead of "Unexpected token <" while the
        // cart drawer body stays invisible. Without this, the .then(r => r.json())
        // chain throws on any non-JSON response and the customer sees a ghosted
        // drawer indefinitely.
        function _safeFetchJson(url, options) {
            var requestOptions = options || {};
            requestOptions.credentials = 'same-origin';
            return fetch(url, requestOptions).then(function(r) {
                if (!r.ok) {
                    return r.text().then(function(body) {
                        var snip = (body || '').slice(0, 200);
                        throw new Error('[' + r.status + '] ' + url + ' -- ' + snip);
                    });
                }
                return r.text().then(function(body) {
                    try {
                        return JSON.parse(body);
                    } catch (e) {
                        var snip = (body || '').slice(0, 200);
                        throw new Error('Invalid JSON from ' + url + ' -- ' + snip);
                    }
                });
            });
        }
        var _cartRefreshTimer = null;
        // Coalesce the heavy cart-drawer re-render: rapid +/- taps each update the
        // server (checkout stays correct) and refresh the cheap bits instantly, but
        // trigger only ONE full drawer rebuild after the taps settle.
        function scheduleCartRefresh(delay) {
            clearTimeout(_cartRefreshTimer);
            _cartRefreshTimer = setTimeout(function() { refreshCartDrawer(); }, delay || 200);
        }
        function refreshCartDrawer(options) {
            var strictRefresh = !!(options && options.strict);
            var cartSnapshot = options && options.cart;
            // Never drop a refresh request. If a cart mutation lands while the
            // section request is in flight, queue one authoritative follow-up so
            // quantity, bundle components, tier bar, and totals cannot diverge.
            if (_refreshPending) {
                _refreshQueued = true;
                _refreshQueuedStrict = _refreshQueuedStrict || strictRefresh;
                // The active promise includes its queued follow-up. Every
                // waiter shares that render; strict callers upgrade its checks.
                return _refreshPromise;
            }
            _refreshPending = true;
            var refreshGeneration = ++_cartRefreshGeneration;
            var refreshController = typeof AbortController !== 'undefined' ? new AbortController() : null;
            var refreshTimedOut = false;

            var cartBody = document.getElementById('cartBody');
            var refreshDrawer = document.getElementById('cartDrawer');
            var softenCartBody = !(refreshDrawer && refreshDrawer.getAttribute('data-kinsora-cart-redesign') === 'true');
            if (cartBody) cartBody.style.opacity = softenCartBody ? '0.5' : '1';

            // Watchdog: if the refresh somehow hangs (flaky network, fetch
            // pending forever), force-release the mutex + restore opacity so
            // the customer isn't stuck on a ghosted drawer. 10s is generous
            // for a normal cart fetch (~200-500ms).
            var watchdog;
            var timeoutPromise = new Promise(function(resolve, reject) {
                watchdog = setTimeout(function () {
                    if (_refreshPending && refreshGeneration === _cartRefreshGeneration) {
                        refreshTimedOut = true;
                        if (refreshController) refreshController.abort();
                        console.warn('[Cart] refreshCartDrawer watchdog fired -- fetch took >10s');
                        // Settle the same promise that callers await, even if a
                        // transport ignores abort. Late responses cannot render.
                        reject(new Error('The cart drawer refresh timed out.'));
                    }
                }, 10000);
            });

            // Fire both requests in parallel, validating ok + JSON to avoid the
            // "Unexpected token <" failure mode that leaves the drawer ghosted.
            // Shopify can reuse a section for equivalent merchandise even when
            // private properties and line keys changed. Its recognized variant
            // query varies that render cache; custom cache-buster keys do not.
            // On /cart this only refreshes HTML and never selects a product.
            var refreshSections = 'cart-drawer';
            if (document.documentElement.dataset.setSalePrices !== 'true' && document.getElementById('shopify-section-stack-tier-bar')) refreshSections += ',stack-tier-bar';
            var sectionUrl = freeGiftCartEndpoint('cart?sections=' + refreshSections + '&variant=' + (Date.now() + refreshGeneration));
            var snapshotOptions = { cache: 'no-store' };
            if (refreshController) snapshotOptions.signal = refreshController.signal;
            _refreshPromise = Promise.race([timeoutPromise, Promise.all([
                _safeFetchJson(sectionUrl, snapshotOptions),
                cartSnapshot
                    ? Promise.resolve(cartSnapshot)
                    : _safeFetchJson(freeGiftCartEndpoint('cart.js'), snapshotOptions)
            ])])
            .then(function(results) {
                // A timed-out request must never overwrite a newer cart render.
                if (refreshGeneration !== _cartRefreshGeneration) {
                    if (strictRefresh) throw new Error(refreshTimedOut
                        ? 'The cart drawer refresh timed out.'
                        : 'The cart drawer refresh was superseded before it rendered.');
                    return;
                }
                var sections = results[0];
                var cart = results[1];
                var html = sections && sections['cart-drawer'];
                if (strictRefresh && !html) {
                    throw new Error('The cart drawer section was missing from Shopify\'s refresh response.');
                }
                if (html) {
                    var container = document.querySelector('.section-cart-drawer');
                    if (strictRefresh && !container) {
                        throw new Error('The live cart drawer container could not be found.');
                    }
                    if (container) {
                        var previousDrawer = document.getElementById('cartDrawer');
                        var wasOpen = !!(previousDrawer && previousDrawer.classList.contains('open'));
                        var focusWasInsideDrawer = !!(previousDrawer && previousDrawer.contains(document.activeElement));
                        var redesignApi = cartRedesignAccessibilityApi();
                        if (redesignApi && typeof redesignApi.beforeDrawerReplace === 'function') {
                            redesignApi.beforeDrawerReplace();
                        }
                        var temp = document.createElement('div');
                        temp.innerHTML = html;
                        var freshContainer = temp.querySelector('.section-cart-drawer');
                        if (strictRefresh && !freshContainer && !temp.querySelector('#cartDrawer')) {
                            throw new Error('The refreshed cart drawer markup was invalid.');
                        }
                        // Move the already-parsed nodes into the live container instead
                        // of re-serializing + re-parsing via innerHTML (the big
                        // main-thread cost on every cart re-render). Fall back to
                        // innerHTML on browsers without replaceChildren.
                        var _src = freshContainer || temp;
                        if (container.replaceChildren) {
                            container.replaceChildren.apply(container, Array.prototype.slice.call(_src.childNodes));
                        } else {
                            container.innerHTML = _src.innerHTML;
                        }
                        var refreshedDrawer = document.getElementById('cartDrawer');
                        setCartDrawerAccessibility(refreshedDrawer, wasOpen);
                        if (wasOpen) {
                            var overlay = document.getElementById('cartOverlay');
                            if (refreshedDrawer) refreshedDrawer.classList.add('open');
                            if (overlay) overlay.classList.add('open');
                        }
                        if (redesignApi && typeof redesignApi.afterDrawerReplace === 'function') {
                            redesignApi.afterDrawerReplace({
                                drawer: refreshedDrawer,
                                open: wasOpen,
                                restoreFocus: focusWasInsideDrawer
                            });
                        } else if (wasOpen && focusWasInsideDrawer) {
                            focusCartDrawerStart(refreshedDrawer);
                        }
                        dispatchCartDrawerState(refreshedDrawer, wasOpen, 'replace');
                        // The section swap creates a new checkout node. Reapply an
                        // active cart/gift lock before the browser can dispatch a
                        // click against that freshly inserted control.
                        applyCheckoutSynchronizationBusyState();
                        if (strictRefresh && !document.getElementById('cartDrawer')) {
                            throw new Error('The refreshed cart drawer markup was invalid.');
                        }
                    }
                }

                // Swap + pulse the sitewide BOGO bar from authoritative cart data.
                try {
                    var _stierHtml = sections && sections['stack-tier-bar'];
                    var _stierWrap = document.getElementById('shopify-section-stack-tier-bar');
                    if (_stierHtml && _stierWrap) {
                        var _prevBar = _stierWrap.querySelector('[data-stier]');
                        var _prevN = _prevBar ? parseInt(_prevBar.getAttribute('data-n'), 10) : 0;
                        var _prevFree = _prevBar ? parseInt(_prevBar.getAttribute('data-free-count'), 10) : 0;
                        if (isNaN(_prevN)) _prevN = 0;
                        if (isNaN(_prevFree)) _prevFree = Math.floor(_prevN / 3) * 2;
                        // Section Rendering API responses include their own Shopify
                        // wrapper. Inserting that full response inside the live wrapper
                        // creates duplicate #shopify-section-stack-tier-bar elements.
                        // Both receive the fixed header offset, so the inner copy can
                        // appear a second header-height lower in the middle of the page.
                        var _stierTemp = document.createElement('div');
                        _stierTemp.innerHTML = _stierHtml;
                        var _freshStierWrap = _stierTemp.querySelector('#shopify-section-stack-tier-bar');
                        var _stierSource = _freshStierWrap || _stierTemp;
                        if (_stierWrap.replaceChildren) {
                            _stierWrap.replaceChildren.apply(_stierWrap, Array.prototype.slice.call(_stierSource.childNodes));
                        } else {
                            _stierWrap.innerHTML = _stierSource.innerHTML;
                        }
                        var _newBar = _stierWrap.querySelector('[data-stier]');
                        var _newN = _newBar ? parseInt(_newBar.getAttribute('data-n'), 10) : 0;
                        var _newFree = _newBar ? parseInt(_newBar.getAttribute('data-free-count'), 10) : 0;
                        if (_newBar && _newFree > _prevFree) {
                            var _freeChip = _newBar.querySelector('[data-bogo-earned]');
                            if (_freeChip) {
                                _freeChip.classList.add('is-pulse');
                                setTimeout(function(){ _freeChip.classList.remove('is-pulse'); }, 600);
                            }
                        }
                        if (window.Kinsora && window.Kinsora.stackTier) {
                            window.Kinsora.stackTier.announce(true);
                        }
                    }
                } catch (e) { console.error('[Cart] stier bar refresh', e); }
                try { if (window.Kinsora && window.Kinsora.measureBars) window.Kinsora.measureBars(); } catch (e) {}

                // Fade content back in (0.5 → 1, no flash to 0)
                var newBody = document.getElementById('cartBody');
                if (newBody) {
                    newBody.style.opacity = softenCartBody ? '0.5' : '1';
                    if (softenCartBody) requestAnimationFrame(function() {
                        newBody.style.opacity = '1';
                    });
                }

                try { updateCartCount(getPaidCartCount(cart)); } catch(e) { console.error('[Cart] updateCartCount', e); }
                try { updateProgressBar(cart); } catch(e) { console.error('[Cart] updateProgressBar', e); }
                try {
                    var _drawer = document.getElementById('cartDrawer');
                    if (_drawer && (_drawer.dataset.enableFreeGift === 'true' || _drawer.dataset.enableFreeBracelet === 'true')) {
                        var _giftThreshold = getRewardThresholdCents(_drawer, 'gift');
                        var _eligibleCents = calcEligibleSubtotal(cart);
                        updateFreeGiftUI(cart, _eligibleCents, _giftThreshold);
                    }
                } catch(e) { console.error('[Cart] updateFreeGiftUI', e); }
                try { initFreeGiftSelectors(); } catch(e) { console.error('[Cart] initFreeGiftSelectors', e); }
                try { hideCartUpsellDuplicates(cart); } catch(e) { console.error('[Cart] hideCartUpsellDuplicates', e); }
                try { syncUpsellPairOffer(); } catch(e) { console.error('[Cart] syncUpsellPairOffer', e); }
                try { syncChainNudge(); } catch(e) { console.error('[Cart] syncChainNudge', e); }
                clearTimeout(watchdog);
            })
            .catch(function(err) {
                clearTimeout(watchdog);
                if (refreshTimedOut) {
                    err = new Error('The cart drawer refresh timed out.');
                } else if (refreshGeneration !== _cartRefreshGeneration || (err && err.name === 'AbortError')) {
                    if (strictRefresh) throw new Error('The cart drawer refresh was superseded before it rendered.');
                    return;
                }
                _restoreCartBodyOpacity();
                console.error('[Cart] refreshCartDrawer error:', err);
                showCartToast('Couldn\u2019t load cart. Please refresh the page.');
                if (strictRefresh) {
                    _refreshPending = false;
                    _refreshQueued = false;
                    _refreshQueuedStrict = false;
                    throw err;
                }
                // Intentionally NOT re-throwing. Call sites (addToCart,
                // removeFromCart, updateQty, addUpsellToCart) are fire-and-forget;
                // rethrowing produces unhandled promise rejection warnings.
            })
            .then(function() {
                if (refreshGeneration !== _cartRefreshGeneration) return;
                _refreshPending = false;
                if (_refreshQueued) {
                    var queuedStrict = strictRefresh || _refreshQueuedStrict;
                    _refreshQueued = false;
                    _refreshQueuedStrict = false;
                    // Read a fresh snapshot for a queued render: it may follow
                    // another mutation and must not reuse an earlier snapshot.
                    return refreshCartDrawer(queuedStrict ? { strict: true } : undefined);
                }
            });
            return _refreshPromise;
        }

        // Expose cart helpers on window.Kinsora so other scripts (e.g.
        // kinsora-bundle-init.js's custom multi-add) can open + refresh the
        // cart drawer after their own /cart/add.js call without reaching
        // through DOM clicks.
        window.Kinsora.openCart = openCart;
        window.Kinsora.refreshCartDrawer = refreshCartDrawer;

        /* === FREE GIFT + MULTI-MILESTONE PROGRESS BAR — JS START === */

        // Mutex to prevent concurrent cart mutations
        var _fgBusy = false;
        var _fgAutoTried = {};
        var FREE_GIFT_PROPERTY = '_kinsora_free_gift';
        var FREE_GIFT_PROPERTY_VALUE = 'true';
        var FREE_GIFT_ROLE_PROPERTY = '_kinsora_free_gift_role';
        var FREE_GIFT_PREFERENCE_KEYS = {
            pouch: 'kinsora-preferred-pouch-variant',
            bracelet: 'kinsora-preferred-bracelet-variant'
        };

        /**
         * A configured pouch is complimentary only when the theme itself marked
         * that exact cart line. Variant identity alone is not enough: customers
         * may legitimately buy the Travel Pouch at its normal price.
         */
        function hasFreeGiftMarker(item) {
            if (!item || !item.properties) return false;
            return String(item.properties[FREE_GIFT_PROPERTY] || '').toLowerCase() === FREE_GIFT_PROPERTY_VALUE;
        }

        function configuredGiftIds(role) {
            var drawer = document.getElementById('cartDrawer');
            var renderedId = 0;
            var ids = [];
            if (role === 'bracelet') {
                renderedId = drawer ? Number(drawer.dataset.freeBraceletVariantId || 0) : 0;
                ids = ((window.Kinsora && window.Kinsora.freeBraceletVariantIds) || []).map(Number);
            } else if (role === 'pouch') {
                renderedId = drawer ? Number(drawer.dataset.freeGiftVariantId || 0) : 0;
                ids = ((window.Kinsora && window.Kinsora.freePouchVariantIds) || []).map(Number);
                if (!ids.length && window.Kinsora && window.Kinsora.freeGiftAutoVariantId) {
                    ids = [Number(window.Kinsora.freeGiftAutoVariantId)];
                }
            } else {
                ids = ((window.Kinsora && window.Kinsora.freeGiftVariantIds) || []).map(Number);
            }
            if (renderedId && ids.indexOf(renderedId) === -1) ids.unshift(renderedId);
            return ids.filter(function(id, index, list) { return id > 0 && list.indexOf(id) === index; });
        }

        function preferredFreeGiftVariantId(role) {
            var key = FREE_GIFT_PREFERENCE_KEYS[role];
            var id = 0;
            if (key) {
                try { id = Number(window.sessionStorage.getItem(key) || 0); } catch (error) { id = 0; }
            }
            return configuredGiftIds(role).indexOf(id) !== -1 ? id : 0;
        }

        function setPreferredFreeGiftVariant(role, variantId) {
            variantId = Number(variantId || 0);
            var key = FREE_GIFT_PREFERENCE_KEYS[role];
            if (!key || configuredGiftIds(role).indexOf(variantId) === -1) return false;
            try { window.sessionStorage.setItem(key, String(variantId)); } catch (error) {}
            return true;
        }

        function isConfiguredFreeGiftVariant(item, role) {
            if (!item) return false;
            return configuredGiftIds(role).indexOf(Number(item.variant_id)) !== -1;
        }

        function freeGiftRole(item) {
            if (!hasFreeGiftMarker(item)) return '';
            var explicitRole = String(item.properties && item.properties[FREE_GIFT_ROLE_PROPERTY] || '').toLowerCase();
            if (explicitRole === 'bracelet' && isConfiguredFreeGiftVariant(item, 'bracelet')) return 'bracelet';
            if (explicitRole === 'pouch' && isConfiguredFreeGiftVariant(item, 'pouch')) return 'pouch';
            if (!explicitRole && isConfiguredFreeGiftVariant(item, 'pouch')) return 'pouch';
            if (!explicitRole && isConfiguredFreeGiftVariant(item, 'bracelet')) return 'bracelet';
            return '';
        }

        function isFreeGiftItem(item) {
            return !!freeGiftRole(item);
        }

        function findFreeGiftItemByRole(cart, role) {
            if (!cart || !cart.items) return null;
            for (var i = 0; i < cart.items.length; i++) {
                if (freeGiftRole(cart.items[i]) === role) return cart.items[i];
            }
            return null;
        }

        function requiredFreeGiftRoles(drawer) {
            var roles = [];
            if (drawer && drawer.dataset.enableFreeGift === 'true' && configuredGiftIds('pouch').length) roles.push('pouch');
            if (drawer && drawer.dataset.enableFreeBracelet === 'true' && configuredGiftIds('bracelet').length) roles.push('bracelet');
            return roles;
        }

        function giftRoleQualifies(role, eligibleCents, braceletThreshold) {
            if (role === 'pouch') return eligibleCents > 0;
            return role === 'bracelet' && Number.isFinite(braceletThreshold)
                && braceletThreshold > 0 && eligibleCents >= braceletThreshold;
        }

        function autoFreeGiftVariantId(drawer, role, useFreshInventory) {
            var preferredId = role === 'pouch' || useFreshInventory ? 0 : preferredFreeGiftVariantId(role);
            if (preferredId) return preferredId;
            if (role === 'bracelet') {
                return Number(drawer && drawer.dataset.freeBraceletVariantId || 0) ||
                    Number(window.Kinsora && window.Kinsora.freeBraceletAutoVariantId || 0);
            }
            return Number(drawer && drawer.dataset.freeGiftVariantId || 0) ||
                Number(window.Kinsora && window.Kinsora.freeGiftAutoVariantId || 0);
        }

        /**
         * Older theme versions auto-added an unmarked pouch. It is impossible to
         * distinguish that line from a pouch the customer intentionally bought,
         * so never mutate or relabel it. While the reward is unlocked, only an
         * unmarked line Shopify already prices at $0 may suppress a duplicate
         * migration pouch. A paid pouch still earns its separate marked gift.
         */
        function findLegacyUnmarkedFreeGift(cart) {
            if (!cart || !cart.items) return null;
            for (var i = 0; i < cart.items.length; i++) {
                if (
                    isConfiguredFreeGiftVariant(cart.items[i], 'pouch') &&
                    !hasFreeGiftMarker(cart.items[i]) &&
                    Number(cart.items[i].final_line_price) === 0
                ) {
                    return cart.items[i];
                }
            }
            return null;
        }

        function findLegacyUnmarkedFreeGifts(cart) {
            if (!cart || !Array.isArray(cart.items)) return [];
            return cart.items.filter(function(item) {
                return isConfiguredFreeGiftVariant(item, 'pouch')
                    && !hasFreeGiftMarker(item)
                    && Number(item.final_line_price) === 0;
            });
        }

        /** Shopper-facing cart count excludes automatically added reward lines. */
        function getPaidCartCount(cart) {
            var count = 0;
            if (!cart || !cart.items) return count;
            cart.items.forEach(function(item) {
                if (isFreeGiftItem(item)) return;
                count += Number(item.quantity) || 0;
            });
            return count;
        }

        /** Convert a base-shop-currency reward setting into presentment cents. */
        function getRewardThresholdCents(drawer, type) {
            if (!drawer) return 0;
            var attr = type === 'shipping' ? 'shippingThresholdBaseCents' : 'giftThresholdBaseCents';
            var baseCents = parseFloat(drawer.dataset[attr] || '0');
            if (!isFinite(baseCents)) baseCents = 0;
            if (window.Kinsora && typeof window.Kinsora.baseToPresentmentCents === 'function') {
                var converted = window.Kinsora.baseToPresentmentCents(baseCents);
                return isFinite(converted) && converted > 0 ? converted : null;
            }
            var shopCurrency = drawer.dataset.shopCurrency || '';
            var presentmentCurrency = drawer.dataset.presentmentCurrency || shopCurrency;
            return shopCurrency && presentmentCurrency === shopCurrency
                ? Math.round(baseCents)
                : null;
        }

        /** Paid merchandise after Shopify applies product and order discounts. */
        function calcEligibleSubtotal(cart) {
            if (!cart || !cart.items) return 0;
            var total = Number(cart.total_price);
            if (!isFinite(total)) {
                total = cart.items.reduce(function(sum, item) {
                    return sum + (Number(item.final_line_price) || 0);
                }, 0);
            }
            // A marked reward never helps itself qualify. This also prevents a
            // temporarily paid gift line from crossing the reward threshold.
            cart.items.forEach(function(item) {
                if (isFreeGiftItem(item) || item.gift_card) total -= Number(item.final_line_price) || 0;
            });
            return Math.max(0, total);
        }

        /** Hydrate the redesigned reward rail in the active presentment currency. */
        function updateRedesignedReward(cart) {
            var drawer = document.getElementById('cartDrawer');
            var reward = drawer && drawer.querySelector('.ks-reward');
            if (!drawer || !reward) return;
            var threshold = getRewardThresholdCents(drawer, 'gift');
            if (!isFinite(threshold) || threshold <= 0) {
                reward.hidden = true;
                return;
            }

            var eligibleCents = calcEligibleSubtotal(cart);
            var requiredRoles = requiredFreeGiftRoles(drawer);
            var giftPresent = requiredRoles.length > 0 && requiredRoles.every(function(role) {
                var item = findFreeGiftItemByRole(cart, role);
                return item && Number(item.final_line_price) === 0;
            });
            var hasBraceletReward = requiredRoles.indexOf('bracelet') !== -1;
            var reached = eligibleCents >= threshold;
            var remaining = Math.max(threshold - eligibleCents, 0);
            var headline = reward.querySelector('.ks-reward__headline');
            var progress = reward.querySelector('.ks-reward__progress');
            var fill = reward.querySelector('.ks-reward__rail > span');
            var pouchDot = reward.querySelector('.ks-reward__dot--pouch');
            var pouchLabel = reward.querySelector('.ks-reward__label--pouch');

            reward.hidden = false;
            if (headline) {
                headline.textContent = '';
                var accent = document.createElement('span');
                accent.className = 'ks-reward__accent';
                if (giftPresent) {
                    accent.textContent = hasBraceletReward ? '2 bonus gifts' : 'Bonus travel pouch';
                    headline.appendChild(accent);
                    headline.appendChild(document.createTextNode(' added to your cart'));
                } else if (reached) {
                    headline.appendChild(document.createTextNode('Adding your '));
                    accent.textContent = hasBraceletReward ? 'bonus gifts' : 'bonus travel pouch';
                    headline.appendChild(accent);
                    headline.appendChild(document.createTextNode('…'));
                } else {
                    headline.appendChild(document.createTextNode('Add '));
                    accent.textContent = fgFormatMoney(remaining);
                    headline.appendChild(accent);
                    headline.appendChild(document.createTextNode(hasBraceletReward ? ' for 2 bonus gifts.' : ' for a bonus travel pouch.'));
                }
            }
            if (fill) {
                var fillPercent = giftPresent ? 100 : Math.min(75, 25 + (Math.min(eligibleCents / threshold, 1) * 50));
                fill.style.width = fillPercent + '%';
            }
            if (pouchDot) pouchDot.classList.toggle('is-earned', giftPresent);
            if (pouchLabel) pouchLabel.textContent = hasBraceletReward
                ? 'Spend ' + fgFormatMoney(threshold) + ': 2 bonus gifts'
                : 'Spend ' + fgFormatMoney(threshold) + ': bonus travel pouch';
            if (progress) {
                progress.setAttribute('aria-valuemin', '0');
                progress.setAttribute('aria-valuemax', String(threshold));
                progress.setAttribute('aria-valuenow', String(Math.min(eligibleCents, threshold)));
                progress.setAttribute('aria-label', giftPresent
                    ? (hasBraceletReward ? 'Free Shipping Unlocked. Bonus travel pouch and bonus bracelet added to cart.' : 'Free Shipping Unlocked. Bonus travel pouch added to cart.')
                    : 'Free Shipping Unlocked. ' + fgFormatMoney(Math.min(eligibleCents, threshold)) + ' of ' + fgFormatMoney(threshold) + (hasBraceletReward ? ' toward 2 bonus gifts.' : ' toward a bonus travel pouch.'));
            }
        }

        /**
         * Find the free gift line item in the cart (if any).
         * Returns the item object or null.
         */
        function findFreeGiftItem(cart) {
            return findFreeGiftItemByRole(cart, 'pouch');
        }

        var _fgReconcilePromise = null;
        var _fgControlsBusy = false;
        var _cartMutationSyncPromise = null;
        var _cartMutationSyncBusy = false;
        var CART_MUTATION_SYNC_FAILURE_KEY = 'kinsora-cart-gift-sync-failed';
        var _cartMutationSyncFailed = false;
        try {
            _cartMutationSyncFailed = window.sessionStorage.getItem(CART_MUTATION_SYNC_FAILURE_KEY) === 'true';
        } catch (storageError) {}

        var FREE_GIFT_BLOCKED_CHECKOUT_SELECTOR = [
            '.cart-checkout-btn',
            '.cart-page-checkout-btn',
            '.cart-page-mobile-checkout',
            '.cart-page-dynamic-checkout',
            '.additional-checkout-buttons',
            '.shopify-payment-button',
            'shopify-accelerated-checkout',
            '.kinsora-express-btn',
            '.kinsora-shoppay-wrap',
            'shop-pay-button'
        ].join(', ');

        function applyCheckoutSynchronizationBusyState() {
            var busy = _fgControlsBusy || _cartMutationSyncBusy;
            document.documentElement.classList.toggle('kinsora-free-gift-reconciling', busy);
            document.querySelectorAll(FREE_GIFT_BLOCKED_CHECKOUT_SELECTOR).forEach(function(control) {
                var checkoutLabel = control.querySelector && control.querySelector('.cart-checkout-btn__label');
                if (busy) {
                    if (control.getAttribute('data-kinsora-free-gift-busy') !== 'true') {
                        control.setAttribute('data-kinsora-free-gift-had-aria-disabled', control.hasAttribute('aria-disabled') ? 'true' : 'false');
                        control.setAttribute('data-kinsora-free-gift-prev-aria-disabled', control.getAttribute('aria-disabled') || '');
                        control.setAttribute('data-kinsora-free-gift-prev-pointer-events', control.style.pointerEvents || '');
                        if ('disabled' in control) {
                            control.setAttribute('data-kinsora-free-gift-was-disabled', control.disabled ? 'true' : 'false');
                        }
                    }
                    control.setAttribute('aria-disabled', 'true');
                    control.setAttribute('aria-busy', 'true');
                    control.setAttribute('data-kinsora-free-gift-busy', 'true');
                    control.style.pointerEvents = 'none';
                    if ('disabled' in control) control.disabled = true;
                    if (checkoutLabel && control.getAttribute('data-busy-label')) {
                        checkoutLabel.textContent = control.getAttribute('data-busy-label');
                    }
                } else if (control.getAttribute('data-kinsora-free-gift-busy') === 'true') {
                    if (control.getAttribute('data-kinsora-free-gift-had-aria-disabled') === 'true') {
                        control.setAttribute('aria-disabled', control.getAttribute('data-kinsora-free-gift-prev-aria-disabled') || 'true');
                    } else {
                        control.removeAttribute('aria-disabled');
                    }
                    control.style.pointerEvents = control.getAttribute('data-kinsora-free-gift-prev-pointer-events') || '';
                    if ('disabled' in control) {
                        control.disabled = control.getAttribute('data-kinsora-free-gift-was-disabled') === 'true';
                    }
                    if (checkoutLabel && control.getAttribute('data-ready-label')) {
                        checkoutLabel.textContent = control.getAttribute('data-ready-label');
                    }
                    control.removeAttribute('aria-busy');
                    control.removeAttribute('data-kinsora-free-gift-busy');
                    control.removeAttribute('data-kinsora-free-gift-had-aria-disabled');
                    control.removeAttribute('data-kinsora-free-gift-prev-aria-disabled');
                    control.removeAttribute('data-kinsora-free-gift-prev-pointer-events');
                    control.removeAttribute('data-kinsora-free-gift-was-disabled');
                }
            });
        }

        function setFreeGiftReconciliationBusy(busy) {
            if (busy) invalidatePassiveCartVerification();
            _fgControlsBusy = !!busy;
            applyCheckoutSynchronizationBusyState();
        }

        function setCartMutationSynchronizationBusy(busy) {
            if (busy) invalidatePassiveCartVerification();
            _cartMutationSyncBusy = !!busy;
            applyCheckoutSynchronizationBusyState();
        }

        function rememberCartMutationSynchronizationFailure(failed) {
            _cartMutationSyncFailed = !!failed;
            window.Kinsora.rewardSyncFailed = !!failed;
            document.dispatchEvent(new CustomEvent('kinsora:reward-state'));
            try {
                if (failed) window.sessionStorage.setItem(CART_MUTATION_SYNC_FAILURE_KEY, 'true');
                else window.sessionStorage.removeItem(CART_MUTATION_SYNC_FAILURE_KEY);
            } catch (storageError) {}
        }

        function pendingCheckoutSynchronization() {
            var pending = [];
            if (_cartMutationSyncPromise) pending.push(_cartMutationSyncPromise);
            if (_fgReconcilePromise && pending.indexOf(_fgReconcilePromise) === -1) {
                pending.push(_fgReconcilePromise);
            }
            return pending.length ? Promise.all(pending) : null;
        }

        function waitForFreeGiftReconciliation() {
            return _fgReconcilePromise || Promise.resolve();
        }

        function freeGiftCartEndpoint(path) {
            var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
            return root + String(path || '').replace(/^\//, '');
        }

        // Bound the response and its body. A timed-out write may still have committed.
        function withCartRequestDeadline(options, request) {
          var controller = new AbortController();
          var timer;
          var deadline = new Promise(function(resolve, reject) {
            timer = window.setTimeout(function() {
              var error = new Error('The cart request timed out. Please refresh and review your cart before trying again.');
              error.kinsoraCartRequestTimeout = true;
              var method = String(options && options.method || 'GET').toUpperCase();
              if (method !== 'GET' && method !== 'HEAD') error.kinsoraUnsafeCartState = true;
              reject(error);
              controller.abort();
            }, 15000);
          });
          return Promise.race([Promise.resolve().then(function() {
            return request(controller.signal);
          }), deadline]).finally(function() { window.clearTimeout(timer); });
        }

        function freeGiftFetchJson(path, options) {
            var requestOptions = options || {};
            requestOptions.credentials = 'same-origin';
            requestOptions.headers = requestOptions.headers || {};
            requestOptions.headers.Accept = 'application/json';
            return withCartRequestDeadline(requestOptions, function(signal) {
                return fetch(freeGiftCartEndpoint(path), Object.assign({}, requestOptions, {signal: signal})).then(function(response) {
                    if (!response.ok) {
                        return response.text().then(function(body) {
                            var error = new Error('[Free gift] ' + path + ' ' + response.status + ' -- ' + (body || '').slice(0, 200));
                            error.kinsoraCartResponseStatus = response.status;
                            error.kinsoraCartRequestPath = path;
                            throw error;
                        });
                    }
                    return response.json();
                });
            });
        }

        /**
         * Keep the complimentary gift authoritative after every cart mutation.
         * Both the cart drawer and the full cart page call this same Promise so a
         * line can never remain merely because one surface refreshed before the
         * automatic gift mutation finished.
         */
        function giftDiscountIsManagedByShopify() {
            return document.documentElement.dataset.setSalePrices === 'true';
        }

        function reconcileFreeGift(cart, options) {
            options = options || {};
            var drawer = document.getElementById('cartDrawer');
            if (!drawer || !cart || !cart.items) {
                return Promise.resolve({ cart: cart, changed: false, action: 'none' });
            }

            var giftThreshold = getRewardThresholdCents(drawer, 'gift');

            var eligibleCents = calcEligibleSubtotal(cart);
            var requiredRoles = requiredFreeGiftRoles(drawer);
            requiredRoles = requiredRoles.filter(function(role) {
                return giftRoleQualifies(role, eligibleCents, giftThreshold);
            });
            ['pouch', 'bracelet'].forEach(function(role) {
                if (requiredRoles.indexOf(role) === -1) _fgAutoTried[role] = false;
            });
            var giftReached = requiredRoles.length > 0;

            // Join an in-flight automatic add/remove before constructing another
            // fetch. Manual gift selection owns the same mutex, so wait for its
            // subsequent drawer refresh instead of racing it.
            if (_fgReconcilePromise) return _fgReconcilePromise;
            if (_fgBusy) return Promise.resolve({ cart: cart, changed: false, action: 'busy' });

            var action = 'none';
            var request;
            var markedGifts = cart.items.filter(hasFreeGiftMarker);
            var legacyUnmarkedGifts = findLegacyUnmarkedFreeGifts(cart);
            var existingByRole = {};
            var cleanupUpdates = {};
            var roleMigrations = [];
            var invalidPaidRoles = [];
            var invalidPaidVariantByRole = {};

            markedGifts.forEach(function(item) {
                var role = freeGiftRole(item);
                if (!giftReached || requiredRoles.indexOf(role) === -1 || existingByRole[role]) {
                    cleanupUpdates[item.key] = 0;
                    return;
                }
                existingByRole[role] = item;
                // Older marked rewards predate explicit roles. Preserve the
                // selected variant and all properties while making it canonical.
                if (!String(item.properties && item.properties[FREE_GIFT_ROLE_PROPERTY] || '')) {
                    roleMigrations.push({ item: item, role: role });
                }
                if (Number(item.final_line_price) !== 0 && !giftDiscountIsManagedByShopify()) {
                    cleanupUpdates[item.key] = 0;
                    invalidPaidRoles.push(role);
                    invalidPaidVariantByRole[role] = Number(item.variant_id) || autoFreeGiftVariantId(drawer, role);
                    _fgAutoTried[role] = true;
                } else if (Number(item.quantity) > 1) {
                    cleanupUpdates[item.key] = 1;
                }
            });
            // Previous theme versions could leave an unmarked $0 pouch. It is
            // never a canonical reward line and must not coexist with (or stand
            // in for) the marked pouch after migration.
            legacyUnmarkedGifts.forEach(function(item) {
                cleanupUpdates[item.key] = 0;
            });

            if (!giftReached && (markedGifts.length || legacyUnmarkedGifts.length)) {
                action = 'removed';
                var thresholdUpdates = {};
                markedGifts.forEach(function(item) { thresholdUpdates[item.key] = 0; });
                legacyUnmarkedGifts.forEach(function(item) { thresholdUpdates[item.key] = 0; });
                request = freeGiftFetchJson('cart/update.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ updates: thresholdUpdates })
                });
            } else if (Object.keys(cleanupUpdates).length) {
                action = invalidPaidRoles.length ? 'invalid-paid-gift-retrying' : 'duplicate-or-stale-gifts-removed';
                request = freeGiftFetchJson('cart/update.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ updates: cleanupUpdates })
                });
                if (invalidPaidRoles.length) {
                    // Shopify can move a BOGO allocation from the marked gift
                    // to newly added merchandise. Re-add the same selected gift
                    // once so the dedicated reward discount can settle at $0.
                    request = request.then(function() {
                        return freeGiftFetchJson('cart/add.js', {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify({
                                items: invalidPaidRoles.map(function(role) {
                                    var properties = {};
                                    properties[FREE_GIFT_PROPERTY] = FREE_GIFT_PROPERTY_VALUE;
                                    properties[FREE_GIFT_ROLE_PROPERTY] = role;
                                    return {
                                        id: invalidPaidVariantByRole[role],
                                        quantity: 1,
                                        properties: properties
                                    };
                                })
                            })
                        });
                    }).then(function() {
                        return freeGiftFetchJson('cart.js');
                    }).then(function(retriedCart) {
                        var retriedPaidUpdates = {};
                        var missingRetriedGift = false;
                        invalidPaidRoles.forEach(function(role) {
                            var retriedGift = findFreeGiftItemByRole(retriedCart, role);
                            if (!retriedGift) {
                                missingRetriedGift = true;
                            } else if (Number(retriedGift.final_line_price) !== 0 && !giftDiscountIsManagedByShopify()) {
                                retriedPaidUpdates[retriedGift.key] = 0;
                            }
                        });
                        if (missingRetriedGift || Object.keys(retriedPaidUpdates).length) {
                            action = 'invalid-paid-gift-removed';
                            window.Kinsora.freeGiftDiscountError = true;
                            if (Object.keys(retriedPaidUpdates).length) {
                                return freeGiftFetchJson('cart/update.js', {
                                    method: 'POST',
                                    headers: { 'Content-Type': 'application/json' },
                                    body: JSON.stringify({ updates: retriedPaidUpdates })
                                });
                            }
                            return retriedCart;
                        }
                        action = 'invalid-paid-gift-restored';
                        return retriedCart;
                    });
                }
            } else if (roleMigrations.length) {
                action = 'legacy-gift-roles-migrated';
                request = roleMigrations.reduce(function(previous, migration) {
                    return previous.then(function() {
                        var properties = Object.assign({}, migration.item.properties);
                        properties[FREE_GIFT_ROLE_PROPERTY] = migration.role;
                        return freeGiftFetchJson('cart/change.js', {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify({ id: migration.item.key, quantity: 1, properties: properties })
                        });
                    });
                }, Promise.resolve(cart));
            } else if (giftReached) {
                var missingRoles = requiredRoles.filter(function(role) {
                    return !existingByRole[role] && !_fgAutoTried[role] && autoFreeGiftVariantId(drawer, role, options.useFreshInventory);
                });
                if (!missingRoles.length) {
                    return Promise.resolve({ cart: cart, changed: false, action: 'none' });
                }
                action = 'added';
                missingRoles.forEach(function(role) { _fgAutoTried[role] = true; });
                request = Promise.resolve(cart);
                request = request.then(function() {
                    return freeGiftFetchJson('cart/add.js', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({
                            items: missingRoles.map(function(role) {
                                var properties = {};
                                properties[FREE_GIFT_PROPERTY] = FREE_GIFT_PROPERTY_VALUE;
                                properties[FREE_GIFT_ROLE_PROPERTY] = role;
                                return {
                                    id: autoFreeGiftVariantId(drawer, role, options.useFreshInventory),
                                    quantity: 1,
                                    properties: properties
                                };
                            })
                        })
                    });
                }).then(function() {
                    return freeGiftFetchJson('cart.js');
                }).then(function(updatedCart) {
                    var missingAfterNominalAdd = missingRoles.filter(function(role) {
                        return !findFreeGiftItemByRole(updatedCart, role);
                    });
                    if (!missingAfterNominalAdd.length) return updatedCart;
                    // A partial/nominally successful multi-add must not be hidden
                    // forever by `_fgAutoTried`. Retry only the missing role once;
                    // the verification step below owns the final fail-closed state.
                    return freeGiftFetchJson('cart/add.js', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({
                            items: missingAfterNominalAdd.map(function(role) {
                                var properties = {};
                                properties[FREE_GIFT_PROPERTY] = FREE_GIFT_PROPERTY_VALUE;
                                properties[FREE_GIFT_ROLE_PROPERTY] = role;
                                return {
                                    id: autoFreeGiftVariantId(drawer, role, options.useFreshInventory),
                                    quantity: 1,
                                    properties: properties
                                };
                            })
                        })
                    }).then(function() {
                        return freeGiftFetchJson('cart.js');
                    });
                }).then(function(updatedCart) {
                    var paidUpdates = {};
                    var missingAfterRetry = [];
                    missingRoles.forEach(function(role) {
                        var addedGift = findFreeGiftItemByRole(updatedCart, role);
                        if (!addedGift) {
                            missingAfterRetry.push(role);
                        } else if (Number(addedGift.final_line_price) !== 0 && !giftDiscountIsManagedByShopify()) {
                            paidUpdates[addedGift.key] = 0;
                        }
                    });
                    if (missingAfterRetry.length || Object.keys(paidUpdates).length) {
                        action = missingAfterRetry.length ? 'missing-gift-after-retry' : 'invalid-paid-gift-removed';
                        window.Kinsora.freeGiftDiscountError = true;
                        if (Object.keys(paidUpdates).length) {
                            return freeGiftFetchJson('cart/update.js', {
                                method: 'POST',
                                headers: { 'Content-Type': 'application/json' },
                                body: JSON.stringify({ updates: paidUpdates })
                            });
                        }
                        return updatedCart;
                    }
                    return updatedCart;
                });
            } else {
                if (!giftReached && window.Kinsora.freeGiftNotice && window.Kinsora.freeGiftNotice.type === 'threshold') {
                    window.Kinsora.freeGiftNotice.remainingCents = Math.max(giftThreshold - eligibleCents, 0);
                } else if (!giftReached && window.Kinsora.freeGiftNotice && window.Kinsora.freeGiftNotice.type === 'error') {
                    window.Kinsora.freeGiftDiscountError = false;
                    window.Kinsora.freeGiftNotice = null;
                } else if (giftReached && window.Kinsora.freeGiftNotice && window.Kinsora.freeGiftNotice.type === 'threshold') {
                    window.Kinsora.freeGiftNotice = null;
                }
                return Promise.resolve({ cart: cart, changed: false, action: 'none' });
            }

            _fgBusy = true;
            setFreeGiftReconciliationBusy(true);
            _fgReconcilePromise = request.then(function(updatedCart) {
                var result = {
                    cart: updatedCart,
                    changed: true,
                    action: action,
                    source: options.source || 'unknown'
                };
                _fgBusy = false;
                _fgReconcilePromise = null;
                setFreeGiftReconciliationBusy(false);
                if (action === 'removed') {
                    window.Kinsora.freeGiftDiscountError = false;
                    window.Kinsora.freeGiftNotice = {
                        type: 'threshold',
                        remainingCents: Math.max(giftThreshold - eligibleCents, 0)
                    };
                } else if (action === 'added') {
                    requiredRoles.forEach(function(role) { _fgAutoTried[role] = false; });
                    window.Kinsora.freeGiftDiscountError = false;
                    window.Kinsora.freeGiftNotice = null;
                } else if (action === 'invalid-paid-gift-restored') {
                    invalidPaidRoles.forEach(function(role) { _fgAutoTried[role] = false; });
                    window.Kinsora.freeGiftDiscountError = false;
                    window.Kinsora.freeGiftNotice = null;
                } else if (action === 'invalid-paid-gift-removed' || action === 'missing-gift-after-retry') {
                    window.Kinsora.freeGiftNotice = { type: 'error' };
                }
                if (action === 'invalid-paid-gift-removed' || action === 'missing-gift-after-retry') {
                    showCartToast(action === 'missing-gift-after-retry'
                        ? 'A bonus gift could not be added. Please refresh and try again.'
                        : 'A reward was removed because Shopify did not discount it to $0. You weren\'t charged.');
                }
                return result;
            }, function(error) {
                if (invalidPaidRoles.length) {
                    invalidPaidRoles.forEach(function(role) { _fgAutoTried[role] = false; });
                } else if (action === 'added') {
                    requiredRoles.forEach(function(role) { _fgAutoTried[role] = false; });
                }
                _fgBusy = false;
                _fgReconcilePromise = null;
                setFreeGiftReconciliationBusy(false);
                throw error;
            });
            return _fgReconcilePromise;
        }

        function canonicalFreeGiftCartIsVerified(cart) {
            var drawer = document.getElementById('cartDrawer');
            if (!drawer || !cart || !Array.isArray(cart.items)) return false;
            var pouchEnabled = drawer.dataset.enableFreeGift === 'true';
            var braceletEnabled = drawer.dataset.enableFreeBracelet === 'true';
            var requiredRoles = requiredFreeGiftRoles(drawer);
            if ((pouchEnabled && requiredRoles.indexOf('pouch') === -1)
                || (braceletEnabled && requiredRoles.indexOf('bracelet') === -1)) {
                return false;
            }
            var threshold = getRewardThresholdCents(drawer, 'gift');
            var eligibleCents = calcEligibleSubtotal(cart);
            requiredRoles = requiredRoles.filter(function(role) {
                return giftRoleQualifies(role, eligibleCents, threshold);
            });
            var markedItems = cart.items.filter(hasFreeGiftMarker);
            if (findLegacyUnmarkedFreeGifts(cart).length) return false;
            function strictRole(item) {
                var role = String(item && item.properties && item.properties[FREE_GIFT_ROLE_PROPERTY] || '').toLowerCase();
                if (role !== 'pouch' && role !== 'bracelet') return '';
                return isConfiguredFreeGiftVariant(item, role) ? role : '';
            }
            if (markedItems.some(function(item) {
                var role = strictRole(item);
                return !role || requiredRoles.indexOf(role) === -1;
            })) return false;

            if (markedItems.length !== requiredRoles.length) return false;

            return requiredRoles.every(function(role) {
                var matches = markedItems.filter(function(item) { return strictRole(item) === role; });
                return matches.length === 1
                    && Number(matches[0].quantity) === 1
                    && (Number(matches[0].final_line_price) === 0 || giftDiscountIsManagedByShopify());
            });
        }

        function serverRenderedCartPromotionsAreVerified() {
            var drawer = document.getElementById('cartDrawer');
            if (!drawer
                || !drawer.hasAttribute('data-bogo-pending-count')
                || !drawer.hasAttribute('data-curated-overcharge-count')) return false;
            var pendingBogoPairs = Number(drawer.dataset.bogoPendingCount);
            var curatedOvercharges = Number(drawer.dataset.curatedOverchargeCount);
            return isFinite(pendingBogoPairs) && pendingBogoPairs === 0
                && isFinite(curatedOvercharges) && curatedOvercharges === 0;
        }

        function cartLineFingerprint(cart) {
            if (!cart || !Array.isArray(cart.items)) return null;
            var propertyNames = [
                '_kinsora_free_gift',
                '_kinsora_free_gift_role',
                '_kinsora_bundle_piece_count',
                '_kinsora_bundle_origin',
                '_kinsora_bundle_role',
                '_kinsora_cart_unit',
                '_kinsora_bogo_pair',
                '_kinsora_express_unit'
            ];
            var tuples = cart.items.map(function(item) {
                var properties = item && item.properties || {};
                return [
                    String(item && item.key || ''),
                    Number(item && (item.variant_id || item.id) || 0),
                    Number(item && item.quantity || 0),
                    Number(item && item.original_line_price || 0),
                    Number(item && item.final_line_price || 0)
                ].concat(propertyNames.map(function(name) {
                    var value = properties[name];
                    return value == null || value === false ? '' : String(value);
                }));
            });
            tuples.sort(function(a, b) {
                return a[0] < b[0] ? -1 : a[0] > b[0] ? 1 : 0;
            });
            return JSON.stringify(tuples);
        }

        function serverRenderedCartMatches(cart) {
            var drawer = document.getElementById('cartDrawer');
            if (!drawer || !cart
                || !drawer.hasAttribute('data-current-total')
                || !drawer.hasAttribute('data-cart-item-count')
                || !drawer.hasAttribute('data-cart-line-fingerprint')) return false;
            return Number(drawer.dataset.currentTotal) === Number(cart.total_price)
                && Number(drawer.dataset.cartItemCount) === Number(cart.item_count)
                && drawer.getAttribute('data-cart-line-fingerprint') === cartLineFingerprint(cart);
        }

        function waitForCanonicalRenderedPromotions(attempt) {
            if (serverRenderedCartPromotionsAreVerified()) return Promise.resolve();
            if (attempt >= 3) {
                return Promise.reject(new Error('The advertised BOGO or curated-set price could not be verified.'));
            }
            return new Promise(function(resolve) {
                window.setTimeout(resolve, 250 + (attempt * 250));
            }).then(function() {
                return refreshCartDrawer({ strict: true });
            }).then(function() {
                return waitForCanonicalRenderedPromotions(attempt + 1);
            });
        }

        function synchronizeCartAfterPaidMutation(attempt, freshCart) {
            attempt = attempt || 0;
            var inventoryRecoveryUsed = false;
            // One reconciliation pass can intentionally perform only cleanup
            // (for example, remove a duplicate pouch). Re-read and reconcile a
            // bounded number of times so a simultaneously missing bracelet is
            // added before checkout is allowed to unlock.
            function reconcileUntilCanonical(cart, pass) {
                return reconcileFreeGift(cart, { source: 'paid-cart-mutation-' + pass, useFreshInventory: inventoryRecoveryUsed })
                    .catch(function(error) {
                        if (inventoryRecoveryUsed || !error || error.kinsoraUnsafeCartState
                            || error.kinsoraCartResponseStatus !== 422
                            || error.kinsoraCartRequestPath !== 'cart/add.js') throw error;
                        inventoryRecoveryUsed = true;
                        return freeGiftFetchJson('cart.js').then(function(currentCart) {
                            return refreshCartDrawer({ strict: true, cart: currentCart }).then(function() {
                                return reconcileFreeGift(currentCart, {
                                    source: 'gift-inventory-recovery', useFreshInventory: true
                                });
                            });
                        });
                    })
                    .then(function(result) {
                        if (result && result.action === 'busy') {
                            throw new Error('The complimentary gift coordinator is busy.');
                        }
                        return Promise.resolve(waitForFreeGiftReconciliation()).then(function() {
                            if (result && result.cart && Array.isArray(result.cart.items)) {
                                return result.cart;
                            }
                            return freeGiftFetchJson('cart.js');
                        });
                    })
                    .then(function(updatedCart) {
                        if (canonicalFreeGiftCartIsVerified(updatedCart) || pass >= 2) return updatedCart;
                        return reconcileUntilCanonical(updatedCart, pass + 1);
                    });
            }

            var initialCart = attempt === 0 && freshCart && Array.isArray(freshCart.items)
                ? Promise.resolve(freshCart)
                : freeGiftFetchJson('cart.js');
            return initialCart
                .then(function(cart) { return reconcileUntilCanonical(cart, 0); })
                .then(function(cart) {
                    if (!canonicalFreeGiftCartIsVerified(cart)) {
                        throw new Error('The complimentary gifts could not be verified.');
                    }
                    return Promise.resolve(refreshCartDrawer({ strict: true, cart: cart }))
                        .then(function() { return waitForCanonicalRenderedPromotions(0); })
                        .then(function() { return cart; });
                })
                .then(function(cart) {
                    if (!canonicalFreeGiftCartIsVerified(cart)
                        || !serverRenderedCartPromotionsAreVerified()
                        || !serverRenderedCartMatches(cart)) {
                        // Discounts can settle between the JSON read and section
                        // render. Re-read and verify both without replaying the
                        // shopper's mutation or releasing the checkout lock.
                        if (attempt < 2) {
                            return new Promise(function(resolve) {
                                window.setTimeout(resolve, 250 * (attempt + 1));
                            }).then(function() {
                                return synchronizeCartAfterPaidMutation(attempt + 1);
                            });
                        }
                        throw new Error('The final cart failed promotion or complimentary-gift verification.');
                    }
                    rememberPassiveCartVerification(cart);
                    return cart;
                });
        }

        /**
         * Serialize any paid cart write behind reward reconciliation, lock every
         * checkout surface before the write starts, and resolve only after a
         * fresh canonical cart plus refreshed drawer both verify. PDP modules,
         * drawer upsells, quantity controls, and the full cart page share this
         * gate so none can expose a stale checkout snapshot.
         */
        function runSynchronizedPaidCartMutation(operation) {
            if (typeof operation !== 'function') {
                return Promise.reject(new Error('A cart mutation operation is required.'));
            }
            if (document.body.classList.contains('kinsora-expressing')) {
                var expressAttempt = window.Kinsora && window.Kinsora._expressAttempt;
                // The legacy regular-PDP handler lives in this same runtime and
                // calls the gate directly (without the head readiness helper).
                // Bind its operation only while the intentional primary click
                // is synchronously dispatching; later callers cannot claim it.
                if (expressAttempt
                    && expressAttempt.primaryClickDispatching === true
                    && expressAttempt.gateBypassAvailable === true
                    && !expressAttempt.gateBypassOperation) {
                    expressAttempt.gateBypassOperation = operation;
                }
                if (expressAttempt
                    && expressAttempt.gateBypassAvailable === true
                    && expressAttempt.gateBypassConsumed !== true
                    && expressAttempt.gateBypassOperation === operation) {
                    expressAttempt.gateBypassConsumed = true;
                    expressAttempt.gateBypassAvailable = false;
                    expressAttempt.gateBypassOperation = null;
                    return Promise.resolve().then(operation);
                }
                return Promise.reject(new Error('Express checkout is already processing another cart action.'));
            }

            var previousSynchronizationFailed = _cartMutationSyncFailed;
            var precedingSynchronization = pendingCheckoutSynchronization();
            var paidMutationStarted = false;
            var paidMutationSucceeded = false;
            var operationFailureVerified = false;
            _cartMutationSyncFailed = false;
            setCartMutationSynchronizationBusy(true);

            var flow = Promise.resolve(precedingSynchronization || waitForFreeGiftReconciliation())
                .catch(function() { /* this new mutation gets one chance to repair the cart */ })
                .then(function() {
                    paidMutationStarted = true;
                    return operation();
                })
                .then(function(operationCart) {
                    paidMutationSucceeded = true;
                    // The paid write is in the cart. Let the ATC button and
                    // drawer move on now; gift reconciliation and the strict
                    // drawer proof below keep checkout locked until they finish
                    // or fail, and must not keep the button spinning.
                    if (typeof operation.kinsoraOnCommitted === 'function') {
                        try {
                            operation.kinsoraOnCommitted(operationCart);
                        } catch (committedCallbackError) {
                            console.error('[Cart] post-add UI callback failed:', committedCallbackError);
                        }
                    }
                    if (operation.kinsoraDirectCheckout === true
                        && typeof operation.kinsoraVerifyDirectCheckout === 'function'
                        && canonicalFreeGiftCartIsVerified(operationCart)) {
                        try {
                            if (operation.kinsoraVerifyDirectCheckout(operationCart) === true) {
                                return operationCart;
                            }
                        } catch (verificationError) {}
                    }
                    return synchronizeCartAfterPaidMutation(0, operation.kinsoraReturnsFreshCart === true ? operationCart : null).then(function(cart) {
                        // Caller-specific merchandise proof belongs inside the lock.
                        if (typeof operation.kinsoraVerifyCanonicalCart === 'function') {
                            operation.kinsoraVerifyCanonicalCart(cart);
                        }
                        return cart;
                    });
                }, function(operationError) {
                    // A network error is ambiguous: Shopify may have committed
                    // the write before the response was lost. Re-read, repair,
                    // refresh, and verify the cart before deciding it is safe to
                    // release checkout. The caller still receives the original
                    // error so it never claims an unconfirmed add succeeded.
                    if (!operationError || (typeof operationError !== 'object' && typeof operationError !== 'function')) {
                        operationError = new Error(String(operationError || 'Cart mutation failed.'));
                    }
                    return synchronizeCartAfterPaidMutation().then(function(cart) {
                        operationError.kinsoraCanonicalCart = cart;
                        if (operationError.kinsoraUnsafeCartState) {
                            // Canonical discounts/gifts do not prove that an
                            // unresolved transactional replacement contains the
                            // shopper's intended merchandise. Keep checkout
                            // locked until a reload/retry resolves that state.
                            throw operationError;
                        }
                        operationFailureVerified = true;
                        operationError.kinsoraCartVerified = true;
                        throw operationError;
                    }, function(synchronizationError) {
                        synchronizationError.kinsoraOperationError = operationError;
                        throw synchronizationError;
                    });
                });
            _cartMutationSyncPromise = flow;

            return flow.then(function(cart) {
                if (_cartMutationSyncPromise === flow) {
                    _cartMutationSyncPromise = null;
                    rememberCartMutationSynchronizationFailure(false);
                    setCartMutationSynchronizationBusy(false);
                }
                return cart;
            }, function(error) {
                if (_cartMutationSyncPromise === flow) {
                    _cartMutationSyncPromise = null;
                    if (operationFailureVerified) {
                        // A fresh canonical repair supersedes any persisted
                        // failure from an earlier request.
                        rememberCartMutationSynchronizationFailure(false);
                        setCartMutationSynchronizationBusy(false);
                    } else if (paidMutationSucceeded || paidMutationStarted) {
                        rememberCartMutationSynchronizationFailure(true);
                        setCartMutationSynchronizationBusy(true);
                        refreshCartDrawer();
                    } else {
                        rememberCartMutationSynchronizationFailure(previousSynchronizationFailed);
                        setCartMutationSynchronizationBusy(previousSynchronizationFailed);
                    }
                }
                throw error;
            });
        }

        /**
         * Repair and verify reward state when the cart was created outside the
         * current page (new tab, app mutation, abandoned session, or reload).
         * Checkout stays locked until both the canonical cart and rendered
         * drawer are authoritative. A failure is persisted for reload recovery.
         */
        function ensureCanonicalGiftState(source) {
            if (_cartMutationSyncPromise) return _cartMutationSyncPromise;
            setCartMutationSynchronizationBusy(true);
            var initialCartFingerprint = null;
            function cartFingerprint(cart) {
                if (!cart || !Array.isArray(cart.items)) return null;
                return JSON.stringify({
                    itemCount: Number(cart.item_count),
                    totalPrice: Number(cart.total_price),
                    itemsSubtotalPrice: Number(cart.items_subtotal_price),
                    items: cart.items.map(function(item) {
                        return {
                            key: String(item && item.key || ''),
                            variantId: Number(item && item.variant_id),
                            quantity: Number(item && item.quantity),
                            originalLinePrice: Number(item && item.original_line_price),
                            finalLinePrice: Number(item && item.final_line_price),
                            properties: item && item.properties || {}
                        };
                    })
                });
            }
            var recovery = Promise.resolve(waitForFreeGiftReconciliation())
                .catch(function() { /* the canonical pass gets one repair attempt */ })
                .then(function() {
                    return freeGiftFetchJson('cart.js').then(function(cart) {
                        initialCartFingerprint = cartFingerprint(cart);
                        return cart;
                    }, function() {
                        // The canonical synchronizer performs its own fresh read;
                        // let that retry decide whether recovery can succeed.
                        initialCartFingerprint = null;
                    });
                })
                .then(function(cart) { return synchronizeCartAfterPaidMutation(0, cart); })
                .then(function(cart) {
                    var finalCartFingerprint = cartFingerprint(cart);
                    try {
                        Object.defineProperty(cart, '_kinsoraGiftStateChanged', {
                            value: initialCartFingerprint === null || finalCartFingerprint !== initialCartFingerprint,
                            configurable: true
                        });
                    } catch (propertyError) {
                        cart._kinsoraGiftStateChanged = initialCartFingerprint === null || finalCartFingerprint !== initialCartFingerprint;
                    }
                    return cart;
                });
            _cartMutationSyncPromise = recovery;
            return recovery.then(function(cart) {
                if (_cartMutationSyncPromise === recovery) {
                    _cartMutationSyncPromise = null;
                    rememberCartMutationSynchronizationFailure(false);
                    setCartMutationSynchronizationBusy(false);
                }
                return cart;
            }, function(error) {
                console.error('[Cart] canonical gift recovery failed (' + (source || 'unknown') + '):', error);
                if (_cartMutationSyncPromise === recovery) {
                    _cartMutationSyncPromise = null;
                    rememberCartMutationSynchronizationFailure(true);
                    setCartMutationSynchronizationBusy(true);
                }
                throw error;
            });
        }

        var _passiveCartVerificationPromise = null;
        var _passiveCartVerificationCart = null;
        var _passiveCartVerificationAt = 0;
        var _passiveCartVerificationGeneration = 0;
        var PASSIVE_CART_VERIFICATION_COALESCE_MS = 5000;

        function invalidatePassiveCartVerification() {
            _passiveCartVerificationGeneration = (_passiveCartVerificationGeneration || 0) + 1;
            _passiveCartVerificationCart = null;
            _passiveCartVerificationAt = 0;
            _passiveCartVerificationPromise = null;
        }

        function rememberPassiveCartVerification(cart) {
            if (!serverRenderedCartSnapshotIsVerified(cart)) return false;
            _passiveCartVerificationCart = cart;
            _passiveCartVerificationAt = Date.now();
            return true;
        }

        function cartPageMatchesAuthoritativeCart(cart) {
            var cartPage = document.querySelector('[data-cart-page]');
            return !cartPage || cartPage.getAttribute('data-cart-line-fingerprint') === cartLineFingerprint(cart);
        }

        function serverRenderedCartSnapshotIsVerified(cart) {
            return canonicalFreeGiftCartIsVerified(cart)
                && serverRenderedCartPromotionsAreVerified()
                && serverRenderedCartMatches(cart)
                && cartPageMatchesAuthoritativeCart(cart);
        }

        function updateCartSurfacesFromSnapshot(cart) {
            if (!cart || _cartMutationSyncBusy || _fgControlsBusy || _cartMutationSyncFailed
                || !serverRenderedCartSnapshotIsVerified(cart)) return cart;
            try { updateCartCount(getPaidCartCount(cart)); } catch(e) {}
            try { updateProgressBar(cart); } catch(e) {}
            try { initFreeGiftSelectors(); } catch(e) {}
            try { hideCartUpsellDuplicates(cart); } catch(e) {}
            try { syncUpsellPairOffer(); } catch(e) { console.error('[Cart] syncUpsellPairOffer', e); }
            return cart;
        }

        function verifyServerRenderedCartQuietly(source, options) {
            options = options || {};
            var now = Date.now();
            if (_cartMutationSyncPromise) return Promise.resolve(_cartMutationSyncPromise);
            if (_cartMutationSyncFailed) {
                return ensureCanonicalGiftState((source || 'passive-cart-check') + '-persisted-failure');
            }
            if (_fgControlsBusy || _fgReconcilePromise) return Promise.resolve(null);
            if (_passiveCartVerificationPromise) return _passiveCartVerificationPromise;
            if (_passiveCartVerificationCart
                && serverRenderedCartSnapshotIsVerified(_passiveCartVerificationCart)
                && (!options.force || now - _passiveCartVerificationAt < PASSIVE_CART_VERIFICATION_COALESCE_MS)) {
                return Promise.resolve(_passiveCartVerificationCart);
            }
            var verificationGeneration = _passiveCartVerificationGeneration;
            var request = freeGiftFetchJson('cart.js').then(function(cart) {
                if (_cartMutationSyncPromise) return Promise.resolve(_cartMutationSyncPromise);
                // A response begun before a cart/gift mutation cannot replace
                // the newer canonical snapshot or repaint its progress/count.
                if (verificationGeneration !== _passiveCartVerificationGeneration) return null;
                if (rememberPassiveCartVerification(cart)) return cart;
                return ensureCanonicalGiftState((source || 'passive-cart-check') + '-mismatch')
                    .then(function(repairedCart) {
                        return rememberPassiveCartVerification(repairedCart) ? repairedCart : null;
                    });
            }).catch(function(error) {
                if (verificationGeneration !== _passiveCartVerificationGeneration && !_cartMutationSyncFailed) return null;
                if (_cartMutationSyncFailed) throw error;
                console.warn('[Cart] passive verification could not complete (' + (source || 'unknown') + '):', error);
                return null;
            });
            _passiveCartVerificationPromise = request;
            return request.then(function(cart) {
                if (_passiveCartVerificationPromise === request) _passiveCartVerificationPromise = null;
                return cart;
            }, function(error) {
                if (_passiveCartVerificationPromise === request) _passiveCartVerificationPromise = null;
                throw error;
            });
        }

        function swapFreeGift(role, variantId) {
            if (role === 'pouch') return Promise.reject(new Error('Pouch color is selected automatically.'));
            var drawer = document.getElementById('cartDrawer');
            variantId = Number(variantId || 0);
            var roleEnabled = role === 'bracelet'
                ? drawer && drawer.dataset.enableFreeBracelet === 'true'
                : role === 'pouch' && drawer && drawer.dataset.enableFreeGift === 'true';
            if (!roleEnabled || configuredGiftIds(role).indexOf(variantId) === -1) {
                return Promise.reject(new Error('That gift is not an available reward option.'));
            }
            if (_cartMutationSyncPromise) {
                // A load-time verifier or paid cart write owns the canonical
                // snapshot. Queue the shopper's choice behind that owner so its
                // final read cannot observe the gift halfway through a swap.
                return Promise.resolve(_cartMutationSyncPromise)
                    .catch(function() { /* this choice gets one repair attempt */ })
                    .then(function() { return swapFreeGift(role, variantId); });
            }
            if (_fgReconcilePromise) {
                return Promise.resolve(_fgReconcilePromise)
                    .catch(function() { /* this choice gets one repair attempt */ })
                    .then(function() { return swapFreeGift(role, variantId); });
            }
            if (_fgBusy) return Promise.reject(new Error('A reward update is already in progress.'));

            _fgBusy = true;
            _fgAutoTried[role] = true;
            setFreeGiftReconciliationBusy(true);
            setCartMutationSynchronizationBusy(true);
            var previousVariantId = 0;
            var removedPrevious = false;

            function addMarkedGift(id) {
                var properties = {};
                properties[FREE_GIFT_PROPERTY] = FREE_GIFT_PROPERTY_VALUE;
                properties[FREE_GIFT_ROLE_PROPERTY] = role;
                return freeGiftFetchJson('cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ items: [{ id: id, quantity: 1, properties: properties }] })
                }).then(function() { return freeGiftFetchJson('cart.js'); });
            }

            // A failed replacement should never leave the shopper without the
            // bracelet they already had. Restore it only after confirming the
            // failed request did not actually leave another $0 bracelet behind.
            function restorePreviousGift() {
                if (!removedPrevious || !previousVariantId) return Promise.resolve();
                return freeGiftFetchJson('cart.js').then(function(cart) {
                    var current = findFreeGiftItemByRole(cart, role);
                    if (current && (Number(current.final_line_price) === 0 || giftDiscountIsManagedByShopify())) return cart;
                    var cleanup = current
                        ? freeGiftFetchJson('cart/change.js', {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify({ id: current.key, quantity: 0 })
                        })
                        : Promise.resolve(cart);
                    return cleanup.then(function() { return addMarkedGift(previousVariantId); });
                }).then(function(cart) {
                    var restored = findFreeGiftItemByRole(cart, role);
                    if (!restored || Number(restored.variant_id) !== previousVariantId || (Number(restored.final_line_price) !== 0 && !giftDiscountIsManagedByShopify())) {
                        if (restored) {
                            return freeGiftFetchJson('cart/change.js', {
                                method: 'POST',
                                headers: { 'Content-Type': 'application/json' },
                                body: JSON.stringify({ id: restored.key, quantity: 0 })
                            });
                        }
                        throw new Error('The previous gift could not be restored at $0.');
                    }
                    return cart;
                });
            }

            var request = freeGiftFetchJson('cart.js').then(function(cart) {
                var threshold = getRewardThresholdCents(drawer, 'gift');
                if (!giftRoleQualifies(role, calcEligibleSubtotal(cart), threshold)) {
                    throw new Error('The cart does not currently qualify for the free gifts.');
                }
                var current = findFreeGiftItemByRole(cart, role);
                if (current && Number(current.variant_id) === variantId && (Number(current.final_line_price) === 0 || giftDiscountIsManagedByShopify())) return cart;
                previousVariantId = current ? Number(current.variant_id) : 0;
                if (current) {
                    // Treat the removal as ambiguous as soon as it is sent. If
                    // Shopify commits but the response is lost, recovery must
                    // still restore the previous gift after an authoritative read.
                    removedPrevious = true;
                    return freeGiftFetchJson('cart/change.js', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ id: current.key, quantity: 0 })
                    });
                }
                return cart;
            }).then(function(cart) {
                var current = findFreeGiftItemByRole(cart, role);
                if (current && Number(current.variant_id) === variantId && (Number(current.final_line_price) === 0 || giftDiscountIsManagedByShopify())) return cart;
                return addMarkedGift(variantId);
            }).then(function(cart) {
                var selected = findFreeGiftItemByRole(cart, role);
                if (selected && Number(selected.variant_id) === variantId && (Number(selected.final_line_price) === 0 || giftDiscountIsManagedByShopify())) return cart;
                if (selected) {
                    return freeGiftFetchJson('cart/change.js', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ id: selected.key, quantity: 0 })
                    }).then(function() { throw new Error('Shopify did not discount that gift to $0.'); });
                }
                throw new Error('The selected gift could not be added.');
            });

            var mutationStage = request.then(function(cart) {
                setPreferredFreeGiftVariant(role, variantId);
                _fgAutoTried[role] = false;
                return { cart: cart, recovered: false, error: null };
            }, function(error) {
                // The add may have committed even if its follow-up cart read was
                // lost. Re-read before rolling back: if the requested $0 gift is
                // authoritative, recover as success so the PDP choice and cart
                // cannot disagree.
                return freeGiftFetchJson('cart.js').then(function(cart) {
                    var committed = findFreeGiftItemByRole(cart, role);
                    if (committed && Number(committed.variant_id) === variantId && Number(committed.final_line_price) === 0) {
                        setPreferredFreeGiftVariant(role, variantId);
                        _fgAutoTried[role] = false;
                        return { recovered: true, cart: cart };
                    }
                    return restorePreviousGift().then(function(restoredCart) {
                        return { recovered: false, cart: restoredCart };
                    });
                }, function() {
                    return restorePreviousGift().then(function(restoredCart) {
                        return { recovered: false, cart: restoredCart };
                    });
                }).catch(function(restoreError) {
                    console.warn('[Free gift] gift choice rollback failed:', restoreError);
                    return { recovered: false, cart: null, rollbackFailed: true, error: restoreError };
                }).then(function(outcome) {
                    if (outcome.recovered) {
                        setPreferredFreeGiftVariant(role, variantId);
                        _fgAutoTried[role] = false;
                        return { cart: outcome.cart, recovered: true, error: null };
                    }
                    return {
                        cart: outcome.cart,
                        recovered: false,
                        error: outcome.rollbackFailed ? outcome.error : error
                    };
                });
            });
            _fgReconcilePromise = mutationStage;

            var verifiedFailure = false;
            var flow = mutationStage.then(function(outcome) {
                // Release only the low-level gift mutex. This flow retains the
                // shared cart owner and checkout lock through a strict drawer
                // render plus a final authoritative cart verification.
                _fgBusy = false;
                _fgReconcilePromise = null;
                _fgAutoTried[role] = false;
                setFreeGiftReconciliationBusy(false);
                return synchronizeCartAfterPaidMutation().then(function(cart) {
                    if (outcome.error) {
                        if (!outcome.error || (typeof outcome.error !== 'object' && typeof outcome.error !== 'function')) {
                            outcome.error = new Error(String(outcome.error || 'The gift choice could not be updated.'));
                        }
                        verifiedFailure = true;
                        outcome.error.kinsoraCartVerified = true;
                        outcome.error.kinsoraCanonicalCart = cart;
                        throw outcome.error;
                    }
                    return cart;
                });
            });
            _cartMutationSyncPromise = flow;

            return flow.then(function(cart) {
                if (_cartMutationSyncPromise === flow) {
                    _cartMutationSyncPromise = null;
                    rememberCartMutationSynchronizationFailure(false);
                    setCartMutationSynchronizationBusy(false);
                }
                return cart;
            }, function(error) {
                // A low-level swap failure can still leave a fully repaired,
                // verified cart. Preserve the shopper-facing error without
                // needlessly trapping checkout in that verified case.
                _fgBusy = false;
                if (_fgReconcilePromise === mutationStage) _fgReconcilePromise = null;
                _fgAutoTried[role] = false;
                setFreeGiftReconciliationBusy(false);
                if (_cartMutationSyncPromise === flow) {
                    _cartMutationSyncPromise = null;
                    rememberCartMutationSynchronizationFailure(!verifiedFailure);
                    setCartMutationSynchronizationBusy(!verifiedFailure);
                }
                throw error;
            });
        }

        function swapFreeBracelet(variantId) {
            return swapFreeGift('bracelet', variantId);
        }

        window.Kinsora.reconcileFreeGift = reconcileFreeGift;
        window.Kinsora.isFreeGiftItem = isFreeGiftItem;
        window.Kinsora.waitForFreeGiftReconciliation = waitForFreeGiftReconciliation;
        window.Kinsora.updateRedesignedReward = updateRedesignedReward;
        window.Kinsora.setPreferredFreeGiftVariant = setPreferredFreeGiftVariant;
        window.Kinsora.swapFreeGift = swapFreeGift;
        window.Kinsora.swapFreeBracelet = swapFreeBracelet;
        window.Kinsora.runSynchronizedPaidCartMutation = runSynchronizedPaidCartMutation;
        if (typeof window.Kinsora._resolveSynchronizedPaidCartMutationReady === 'function') {
            window.Kinsora._resolveSynchronizedPaidCartMutationReady(runSynchronizedPaidCartMutation);
            window.Kinsora._resolveSynchronizedPaidCartMutationReady = null;
        }
        window.Kinsora.ensureCanonicalGiftState = ensureCanonicalGiftState;
        window.Kinsora.verifyServerRenderedCartQuietly = verifyServerRenderedCartQuietly;
        window.Kinsora.cartLineFingerprint = cartLineFingerprint;
        window.Kinsora.isCanonicalFreeGiftCartVerified = canonicalFreeGiftCartIsVerified;

        if (_cartMutationSyncFailed) {
            setCartMutationSynchronizationBusy(true);
            window.setTimeout(function() {
                if (_cartMutationSyncPromise) return;
                verifyServerRenderedCartQuietly('persisted-load-failure', { force: true }).catch(function() {
                    showCartToast('Checkout is paused because a bonus gift could not be verified. Please try again.');
                });
            }, 0);
        }

        var _resumeCanonicalValidationPromise = null;
        function revalidateCanonicalCartAfterResume(source) {
            if (_resumeCanonicalValidationPromise) return _resumeCanonicalValidationPromise;
            var request = verifyServerRenderedCartQuietly(source || 'page-resume', { force: true });
            _resumeCanonicalValidationPromise = Promise.resolve(request).then(function(cart) {
                if (!cart) return cart;
                var cartPage = document.querySelector('[data-cart-page]');
                if (cartPage && cartPage.getAttribute('data-cart-line-fingerprint') !== cartLineFingerprint(cart)) {
                    setCartMutationSynchronizationBusy(true);
                    window.location.reload();
                    return cart;
                }
                return cart;
            });
            return _resumeCanonicalValidationPromise.then(function(cart) {
                _resumeCanonicalValidationPromise = null;
                return cart;
            }, function(error) {
                _resumeCanonicalValidationPromise = null;
                // ensureCanonicalGiftState persists and applies the failed lock.
                showCartToast('Checkout is paused because cart discounts or bonus gifts could not be verified. Please refresh and try again.');
                throw error;
            });
        }

        window.addEventListener('pageshow', function(event) {
            if (event.persisted) revalidateCanonicalCartAfterResume('bfcache-restore').catch(function() {});
        });
        window.addEventListener('focus', function() {
            revalidateCanonicalCartAfterResume('window-focus').catch(function() {});
        });
        document.addEventListener('visibilitychange', function() {
            if (!document.hidden) revalidateCanonicalCartAfterResume('document-visible').catch(function() {});
        });

        // Standard checkout links are queued behind the short gift mutation. The
        // accelerated checkout containers are disabled above until reconciliation
        // ends, preventing checkout from capturing a stale cart snapshot.
        document.addEventListener('click', function(event) {
            var pending = pendingCheckoutSynchronization();
            if (!pending && !_cartMutationSyncFailed) return;
            var target = event.target && event.target.closest
                ? event.target.closest(FREE_GIFT_BLOCKED_CHECKOUT_SELECTOR)
                : null;
            if (!target) return;
            event.preventDefault();
            event.stopImmediatePropagation();
            var link = target.closest && target.closest('a[href]');
            var href = link && link.href;
            if (_cartMutationSyncFailed) {
                showCartToast('Checkout is paused because a bonus gift could not be verified. Please refresh and try again.');
                return;
            }
            Promise.resolve(pending).then(function() {
                if (href) window.location.assign(href);
            }).catch(function() {
                showCartToast('Couldn\u2019t finish updating your bonus gift. Please try checkout again.');
            });
        }, true);

        /**
         * Format money in the active presentment currency.
         */
        function fgFormatMoney(cents) {
            return (window.Kinsora && window.Kinsora.formatMoney)
                ? window.Kinsora.formatMoney(cents)
                : (Number(cents || 0) / 100).toFixed(2);
        }

        /** Hydrate the server-rendered unified rewards card with market-safe values. */
        function updateCartRewardsGift(eligibleCents, giftThreshold) {
            var drawer = document.getElementById('cartDrawer');
            var reward = document.querySelector('[data-cart-rewards-gift]');
            if (!drawer || !reward) return;
            if (!isFinite(giftThreshold) || giftThreshold <= 0) {
                reward.style.visibility = 'hidden';
                return;
            }
            var reached = eligibleCents >= giftThreshold;
            var remaining = Math.max(giftThreshold - eligibleCents, 0);
            var fill = reward.querySelector('[data-cart-gift-fill]');
            var label = reward.querySelector('[data-cart-gift-label]');
            var away = reward.querySelector('[data-cart-gift-away]');
            if (fill) fill.style.width = Math.min((eligibleCents / giftThreshold) * 100, 100) + '%';
            if (label) {
                label.textContent = reached
                    ? (drawer.dataset.giftUnlockedCopy || 'Bonus travel pouch unlocked ✓')
                    : (drawer.dataset.giftAtCopy || 'Bonus travel pouch at __AMOUNT__').replace('__AMOUNT__', fgFormatMoney(giftThreshold));
                label.classList.toggle('cart-rewards__giftdone', reached);
            }
            if (away) {
                away.textContent = reached
                    ? ''
                    : (drawer.dataset.amountAwayCopy || '__AMOUNT__ away').replace('__AMOUNT__', fgFormatMoney(remaining));
            }
            reward.style.visibility = 'visible';
        }

        /**
         * Multi-milestone progress bar + free gift UI update.
         * Called after every cart change.
         */
        function updateProgressBar(cart) {
            updateRedesignedReward(cart);
            var wrapper = document.getElementById('pbWrapper');
            if (!wrapper) return;

            var drawer = document.getElementById('cartDrawer');
            if (!drawer) return;

            var enablePB = drawer.dataset.enableProgressBar === 'true';
            var enableGift = drawer.dataset.enableFreeGift === 'true';
            var enableShipping = drawer.dataset.enableFreeShipping === 'true';
            var giftThreshold = getRewardThresholdCents(drawer, 'gift');
            var shipThreshold = getRewardThresholdCents(drawer, 'shipping');
            var eligibleCents = calcEligibleSubtotal(cart);

            if (enableGift) updateCartRewardsGift(eligibleCents, giftThreshold);

            /* A missing foreign-currency conversion disables that reward in the
               UI instead of ever comparing a local subtotal with a USD value. */
            enableGift = enableGift && isFinite(giftThreshold) && giftThreshold > 0;
            enableShipping = enableShipping && isFinite(shipThreshold) && shipThreshold > 0;

            if (!enablePB || (!enableGift && !enableShipping)) {
                wrapper.classList.remove('pb-wrapper--visible');
                return;
            }

            if (!cart || cart.item_count === 0) {
                wrapper.classList.remove('pb-wrapper--visible');
                // Also hide selected summary and collapse dropdown
                var fgSel = document.getElementById('fgSelected');
                if (fgSel) fgSel.style.display = 'none';
                var fgDrop = document.getElementById('fgDropdown');
                if (fgDrop) fgDrop.classList.remove('fg-dropdown--open');
                return;
            }

            wrapper.classList.add('pb-wrapper--visible');

            // Determine bar max (the highest enabled threshold)
            var barMax = 0;
            if (enableGift && enableShipping) {
                barMax = Math.max(giftThreshold, shipThreshold);
            } else if (enableGift) {
                barMax = giftThreshold;
            } else {
                barMax = shipThreshold;
            }

            // Fill percentage
            var fill = document.getElementById('pbFill');
            if (fill && barMax > 0) {
                var pct = Math.min((eligibleCents / barMax) * 100, 100);
                fill.style.width = pct + '%';
                wrapper.setAttribute('aria-valuenow', Math.round(pct));
            }

            // Update diamond milestone markers
            var giftMarker = document.getElementById('pbMarkerGift');
            var shipMarker = document.getElementById('pbMarkerShip');
            var giftOK = enableGift && eligibleCents >= giftThreshold;
            var shipOK = enableShipping && eligibleCents >= shipThreshold;

            if (giftMarker) {
                if (giftOK) { giftMarker.classList.add('pb-marker--reached'); }
                else { giftMarker.classList.remove('pb-marker--reached'); }
            }
            if (shipMarker) {
                if (shipOK) { shipMarker.classList.add('pb-marker--reached'); }
                else { shipMarker.classList.remove('pb-marker--reached'); }
            }

            // ── New milestone-row UI: per-milestone status + headline + all-unlocked banner ──
            var unlockedLabel = drawer.dataset.pbUnlockedLabel || 'Unlocked';
            var toGoTemplate = drawer.dataset.pbToGoTemplate || '{{ amount }} to go';

            function setMilestoneStatus(rowId, statusId, isReached, gapCents) {
                var row = document.getElementById(rowId);
                var statusEl = document.getElementById(statusId);
                if (row) {
                    if (isReached) row.classList.add('pb-milestone--reached');
                    else row.classList.remove('pb-milestone--reached');
                }
                if (statusEl) {
                    if (isReached) {
                        statusEl.textContent = unlockedLabel;
                    } else {
                        var rem = fgFormatMoney(gapCents);
                        statusEl.textContent = toGoTemplate.replace('{{ amount }}', rem);
                    }
                }
            }

            // Combined-milestone mode: when gift + shipping unlock at the same
            // threshold, drive a single "FREE Gift + Shipping" row + marker and
            // skip the two-row logic below.
            if (drawer.dataset.pbCombined === 'true') {
                var comboThreshold = enableGift ? giftThreshold : shipThreshold;
                var comboOK = eligibleCents >= comboThreshold;
                var comboMarker = document.getElementById('pbMarkerCombo');
                if (comboMarker) {
                    if (comboOK) { comboMarker.classList.add('pb-marker--reached'); }
                    else { comboMarker.classList.remove('pb-marker--reached'); }
                }
                setMilestoneStatus('pbMilestoneCombo', 'pbMilestoneComboStatus', comboOK, comboThreshold - eligibleCents);
                var comboHeadline = document.getElementById('pbHeadline');
                if (comboOK) {
                    wrapper.classList.add('pb-wrapper--all-unlocked');
                    if (comboHeadline) { comboHeadline.textContent = '🎉 You unlocked a bonus gift + free shipping!'; }
                } else {
                    wrapper.classList.remove('pb-wrapper--all-unlocked');
                    if (comboHeadline) {
                        comboHeadline.textContent = 'Add ' + fgFormatMoney(comboThreshold - eligibleCents) + ' more for a bonus gift + free shipping';
                    }
                }
                return;
            }

            if (enableGift) {
                setMilestoneStatus('pbMilestoneGift', 'pbMilestoneGiftStatus', giftOK, giftThreshold - eligibleCents);
            }
            if (enableShipping) {
                setMilestoneStatus('pbMilestoneShip', 'pbMilestoneShipStatus', shipOK, shipThreshold - eligibleCents);
            }

            // Headline: closest unlocked goal, OR "all rewards unlocked" celebration
            var headline = document.getElementById('pbHeadline');
            var allUnlocked = (!enableGift || giftOK) && (!enableShipping || shipOK);

            if (allUnlocked) {
                wrapper.classList.add('pb-wrapper--all-unlocked');
                if (headline) {
                    headline.textContent = drawer.dataset.pbAllUnlockedMsg || '\uD83C\uDF89 You\'ve unlocked all rewards!';
                }
            } else {
                wrapper.classList.remove('pb-wrapper--all-unlocked');
                if (headline) {
                    var giftGap = (enableGift && !giftOK) ? (giftThreshold - eligibleCents) : Infinity;
                    var shipGap = (enableShipping && !shipOK) ? (shipThreshold - eligibleCents) : Infinity;
                    if (giftGap <= shipGap) {
                        var giftRem = fgFormatMoney(giftGap);
                        headline.textContent = (drawer.dataset.giftProgressMsg || 'Add {{ amount }} more to unlock a bonus gift!').replace('{{ amount }}', giftRem);
                    } else {
                        var shipRem = fgFormatMoney(shipGap);
                        var shipMsgText = (drawer.dataset.shippingProgressMsg || 'Add {{ amount }} more for FREE shipping!').replace('{{ amount }}', shipRem);
                        if (typeof cart !== 'undefined' && cart && cart.total_discount > 0 && typeof eligibleCents !== 'undefined' && typeof shipThreshold !== 'undefined') {
                            shipMsgText += ' (' + fgFormatMoney(eligibleCents) + ' of ' + fgFormatMoney(shipThreshold) + ' after your discount)';
                        }
                        headline.textContent = shipMsgText;
                    }
                }
            }

            // Free gift dropdown logic handled independently in refreshCartDrawer
        }

        /** Manage the free gift UI, then reconcile its cart line authoritatively. */
        function updateFreeGiftUI(cart, eligibleCents, giftThreshold) {
            var dropdown = document.getElementById('fgDropdown');
            if (dropdown) {
                dropdown.classList.remove('fg-dropdown--open');
                dropdown.setAttribute('aria-hidden', 'true');
            }

            if (canonicalFreeGiftCartIsVerified(cart)) return;
            ensureCanonicalGiftState('cart-drawer').catch(function(error) {
                console.error('[Free gift] reconciliation failed:', error);
                showCartToast('Checkout is paused because your bonus gifts could not be verified. Please refresh and try again.');
            });
        }

        /**
         * Handle free gift variant selector changes.
         */
        function initFreeGiftSelectors() {
            var dropdown = document.getElementById('fgDropdown');
            if (!dropdown) return;

            // Variant selectors — re-init after every HTML swap
            dropdown.querySelectorAll('.fg-product').forEach(function(productEl) {
                var dataEl = productEl.querySelector('.fg-product-data');
                if (!dataEl) return;
                var productData;
                try {
                    productData = JSON.parse(dataEl.textContent);
                } catch (e) { return; }

                var selects = productEl.querySelectorAll('.fg-variant-select');
                var selectBtn = productEl.querySelector('.fg-select-btn');
                var imgEl = productEl.querySelector('.cart-upsell-img');

                // Pre-select first available variant (also swaps image if that variant has one)
                preSelectFirstAvailable(productData, selects, selectBtn, imgEl);

                // On option change, find matching variant + swap image
                selects.forEach(function(sel) {
                    sel.addEventListener('change', function() {
                        onFgOptionChange(productData, selects, selectBtn, imgEl);
                    });
                });
            });
        }

        // ── Delegated click handler (survives HTML swaps) ──
        (function() {
            document.addEventListener('click', function(e) {
                // "Add" button on free gift product card
                var addBtn = e.target.closest('.fg-select-btn');
                if (addBtn) {
                    e.preventDefault();
                    var variantId = addBtn.dataset.variantId;
                    if (!variantId || addBtn.disabled) return;
                    selectFreeGift(parseInt(variantId, 10));
                    return;
                }

                // (Change/Remove buttons removed — gift is a normal line item now)
            });
        })();

        function setFgCardImage(imgEl, variant, productData) {
            if (!imgEl) return;
            // Prefer the variant's own featured_image; fall back to product-level featured_image
            var src = (variant && variant.featured_image) || (productData && productData.featured_image);
            if (src && imgEl.getAttribute('src') !== src) {
                imgEl.setAttribute('src', src);
            }
        }

        function preSelectFirstAvailable(productData, selects, selectBtn, imgEl) {
            if (!productData.variants || productData.variants.length === 0) return;
            // Find first available variant
            var firstAvail = null;
            for (var i = 0; i < productData.variants.length; i++) {
                if (productData.variants[i].available) {
                    firstAvail = productData.variants[i];
                    break;
                }
            }
            if (firstAvail && selects.length > 0) {
                if (selects[0] && firstAvail.option1) selects[0].value = firstAvail.option1;
                if (selects[1] && firstAvail.option2) selects[1].value = firstAvail.option2;
                if (selects[2] && firstAvail.option3) selects[2].value = firstAvail.option3;
            }
            if (firstAvail && selectBtn) {
                selectBtn.dataset.variantId = firstAvail.id;
                selectBtn.disabled = false;
                selectBtn.textContent = 'Add';
            } else if (selectBtn) {
                selectBtn.disabled = true;
                selectBtn.textContent = 'Unavailable';
            }
            // Swap the card image to match the selected variant (if it has its own image)
            setFgCardImage(imgEl, firstAvail, productData);
        }

        function onFgOptionChange(productData, selects, selectBtn, imgEl) {
            var selectedOptions = [];
            selects.forEach(function(s) { selectedOptions.push(s.value); });

            var matchingVariant = null;
            for (var i = 0; i < productData.variants.length; i++) {
                var v = productData.variants[i];
                var match = v.option1 === selectedOptions[0];
                if (selectedOptions.length >= 2) match = match && v.option2 === selectedOptions[1];
                if (selectedOptions.length >= 3) match = match && v.option3 === selectedOptions[2];
                if (match) { matchingVariant = v; break; }
            }

            if (matchingVariant && matchingVariant.available) {
                selectBtn.disabled = false;
                selectBtn.dataset.variantId = matchingVariant.id;
                selectBtn.textContent = 'Add';
            } else {
                selectBtn.disabled = true;
                selectBtn.dataset.variantId = '';
                selectBtn.textContent = 'Unavailable';
            }
            // Swap the card image to match the selected variant (if it has its own image)
            setFgCardImage(imgEl, matchingVariant, productData);
        }

        /**
         * Add a free gift variant to the cart (removing any existing one first).
         */
        function selectFreeGift(variantId) {
            // Mutex prevents double-clicks during the in-flight add. The previous
            // implementation also scheduled `_fgBusy = false` 5s later — that
            // would stomp a legitimate later operation that had set the flag,
            // letting two adds race. Drop the timer; trust the in-flight
            // handler's then/catch to release the mutex.
            if (_fgBusy) return;
            _fgBusy = true;
            setFreeGiftReconciliationBusy(true);

            // Instant UI feedback — disable buttons and collapse the picker
            var allBtns = document.querySelectorAll('.fg-select-btn');
            allBtns.forEach(function(b) { b.disabled = true; b.classList.add('fg-select-btn--loading'); });
            var dd = document.getElementById('fgDropdown');
            if (dd) { dd.classList.remove('fg-dropdown--open'); dd.setAttribute('aria-hidden', 'true'); }

            // Add the free gift directly — no need to fetch /cart.js first since
            // updateFreeGiftUI already confirmed no marked gift exists when the
            // picker is visible. The private property keeps this automatic reward
            // separate from a Travel Pouch the customer intentionally purchases.
            var manualGiftRequest = freeGiftFetchJson('cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    items: [{
                        id: variantId,
                        quantity: 1,
                        properties: {
                            _kinsora_free_gift: FREE_GIFT_PROPERTY_VALUE,
                            _kinsora_free_gift_role: 'pouch'
                        }
                    }]
                })
            }).then(function() {
                return freeGiftFetchJson('cart.js');
            }).then(function(cart) {
                var selected = findFreeGiftItemByRole(cart, 'pouch');
                if (selected && Number(selected.variant_id) === Number(variantId) && Number(selected.final_line_price) === 0) {
                    return cart;
                }
                if (selected) {
                    return freeGiftFetchJson('cart/change.js', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ id: selected.key, quantity: 0 })
                    }).then(function() { throw new Error('Shopify did not discount that gift to $0.'); });
                }
                throw new Error('The selected gift could not be added.');
            });

            _fgReconcilePromise = manualGiftRequest.then(function(cart) {
                return Promise.resolve(refreshCartDrawer()).then(function() {
                    _fgBusy = false;
                    _fgReconcilePromise = null;
                    setFreeGiftReconciliationBusy(false);
                    return { cart: cart, changed: true, action: 'selected', source: 'gift-picker' };
                });
            }, function(err) {
                return Promise.resolve(refreshCartDrawer()).then(function() {
                    _fgBusy = false;
                    _fgReconcilePromise = null;
                    setFreeGiftReconciliationBusy(false);
                    console.error('[Free gift] manual selection failed:', err);
                    showCartToast('Couldn\u2019t add bonus gift. Please try again.');
                    throw err;
                });
            });
            _fgReconcilePromise.catch(function() {});
        }

        /**
         * Remove the free gift from the cart.
         */
        function removeFreeGiftFromCart() {
            if (_fgBusy) return;
            _fgBusy = true;
            setFreeGiftReconciliationBusy(true);
            var removal = fetch(freeGiftCartEndpoint('cart.js'), { credentials: 'same-origin' })
                .then(function(r) { return r.json(); })
                .then(function(cart) {
                    var existing = findFreeGiftItem(cart);
                    if (existing) {
                        return fetch(freeGiftCartEndpoint('cart/change.js'), {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify({ id: existing.key, quantity: 0 })
                        }).then(function(r) { return r.json(); });
                    }
                })
                .then(function() { return refreshCartDrawer(); });
            _fgReconcilePromise = removal.then(function() {
                _fgBusy = false;
                _fgReconcilePromise = null;
                setFreeGiftReconciliationBusy(false);
            }, function(error) {
                return Promise.resolve(refreshCartDrawer()).then(function() {
                    _fgBusy = false;
                    _fgReconcilePromise = null;
                    setFreeGiftReconciliationBusy(false);
                    throw error;
                });
            });
            _fgReconcilePromise.catch(function() {});
        }

        /* === FREE GIFT + MULTI-MILESTONE PROGRESS BAR — JS END === */

        /**
         * Hide upsell cards for products already in the cart.
         */
        function hideCartUpsellDuplicates(cart) {
            var upsellsContainer = document.getElementById('cartUpsells');
            if (!upsellsContainer) return;

            // Hide the entire upsells section when the cart is empty
            if (!cart || !cart.items || cart.item_count === 0) {
                upsellsContainer.style.display = 'none';
                return;
            }

            // Always show upsells section when cart has items
            upsellsContainer.style.display = '';

            var upsellCards = upsellsContainer.querySelectorAll('.cart-upsell-card');
            if (!upsellCards.length) return;

            // Build a set of product handles currently in the cart
            var cartHandles = {};
            cart.items.forEach(function(item) {
                cartHandles[item.handle] = true;
                if (Array.isArray(item.item_components)) {
                    item.item_components.forEach(function(component) {
                        if (component && component.handle) cartHandles[component.handle] = true;
                    });
                }
            });
            var drawer = document.getElementById('cartDrawer');
            var renderedHandles = drawer ? String(drawer.getAttribute('data-cart-handles') || '').split('|') : [];
            renderedHandles.forEach(function(handle) {
                if (handle) cartHandles[handle] = true;
            });

            // Show/hide each upsell card based on whether its handle is in the cart
            var visibleCount = 0;
            upsellCards.forEach(function(card) {
                var handle = card.dataset.handle;
                if (handle && cartHandles[handle]) {
                    card.style.display = 'none';
                } else {
                    card.style.display = '';
                    visibleCount++;
                }
            });

            // Hide the heading if no upsell cards are visible
            var upsellTitle = upsellsContainer.querySelector('.cart-upsells-title');
            if (visibleCount === 0) {
                if (upsellTitle) upsellTitle.style.display = 'none';
            } else {
                if (upsellTitle) upsellTitle.style.display = '';
            }
        }

        function addUpsellToCart(handle, name, price, btnEl) {
            // Prevent double-click
            if (btnEl.classList.contains('added')) return;
            btnEl.textContent = 'Adding…';
            btnEl.disabled = true;

            // Use the variant ID already rendered in the Liquid template (data-variant-id)
            // to skip an extra /products/{handle}.js fetch
            var variantId = btnEl.dataset.variantId;
            if (!variantId) {
                showCartToast('Couldn\u2019t add item. Please try again.');
                btnEl.textContent = 'Add';
                btnEl.disabled = false;
                return;
            }

            // The free gift can be auto-added immediately after the first paid
            // product crosses its threshold. Serialize this upsell add behind
            // that mutation; two simultaneous /cart/add.js writes can otherwise
            // race and leave the recommendation button saying "Added" even
            // though only the complimentary gift reached the cart.
            runSynchronizedPaidCartMutation(function() {
                    return fetch(freeGiftCartEndpoint('cart/add.js'), {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                        body: JSON.stringify({ items: [{
                            id: parseInt(variantId, 10),
                            quantity: 1,
                            properties: { _kinsora_cart_unit: 'upsell-' + Date.now() + '-' + Math.random().toString(36).slice(2, 9) }
                        }] })
                    }).then(function(r) {
                    if (!r.ok) {
                        return r.text().then(function(body) {
                            console.error('[Cart] /cart/add.js (upsell) ' + r.status + ' -- ' + body.slice(0, 300));
                            throw new Error('Cart add failed: ' + r.status);
                        });
                    }
                    return r.json();
                })
            })
                .then(function() {
                    btnEl.textContent = 'Added';
                    btnEl.classList.add('added');
                })
                .catch(function(err) {
                    console.error('[Cart] addUpsellToCart catch:', err);
                    showCartToast('Couldn\u2019t add item. Please try again.');
                    btnEl.textContent = 'Add';
                    btnEl.disabled = false;
                });
        }

        function scrollUpsellPair(dot) {
            var container = document.getElementById('cartUpsells');
            var list = container && container.querySelector('#cartUpsellList');
            if (!list || !dot) return;
            var pairIndex = parseInt(dot.getAttribute('data-pair-index'), 10) || 0;
            var cards = Array.prototype.filter.call(container.querySelectorAll('.cart-upsell-card'), function(card) {
                return card.style.display !== 'none' && !card.hidden;
            });
            var target = cards[pairIndex * 2];
            if (!target) return;
            list.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
        }

        function syncUpsellPairOffer() {
            var container = document.getElementById('cartUpsells');
            if (!container) return;
            var list = container.querySelector('#cartUpsellList');
            var dots = container.querySelector('[data-upsell-pair-dots]');
            var offer = container.querySelector('[data-upsell-pair-offer]');
            var cards = Array.prototype.filter.call(container.querySelectorAll('.cart-upsell-card'), function(card) {
                return card.style.display !== 'none' && !card.hidden;
            });
            if (!list || !cards.length) {
                if (dots) dots.hidden = true;
                if (offer) offer.classList.remove('is-ready');
                return;
            }
            if (list.getAttribute('data-pair-sync-bound') !== 'true') {
                list.setAttribute('data-pair-sync-bound', 'true');
                list.addEventListener('scroll', function() {
                    if (list.__kinsoraPairSyncFrame) {
                        window.cancelAnimationFrame(list.__kinsoraPairSyncFrame);
                    }
                    list.__kinsoraPairSyncFrame = window.requestAnimationFrame(syncUpsellPairOffer);
                }, { passive: true });
            }

            var firstIndex = 0;
            var closestDistance = Infinity;
            for (var cardIndex = 0; cardIndex < cards.length; cardIndex += 2) {
                var distance = Math.abs(cards[cardIndex].offsetLeft - list.scrollLeft);
                if (distance < closestDistance) {
                    closestDistance = distance;
                    firstIndex = cardIndex;
                }
            }
            var activePair = Math.floor(firstIndex / 2);
            var pairCount = Math.ceil(cards.length / 2);

            if (dots) {
                dots.hidden = pairCount <= 1;
                if (dots.children.length !== pairCount) {
                    dots.textContent = '';
                    for (var pairIndex = 0; pairIndex < pairCount; pairIndex += 1) {
                        var dot = document.createElement('button');
                        dot.type = 'button';
                        dot.className = 'cart-upsell-dot';
                        dot.setAttribute('data-action', 'select-upsell-pair');
                        dot.setAttribute('data-pair-index', String(pairIndex));
                        dot.setAttribute('aria-label', 'Show recommendation pair ' + (pairIndex + 1) + ' of ' + pairCount);
                        dots.appendChild(dot);
                    }
                }
                Array.prototype.forEach.call(dots.children, function(dot, dotIndex) {
                    var isActive = dotIndex === activePair;
                    dot.classList.toggle('is-active', isActive);
                    if (isActive) {
                        dot.setAttribute('aria-current', 'true');
                    } else {
                        dot.removeAttribute('aria-current');
                    }
                });
            }

            if (!offer) return;
            var first = cards[firstIndex];
            var second = cards[firstIndex + 1];
            if (!first || !second) {
                offer.classList.remove('is-ready');
                return;
            }
            var firstPrice = parseInt(first.getAttribute('data-price-cents'), 10) || 0;
            var secondPrice = parseInt(second.getAttribute('data-price-cents'), 10) || 0;
            var firstVariant = first.getAttribute('data-variant-id');
            var secondVariant = second.getAttribute('data-variant-id');
            if (!firstVariant || !secondVariant || firstPrice <= 0 || secondPrice <= 0) {
                offer.classList.remove('is-ready');
                return;
            }
            var regular = firstPrice + secondPrice;
            var pay = Math.max(firstPrice, secondPrice);
            var save = Math.min(firstPrice, secondPrice);
            var money = function(cents) {
                return window.Kinsora && typeof window.Kinsora.formatMoney === 'function'
                    ? window.Kinsora.formatMoney(cents)
                    : '$' + (cents / 100).toFixed(2);
            };
            var compare = offer.querySelector('[data-upsell-pair-compare]');
            var payEl = offer.querySelector('[data-upsell-pair-pay]');
            var saveEl = offer.querySelector('[data-upsell-pair-save]');
            var button = offer.querySelector('[data-upsell-pair-add]');
            if (compare) compare.textContent = money(regular);
            if (payEl) payEl.textContent = money(pay);
            if (saveEl) saveEl.textContent = 'Save ' + money(save);
            if (button) {
                button.setAttribute('data-variant-ids', firstVariant + ',' + secondVariant);
                button.textContent = 'Add both · ' + money(pay);
            }
            offer.classList.add('is-ready');
        }

        function addUpsellPairToCart(btnEl) {
            if (!btnEl || btnEl.disabled || btnEl.classList.contains('added')) return;
            var ids = String(btnEl.getAttribute('data-variant-ids') || '')
                .split(',')
                .map(function(id) { return parseInt(id, 10); })
                .filter(function(id) { return id > 0; });
            if (ids.length !== 2 || ids[0] === ids[1]) {
                showCartToast('Couldn\u2019t add this pair. Please choose the products individually.');
                return;
            }
            var originalLabel = btnEl.textContent;
            btnEl.disabled = true;
            btnEl.textContent = 'Adding pair…';
            runSynchronizedPaidCartMutation(function() {
                    var pairSerial = 'pair-' + Date.now() + '-' + Math.random().toString(36).slice(2, 9);
                    return fetch(freeGiftCartEndpoint('cart/add.js'), {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                        body: JSON.stringify({ items: ids.map(function(id, index) {
                            return { id: id, quantity: 1, properties: { _kinsora_cart_unit: pairSerial + '-' + index } };
                        }) })
                    }).then(function(response) {
                    if (!response.ok) {
                        return response.text().then(function(body) {
                            console.error('[Cart] /cart/add.js (pair) ' + response.status + ' -- ' + body.slice(0, 300));
                            throw new Error('Pair add failed: ' + response.status);
                        });
                    }
                    return response.json();
                })
            })
                .then(function() {
                    btnEl.classList.add('added');
                    btnEl.textContent = 'Pair added';
                })
                .catch(function(error) {
                    console.error('[Cart] addUpsellPairToCart catch:', error);
                    showCartToast('Couldn\u2019t add both products. Please try again.');
                    btnEl.disabled = false;
                    btnEl.textContent = originalLabel;
                });
        }

        function addToCart() {
            // Bundle PDPs override the add-to-cart flow via kinsora-bundle-init.js.
            // That script also sets window.Kinsora.isBundlePDP at script-execute
            // time (before DOMContentLoaded). If a click sneaks through the
            // document-level delegation before bundle-init has cloned + rebound
            // the button, bail here so we don't fire a silent no-op against the
            // bundle product's virtual variant.
            if (window.Kinsora && window.Kinsora.isBundlePDP) {
                console.warn('[Cart] addToCart called on bundle PDP -- bundle-init owns this flow');
                return;
            }
            var itemsToAdd = [];
            var atcBtn = document.querySelector('.add-to-cart');

            // Helper: get the variant ID from a wrapper — prefers user-selected variant (from pills),
            // falls back to the product's default variantId
            function getWrapperVariantId(w) {
                if (w.dataset.variantId) return parseInt(w.dataset.variantId);
                var idx = parseInt(w.dataset.selected);
                var type = w.dataset.type;
                var opts = type === 'necklace' ? getNecklaceOptions() : getPendantOptions();
                return (opts[idx] && opts[idx].variantId) ? opts[idx].variantId : null;
            }

            if (currentMode === 'necklace') {
                // Solo mode — add the main product variant
                var variantInput = document.getElementById('variantIdInput');
                if (variantInput && variantInput.value) {
                    itemsToAdd.push({ id: parseInt(variantInput.value), quantity: 1 });
                }

                // Add each upsell companion (pendant OR necklace) via its selected variant
                var soloAtcContainer = document.getElementById('necklacePendantItems');
                var soloAtcCompanion = (soloAtcContainer && soloAtcContainer.getAttribute('data-companion-type')) || 'pendant';
                document.querySelectorAll('#necklacePendantItems .dropdown-wrapper[data-type="' + soloAtcCompanion + '"]').forEach(function(w) {
                    var vid = getWrapperVariantId(w);
                    if (vid) itemsToAdd.push({ id: vid, quantity: 1 });
                });
            } else {
                // Build a Stack mode — add the locked base product (current PDP)
                var baseWrapper = document.querySelector('#buildStackMode .dropdown-wrapper[data-base-locked="true"]');
                if (baseWrapper) {
                    // Use the page's main product variant (kept in sync with metal/length swatches)
                    var variantInputBase = document.getElementById('variantIdInput');
                    var baseVid = variantInputBase && variantInputBase.value ? parseInt(variantInputBase.value) : null;
                    if (!baseVid) baseVid = parseInt(baseWrapper.getAttribute('data-variant-id'));
                    if (baseVid) itemsToAdd.push({ id: baseVid, quantity: 1 });
                }

                // All non-locked necklace wrappers anywhere in buildStackMode
                // (covers the open-base picker on stack-only template + every
                // secondary necklace card). Unpicked empty wrappers return a
                // null variantId from getWrapperVariantId and are skipped.
                document.querySelectorAll('#buildStackMode .dropdown-wrapper[data-type="necklace"]:not(.dropdown-wrapper--locked)').forEach(function(w) {
                    var vid = getWrapperVariantId(w);
                    if (vid) itemsToAdd.push({ id: vid, quantity: 1 });
                });

                // Pendants
                document.querySelectorAll('#pendantItems .dropdown-wrapper[data-type="pendant"]').forEach(function(w) {
                    var vid = getWrapperVariantId(w);
                    if (vid) itemsToAdd.push({ id: vid, quantity: 1 });
                });
            }

            if (itemsToAdd.length === 0) return;
            var cartUnitSerial = Date.now() + '-' + Math.random().toString(36).slice(2, 9);
            itemsToAdd.forEach(function(item, index) {
                item.properties = Object.assign({}, item.properties || {}, {
                    _kinsora_cart_unit: cartUnitSerial + '-' + index
                });
            });

            // Visual feedback while adding
            if (atcBtn) {
                atcBtn.textContent = 'ADDING…';
                atcBtn.disabled = true;
            }

            var expressOwnsCheckout = document.body.classList.contains('kinsora-expressing');
            var paidAddSucceeded = false;
            var atcUiSettled = false;
            function settleAtcUi(success) {
                if (atcUiSettled) return;
                atcUiSettled = true;
                if (!success) {
                    if (atcBtn) {
                        atcBtn.textContent = atcBtn.dataset.addText || 'Add To Cart';
                        atcBtn.disabled = false;
                    }
                    return;
                }
                // Express checkout opens the drawer from its own finalizer.
                // Every other add can show the cart as soon as the line commits.
                // Gift checks keep checkout locked and must not hold this button.
                if (!expressOwnsCheckout) openCart({ skipVerification: true });
                if (atcBtn) {
                    atcBtn.textContent = 'ADDED!';
                    setTimeout(function() {
                        if (!atcBtn.isConnected) return;
                        atcBtn.textContent = atcBtn.dataset.addText || 'Add To Cart';
                        atcBtn.disabled = false;
                    }, 1200);
                }
            }
            function addedUnitLanded(cart) {
                return !!(cart && Array.isArray(cart.items) && cart.items.some(function(item) {
                    var unit = item && item.properties && item.properties._kinsora_cart_unit;
                    return unit && String(unit).indexOf(cartUnitSerial) === 0;
                }));
            }
            var paidAddOperation = function() {
                return withCartRequestDeadline({ method: 'POST' }, function(signal) {
                    return fetch(freeGiftCartEndpoint('cart/add.js'), {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                        body: JSON.stringify({ items: itemsToAdd }),
                        signal: signal
                    }).then(function(response) {
                        if (!response.ok) {
                            // Log Shopify's error JSON so the customer can see WHY
                            // (sold-out variant, inventory mismatch, and similar).
                            return response.text().then(function(body) {
                                console.error('[Cart] /cart/add.js ' + response.status + ' -- ' + body.slice(0, 300));
                                throw new Error('Cart add failed: ' + response.status);
                            });
                        }
                        return response.json();
                    });
                }).catch(function(err) {
                    // The write can commit even when the response is lost.
                    // Confirm the line, then release the button. Do not retry
                    // the add.
                    if (!err || !err.kinsoraCartRequestTimeout) throw err;
                    return freeGiftFetchJson('cart.js').then(function(cart) {
                        if (!addedUnitLanded(cart)) throw err;
                        paidAddSucceeded = true;
                        return cart;
                    });
                }).then(function(data) {
                    paidAddSucceeded = true;
                    return data;
                });
            };
            paidAddOperation.kinsoraOnCommitted = function() {
                if (expressOwnsCheckout) return;
                settleAtcUi(true);
            };
            var paidMutationFlow = runSynchronizedPaidCartMutation(paidAddOperation)
            .then(function(data) {
                // Express checkout owns its own finalizer. Every other add
                // already opened the drawer when the line committed; this
                // covers a gate that resolved without the committed callback.
                settleAtcUi(true);
                if (expressOwnsCheckout) {
                    openCart();
                    refreshCartDrawer();
                }
                return data;
            });

            paidMutationFlow.then(function() {
                settleAtcUi(true);
            }, function(err) {
                console.error('[Cart] addToCart catch:', err);
                if (!expressOwnsCheckout && err && err.kinsoraCartVerified) {
                    if (!atcUiSettled) openCart({ skipVerification: true });
                    showCartToast('Your cart was rechecked after a connection issue. Please review it before continuing.');
                } else if (!expressOwnsCheckout && (paidAddSucceeded || atcUiSettled)) {
                    if (!atcUiSettled) openCart({ skipVerification: true });
                    showCartToast('Your item was added, but the bonus gifts could not be verified. Please try again.');
                } else if (!atcUiSettled) {
                    showCartToast('Couldn\u2019t add to cart. Please try again.');
                }
                if (!atcUiSettled) settleAtcUi(false);
            });
        }

        /**
         * Remove a line item by its Shopify cart line key.
         */
        var _cartRemovalBusy = false;
        function setCartRemovalBusy(busy) {
            _cartRemovalBusy = busy;
            var drawer = document.getElementById('cartDrawer');
            if (!drawer) return;

            if (busy) drawer.setAttribute('aria-busy', 'true');
            else drawer.removeAttribute('aria-busy');

            // A tier-safe removal can proceed without a confirmation. Until
            // Shopify returns the new cart and the drawer has re-rendered, the
            // piece counts in this DOM are stale. Briefly lock every item
            // mutation control so a rapid second tap cannot bypass a warning
            // that is required by the newly reduced cart.
            drawer.querySelectorAll(
                '[data-action="remove-cart-item"], ' +
                '[data-action="cart-quantity-minus"], ' +
                '[data-action="cart-quantity-plus"]'
            ).forEach(function(control) {
                control.disabled = busy;
                if (busy) control.setAttribute('aria-disabled', 'true');
                else control.removeAttribute('aria-disabled');
            });
        }

        function removeFromCart(lineKey) {
            if (_cartRemovalBusy) return Promise.resolve();
            setCartRemovalBusy(true);

            return runSynchronizedPaidCartMutation(function() {
                return fetch(freeGiftCartEndpoint('cart/change.js'), {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ id: lineKey, quantity: 0 })
                }).then(function(r) {
                    if (!r.ok) {
                        return r.text().then(function(body) {
                            console.error('[Cart] /cart/change.js (remove) ' + r.status + ' -- ' + body.slice(0, 300));
                            throw new Error('Remove failed: ' + r.status);
                        });
                    }
                    return r.json();
                });
            })
            .catch(function(err) {
                console.error('[Cart] removeFromCart catch:', err);
                showCartToast('Couldn\u2019t remove item. Please try again.');
                return refreshCartDrawer();
            })
            .then(function() {
                setCartRemovalBusy(false);
            });
        }

        /**
         * Increase or decrease quantity for a line item by its Shopify cart line key.
         */
        var _cartMutationChain = Promise.resolve();
        function queueCartMutation(task) {
            var run = _cartMutationChain.then(task, task);
            _cartMutationChain = run.catch(function() {});
            return run;
        }

        var _cartQuantityBusy = false;
        window.Kinsora.isCartQuantityPending = function() { return _cartQuantityBusy; };
        function updateQty(lineKey, delta, control) {
            var redesignRuntime = window.KinsoraCartRedesign;
            if (_cartQuantityBusy || _cartRemovalBusy || _cartMutationSyncBusy || _fgControlsBusy || _fgBusy
                || (redesignRuntime && typeof redesignRuntime.isMutationBusy === 'function' && redesignRuntime.isMutationBusy())
                || (control && (control.disabled || !control.isConnected))) return Promise.resolve(null);
            // Resolve the clicked row, including defensive split-unit rows that
            // share a Shopify source key. Detached controls never enqueue work.
            var itemEl = control && control.closest('[data-ks-cart-line], .cart-item');
            if (!itemEl) itemEl = document.querySelector('[data-cart-item-key="' + lineKey + '"]');
            if (!itemEl || !itemEl.isConnected || itemEl.getAttribute('data-cart-item-key') !== lineKey) return Promise.resolve(null);
            var qtyEl = itemEl ? itemEl.querySelector('.cart-qty-value') : null;
            var currentQty = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
            var newQty = currentQty + delta;
            if (newQty < 1) newQty = 0; // 0 removes the item
            var addAsSplitBogoUnit = delta > 0 && itemEl && itemEl.dataset.bogoEligible === 'true';
            var decrementSyntheticUnit = delta < 0 && itemEl && itemEl.dataset.syntheticSplitUnit === 'true';

            if (!isFinite(currentQty) || currentQty < 1) return Promise.resolve(null);
            // Capture the focused action before disabling it can move focus.
            if (redesignRuntime && typeof redesignRuntime.captureMutationView === 'function') redesignRuntime.captureMutationView();
            // Lock synchronously, before the promise queue starts. Keep the
            // canonical count visible while the specific clicked button works.
            _cartQuantityBusy = true;
            var originalControl = control ? {
                html: control.innerHTML,
                disabled: control.disabled,
                busy: control.getAttribute('aria-busy'),
                ariaDisabled: control.getAttribute('aria-disabled')
            } : null;
            if (control) {
                control.disabled = true;
                control.setAttribute('aria-busy', 'true');
                control.setAttribute('aria-disabled', 'true');
                control.innerHTML = '<span class="ks-cart-busy-spinner" aria-hidden="true"></span><span class="visually-hidden">Updating quantity</span>';
            }
            function finishQuantity() {
                _cartQuantityBusy = false;
                if (control && originalControl && control.isConnected) {
                    control.innerHTML = originalControl.html;
                    control.disabled = originalControl.disabled;
                    if (originalControl.busy === null) control.removeAttribute('aria-busy');
                    else control.setAttribute('aria-busy', originalControl.busy);
                    if (originalControl.ariaDisabled === null) control.removeAttribute('aria-disabled');
                    else control.setAttribute('aria-disabled', originalControl.ariaDisabled);
                }
                try {
                    var currentRedesign = window.KinsoraCartRedesign;
                    if (currentRedesign && typeof currentRedesign.hydrateOptions === 'function') currentRedesign.hydrateOptions();
                } catch (optionError) {
                    console.error('[Cart] quantity option refresh:', optionError);
                }
            }

            return queueCartMutation(function() {
                return runSynchronizedPaidCartMutation(function() {
                        if (decrementSyntheticUnit) {
                            // A defensive mixed paid/free renderer can show one
                            // Shopify quantity line as one-unit rows. Decrement the
                            // authoritative source quantity, never the faux visible 1.
                            return _safeFetchJson(freeGiftCartEndpoint('cart.js')).then(function(cart) {
                                var sourceLine = cart && cart.items && cart.items.filter(function(item) { return item.key === lineKey; })[0];
                                if (!sourceLine) throw new Error('Quantity source line no longer exists');
                                var targetQuantity = Math.max((Number(sourceLine.quantity) || 0) - 1, 0);
                                return fetch(freeGiftCartEndpoint('cart/change.js'), {
                                    method: 'POST',
                                    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                                    body: JSON.stringify({ id: lineKey, quantity: targetQuantity })
                                }).then(function(response) {
                                    if (!response.ok) {
                                        return response.text().then(function(body) {
                                            throw new Error('Qty update failed: ' + response.status + ' -- ' + body.slice(0, 200));
                                        });
                                    }
                                    return response.json();
                                });
                            });
                        }

                        if (!addAsSplitBogoUnit) {
                            return fetch(freeGiftCartEndpoint('cart/change.js'), {
                                method: 'POST',
                                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                                body: JSON.stringify({ id: lineKey, quantity: newQty })
                            }).then(function(response) {
                                if (!response.ok) {
                                    return response.text().then(function(body) {
                                        throw new Error('Qty update failed: ' + response.status + ' -- ' + body.slice(0, 200));
                                    });
                                }
                                return response.json();
                            });
                        }

                        // Keep eligible units on separate Shopify lines. A merged
                        // quantity can contain one paid and one free unit, which is
                        // impossible to represent or pair reliably as one cart row.
                        return _safeFetchJson(freeGiftCartEndpoint('cart.js')).then(function(cart) {
                            var sourceLine = cart && cart.items && cart.items.filter(function(item) { return item.key === lineKey; })[0];
                            if (!sourceLine) throw new Error('Quantity source line no longer exists');
                            var properties = Object.assign({}, sourceLine.properties || {});
                            delete properties[FREE_GIFT_PROPERTY];
                            properties._kinsora_cart_unit = 'qty-' + Date.now() + '-' + Math.random().toString(36).slice(2, 9);
                            var payload = {
                                id: Number(sourceLine.variant_id),
                                quantity: 1,
                                properties: properties
                            };
                            if (sourceLine.selling_plan_allocation && sourceLine.selling_plan_allocation.selling_plan) {
                                payload.selling_plan = Number(sourceLine.selling_plan_allocation.selling_plan.id);
                            }
                            return fetch(freeGiftCartEndpoint('cart/add.js'), {
                                method: 'POST',
                                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                                body: JSON.stringify({ items: [payload] })
                            }).then(function(response) {
                                if (!response.ok) {
                                    return response.text().then(function(body) {
                                        throw new Error('Qty add failed: ' + response.status + ' -- ' + body.slice(0, 200));
                                    });
                                }
                                // The shared mutation gate reads and verifies the final cart next.
                            });
                        });
                    });
            })
            .then(function(cart) {
                // Reconcile the stepper with the quantity Shopify actually accepted.
                // If the line is stock-capped, the server clamps below what was
                // requested — show the true number (not the optimistic one) and tell
                // the shopper why, so a low-stock item doesn't silently snap back.
                if (cart && cart.items && qtyEl) {
                    var serverLine = null;
                    for (var i = 0; i < cart.items.length; i++) {
                        if (cart.items[i].key === lineKey) { serverLine = cart.items[i]; break; }
                    }
                    if (serverLine && !addAsSplitBogoUnit && !decrementSyntheticUnit) {
                        qtyEl.textContent = serverLine.quantity;
                        if (delta > 0 && serverLine.quantity < newQty) {
                            showCartToast('That’s all we have in stock right now.');
                        }
                    } else if (addAsSplitBogoUnit || decrementSyntheticUnit) qtyEl.textContent = currentQty;
                }
                // Cheap authoritative bits update instantly (count + progress);
                // the shared mutation gate has already completed the heavy
                // authoritative drawer refresh before this callback runs.
                try { updateCartCount(getPaidCartCount(cart)); } catch(e) {}
                try { updateProgressBar(cart); } catch(e) {}
            })
            .catch(function(err) {
                console.error('[Cart] updateQty catch:', err);
                showCartToast('Couldn\u2019t update quantity. Please try again.');
                return refreshCartDrawer();
            }).then(function(cart) {
                finishQuantity();
                return cart;
            }, function(error) {
                finishQuantity();
                throw error;
            });
        }

        // ── BOGO free-item guard ─────────────────────────────────────────
        // Warn only when a removal reduces the number of free items. Removing
        // 3→2 leaves one free item and proceeds immediately; removing 2→1
        // changes one free item to zero and receives confirmation.
        function bogoFreeCount(n) { return Math.floor(Math.max(0, n) / 3) * 2; }
        function clearTierWarn() {
            var open = document.querySelector('#cartDrawer .tier-warn');
            if (open) {
                var li = open.closest('.cart-item');
                if (li) li.classList.remove('has-tier-warn');
                open.remove();
            }
        }
        function revealTierWarn(warning) {
            var body = warning ? warning.closest('.cart-drawer-body') : null;
            if (!warning || !body) return;

            // Wait for the newly appended warning to finish expanding its cart
            // line before measuring. Only scroll when some part of the warning
            // would otherwise sit outside the drawer's visible body (the footer
            // is a separate flex child, so body.bottom is its safe upper edge).
            requestAnimationFrame(function () {
                requestAnimationFrame(function () {
                    if (!warning.isConnected || !body.isConnected) return;
                    var warningRect = warning.getBoundingClientRect();
                    var bodyRect = body.getBoundingClientRect();
                    var inset = 12;
                    var visibleTop = bodyRect.top + inset;
                    var visibleBottom = bodyRect.bottom - inset;
                    if (warningRect.top >= visibleTop && warningRect.bottom <= visibleBottom) return;

                    var delta;
                    if (warningRect.height > visibleBottom - visibleTop || warningRect.top < visibleTop) {
                        delta = warningRect.top - visibleTop;
                    } else {
                        delta = warningRect.bottom - visibleBottom;
                    }
                    var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
                    try {
                        body.scrollBy({ top: delta, behavior: reducedMotion ? 'auto' : 'smooth' });
                    } catch (e) {
                        body.scrollTop += delta;
                    }
                });
            });
        }
        function showTierWarn(lineEl, fromFree, toFree, proceed) {
            clearTierWarn(); // only one warning open at a time
            if (!lineEl) { proceed(); return; }
            var w = document.createElement('div');
            w.className = 'tier-warn';
            w.setAttribute('role', 'alert');
            var drawer = document.getElementById('cartDrawer');
            var warningTemplate = drawer ? drawer.getAttribute('data-tier-warning') : '';
            var removeLabel = drawer ? drawer.getAttribute('data-tier-remove') : '';
            var keepLabel = drawer ? drawer.getAttribute('data-tier-keep') : '';
            var warningText = (warningTemplate || 'Heads up, removing this changes your BOGO reward from __FROM__ free item(s) to __TO__.')
                .replace('__FROM__', String(fromFree))
                .replace('__TO__', String(toFree));
            w.innerHTML =
                '<p class="tier-warn__msg">' + warningText + '</p>' +
                '<div class="tier-warn__actions">' +
                  '<button type="button" class="tier-warn__go">' + (removeLabel || 'Remove anyway') + '</button>' +
                  '<button type="button" class="tier-warn__keep">' + (keepLabel || 'Keep it') + '</button>' +
                '</div>';
            lineEl.classList.add('has-tier-warn');
            lineEl.appendChild(w);
            w.querySelector('.tier-warn__keep').addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); clearTierWarn(); });
            w.querySelector('.tier-warn__go').addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); clearTierWarn(); proceed(); });
            revealTierWarn(w);
        }
        // Gate a remove ('remove') or single decrement ('minus'). Non-eligible
        // lines and removals that preserve the number of free items pass through.
        function tierGate(lineEl, type, proceed) {
            if (_cartRemovalBusy) return;
            clearChainConfirm();
            proceed();
}

        // ── Feature 1: "pendant needs a chain" nudge ──────────────────────
        // The offer CARD is server-rendered in cart-drawer.liquid whenever the cart
        // has >=1 pendant and 0 chains. JS owns: dismissing it for the session, and
        // The slot never shows a second BOGO success banner after adding a chain;
        // the free line price, pair-complete nudge, savings row, and checkout
        // confirmation already communicate the completed offer.
        var CHAIN_NUDGE_DISMISS_KEY = 'kinsora_chainNudgeDismissed';
        function chainNudgeDismissed() {
            try { return sessionStorage.getItem(CHAIN_NUDGE_DISMISS_KEY) === '1'; } catch (e) { return false; }
        }
        function clearChainConfirm() {
            if (window.Kinsora) window.Kinsora._chainUnlockPct = null;
            var c = document.querySelector('#cartDrawer [data-chain-confirm]');
            if (c) c.remove();
        }
        // Reconcile the nudge slot with session + confirmation state. Runs on load
        // and after every drawer re-render.
        function syncChainNudge() {
            var slot = document.querySelector('#cartDrawer [data-chain-nudge-slot]');
            if (!slot) return;
            if (chainNudgeDismissed()) {              // dismissed this session → never re-show the offer
                var card = slot.querySelector('[data-chain-nudge]');
                if (card) card.remove();
            }
            var freeTotal = window.Kinsora && window.Kinsora._chainUnlockPct;
            if (freeTotal) {
                clearChainConfirm();
            }
            initChainPicker();                         // default the style + fill the length dropdown
        }
        // Add the chain from the nudge. If the add crosses a tier boundary, arm the
        // confirmation so it appears after the re-render; at 40% there's no boundary
        // to cross → no confirmation, just a normal cart update.
        // Fill the length dropdown from the selected style's data-variants
        // ("{id}:{label}|..."). Hides the dropdown for single-length chains — the
        // lone variant still lives in the <select> so "add" can read it.
        function populateChainSize(styleEl) {
            var card = styleEl && styleEl.closest('[data-chain-nudge]'); if (!card) return;
            var sel = card.querySelector('[data-chain-size]'); if (!sel) return;
            var opts = (styleEl.getAttribute('data-variants') || '').split('|').filter(Boolean).map(function (s) {
                var i = s.indexOf(':');
                return { id: s.slice(0, i), label: s.slice(i + 1) };
            });
            sel.innerHTML = '';
            opts.forEach(function (o) {
                var op = document.createElement('option');
                op.value = o.id; op.textContent = (o.label || '').toLowerCase();
                sel.appendChild(op);
            });
            var pick = card.querySelector('.cart-chain-nudge__pick');
            if (pick) pick.classList.toggle('is-single', opts.length <= 1);
        }
        function selectChainStyle(el) {
            var card = el && el.closest('[data-chain-nudge]'); if (!card) return;
            if (card.classList.contains('is-adding')) return;
            card.querySelectorAll('[data-action="select-chain-style"]').forEach(function (b) {
                var on = b === el;
                b.classList.toggle('is-selected', on);
                b.setAttribute('aria-checked', on ? 'true' : 'false');
            });
            populateChainSize(el);
        }
        // Default the picker to the first style + fill its dropdown, once per render.
        function initChainPicker() {
            var card = document.querySelector('#cartDrawer [data-chain-nudge]');
            if (!card || card.__pickerInit) return;
            var first = card.querySelector('[data-action="select-chain-style"]');
            if (first) { selectChainStyle(first); card.__pickerInit = true; }
        }
        // Add the selected style at the chosen length. If it completes a BOGO
        // pair, arm the confirmation for after the re-render.
        function addChainFromNudge(btn) {
            var card = btn.closest('[data-chain-nudge]');
            if (card && card.classList.contains('is-adding')) return; // an add is already in flight
            var sel = card && card.querySelector('[data-chain-size]');
            var variantId = sel && sel.value;
            if (!variantId) { showCartToast('couldn’t add the chain. please try again.'); return; }
            if (btn.dataset.crosses === 'true') {
                if (window.Kinsora) window.Kinsora._chainUnlockPct = Math.max(1, parseInt(btn.dataset.freeTotal, 10) || 1);
            } else {
                clearChainConfirm();
            }
            var originalButtonHtml = btn.innerHTML;
            btn.innerHTML = '<span class="ks-cart-busy-spinner" aria-hidden="true"></span><span class="visually-hidden">Adding item</span>';
            btn.setAttribute('aria-busy', 'true');
            btn.disabled = true;
            if (card) card.classList.add('is-adding');
            runSynchronizedPaidCartMutation(function() {
                    return fetch(freeGiftCartEndpoint('cart/add.js'), {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                        body: JSON.stringify({ items: [{
                            id: parseInt(variantId, 10),
                            quantity: 1,
                            properties: { _kinsora_cart_unit: 'chain-' + Date.now() + '-' + Math.random().toString(36).slice(2, 9) }
                        }] })
                    }).then(function (r) {
                        if (!r.ok) {
                            return r.text().then(function (b) {
                                throw new Error('/cart/add.js ' + r.status + ' ' + b.slice(0, 200));
                            });
                        }
                        return r.json();
                    });
                })
                // The shared mutation gate refreshes the drawer before resolve.
                .catch(function (err) {
                    console.error('[Cart] addChainFromNudge:', err);
                    if (window.Kinsora) window.Kinsora._chainUnlockPct = null;
                    showCartToast('couldn’t add the chain. please try again.');
                    btn.innerHTML = originalButtonHtml;
                    btn.removeAttribute('aria-busy');
                    btn.disabled = false;
                    if (card) card.classList.remove('is-adding');
                });
        }
        function dismissChainNudge(el) {
            try { sessionStorage.setItem(CHAIN_NUDGE_DISMISS_KEY, '1'); } catch (e) {}
            var card = el.closest('[data-chain-nudge]');
            if (card) card.remove();
        }

        if (document.getElementById('cartDrawer')) {
            try { syncChainNudge(); } catch (e) {}
            verifyServerRenderedCartQuietly('page-load')
                .then(updateCartSurfacesFromSnapshot)
                .catch(function(error) {
                    console.error('[Cart] initial cart verification failed:', error);
                    showCartToast('Checkout is paused because your cart could not be verified. Please refresh and try again.');
                });
        }

        // Theme editor live preview: re-init when section is re-rendered
        document.addEventListener('shopify:section:load', function(e) {
            if (e.detail && e.detail.sectionId === 'cart-drawer') {
                refreshCartDrawer();
            }
        });

        // Transparent header – add solid bg on scroll
        (function() {
            var nav = document.querySelector('.main-nav[data-transparent-header]');
            if (!nav) return;
            var threshold = 60;
            var ticking = false;
            function syncState() {
                var solid = window.scrollY > threshold;
                nav.classList.toggle('main-nav--scrolled', solid);
                document.body.classList.toggle('nav-solid', solid);
            }
            function queueSync() {
                if (ticking) return;
                ticking = true;
                requestAnimationFrame(function() {
                    syncState();
                    ticking = false;
                });
            }
            syncState();
            window.addEventListener('scroll', queueSync, { passive: true });
            window.addEventListener('pageshow', syncState);
        })();

        // Measure the fixed header bottom + stack tier bar height into CSS vars,
        // so the bar sits flush under the header and the sticky ATC bar sits below it.
        (function () {
            function kMeasureBars() {
                var root = document.documentElement;
                var nav = document.querySelector('.main-nav');
                var stier = document.getElementById('shopify-section-stack-tier-bar');
                if (nav) {
                    var hb = Math.round(nav.getBoundingClientRect().bottom);
                    if (hb > 0) root.style.setProperty('--kheader-h', hb + 'px');
                }
                if (stier) {
                    var sh = Math.round(stier.getBoundingClientRect().height);
                    if (sh > 0) root.style.setProperty('--kstier-h', sh + 'px');
                }
            }
            window.Kinsora = window.Kinsora || {};
            window.Kinsora.measureBars = kMeasureBars;
            if (document.readyState === 'loading') {
                document.addEventListener('DOMContentLoaded', kMeasureBars);
            } else {
                kMeasureBars();
            }
            window.addEventListener('load', kMeasureBars);
            window.addEventListener('resize', kMeasureBars);
        })();

        // Policy Page
        function scrollToPolicy(event, policyId) {
            document.querySelectorAll('#policyPage .policy-nav-link').forEach(link => {
                link.classList.remove('active');
            });
            event.target.classList.add('active');

            var section = document.getElementById(policyId);
            if (section) {
                section.scrollIntoView({ behavior: 'smooth' });
            }
        }

        // Scroll-to-top button visibility (throttled to ~60fps)
        window.addEventListener('scroll', throttle(function() {
            var btn = document.getElementById('scrollToTop');
            if (btn) {
                if (window.scrollY > 400) {
                    btn.classList.add('visible');
                } else {
                    btn.classList.remove('visible');
                }
            }
        }, 100));

        // ---- Data-action event delegation ----
        // Maps data-action attributes in HTML to handler functions.
        // Replaces inline onclick handlers for Shopify Section Rendering API compatibility.
        // Keyboard activation (Enter / Space) for focusable non-native toggles:
        // role="button" or [data-action] elements that carry a tabindex.
        document.addEventListener('keydown', function(e) {
            if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
            var k = e.target;
            if (!k || !k.matches) return;
            if (k.matches('[role="button"][tabindex], [data-action][tabindex]') && !k.matches('button, a, input, select, textarea, summary')) {
                e.preventDefault();
                k.click();
            }
        });
        document.addEventListener('click', function(e) {
            var el = safeClosest(e.target, '[data-action]');
            if (!el) return;
            var action = el.dataset.action;
            switch (action) {
                // Product page — buy box
                case 'switch-tab':
                    switchBuyBoxTab(el, el.dataset.tab);
                    break;
                case 'select-swatch':
                    selectSwatch(el);
                    break;
                case 'select-length':
                    selectLength(el);
                    break;
                case 'add-pendant-necklace':
                    addPendantNecklaceMode();
                    break;
                case 'toggle-dropdown':
                    toggleDropdown(el.closest('.dropdown-wrapper'));
                    break;
                case 'add-secondary-necklace':
                    addSecondaryNecklace();
                    break;
                case 'add-pendant-stack':
                    addPendantStackMode();
                    break;
                case 'add-to-cart':
                    addToCart();
                    break;
                case 'share-product':
                    if (navigator.share) {
                        navigator.share({ title: document.title, url: window.location.href });
                    } else {
                        navigator.clipboard.writeText(window.location.href).then(function() {
                            el.textContent = 'Link copied!';
                            setTimeout(function() { el.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/></svg> Share'; }, 2000);
                        });
                    }
                    break;
                case 'toggle-subscription':
                    toggleSubscription(el);
                    break;
                case 'toggle-accordion':
                    toggleAccordion(el);
                    break;
                case 'switch-image':
                    switchImage(el, parseInt(el.dataset.index, 10));
                    break;

                // Cart drawer
                case 'close-cart':
                    closeCart();
                    break;
                case 'open-cart':
                    openCart();
                    break;
                case 'cart-quantity-minus':
                    if (_cartRemovalBusy) break;
                    var key = el.dataset.cartItemKey || el.closest('.cart-item').dataset.cartItemKey;
                    if (key) {
                        var redesignedDrawer = el.closest('#cartDrawer[data-kinsora-cart-redesign="true"]');
                        if (redesignedDrawer) updateQty(key, -1, el);
                        else tierGate(el.closest('.cart-item'), 'minus', (function (k, control) { return function () { updateQty(k, -1, control); }; })(key, el));
                    }
                    break;
                case 'cart-quantity-plus':
                    if (_cartRemovalBusy) break;
                    var key = el.dataset.cartItemKey || el.closest('.cart-item').dataset.cartItemKey;
                    if (key) updateQty(key, 1, el);
                    break;
                case 'remove-cart-item':
                    if (_cartRemovalBusy) break;
                    var key = el.dataset.cartItemKey || el.closest('.cart-item').dataset.cartItemKey;
                    if (key) tierGate(el.closest('.cart-item'), 'remove', (function (k) { return function () { removeFromCart(k); }; })(key));
                    break;
                case 'add-upsell':
                    addUpsellToCart(el.dataset.handle, el.dataset.title, parseFloat(el.dataset.price), el);
                    break;
                case 'add-upsell-pair':
                    addUpsellPairToCart(el);
                    break;
                case 'select-upsell-pair':
                    scrollUpsellPair(el);
                    break;
                case 'select-chain-style':
                    selectChainStyle(el);
                    break;
                case 'add-chain-nudge':
                    addChainFromNudge(el);
                    break;
                case 'dismiss-chain-nudge':
                    dismissChainNudge(el);
                    break;

                // Header / navigation
                case 'open-mobile-menu':
                    openMobileMenu();
                    break;
                case 'close-mobile-menu':
                    closeMobileMenu();
                    break;
                case 'toggle-mobile-submenu':
                    toggleMobileSubmenu(el);
                    el.setAttribute('aria-expanded', el.getAttribute('aria-expanded') !== 'true');
                    break;

                // Announcement bar
                case 'rotate-announcement':
                    rotateAnnouncement(parseInt(el.dataset.direction, 10));
                    break;

                // Collection filters (Storefront Filtering API)
                case 'open-filters':
                    openFilterDrawer(el);
                    break;
                case 'close-filters':
                    closeFilterDrawer();
                    break;
                case 'toggle-filter-group':
                    setFilterGroupExpanded(el, el.getAttribute('aria-expanded') !== 'true');
                    break;
                case 'apply-filters':
                    var form = document.getElementById('filtersForm');
                    if (form) {
                        var params = new URLSearchParams();
                        form.querySelectorAll('input[type="checkbox"]:checked').forEach(function(cb) {
                            params.append(cb.name, cb.value);
                        });
                        form.querySelectorAll('input[type="number"]').forEach(function(input) {
                            if (input.value) params.set(input.name, input.value * 100);
                        });
                        var sortSelect = document.getElementById('sortBy');
                        if (sortSelect && sortSelect.value) params.set('sort_by', sortSelect.value);
                        var filterUrl = window.location.pathname + '?' + params.toString();
                        closeFilterDrawer();
                        fetchCollectionSection(filterUrl, '[data-action="open-filters"]');
                    }
                    break;
                case 'filter-pill':
                    var cat = el.dataset.category;
                    if (cat) {
                        document.querySelectorAll('.filter-button').forEach(function(p) { p.classList.remove('active'); });
                        el.classList.add('active');
                        document.querySelectorAll('.product-card[data-category]').forEach(function(card) {
                            card.style.display = (!cat || cat === 'all' || card.dataset.category === cat) ? '' : 'none';
                        });
                    }
                    break;

                // Mega menu (header)
                case 'mega-menu-trigger':
                    openMegaMenu();
                    break;
                case 'mega-menu-close':
                    forceCloseMegaMenu();
                    break;

                // FAQ & lifestyle accordions
                case 'toggle-faq-accordion':
                    el.classList.toggle('expanded');
                    var faqExpanded = el.classList.contains('expanded');
                    el.setAttribute('aria-expanded', faqExpanded ? 'true' : 'false');
                    var answer = el.nextElementSibling;
                    if (answer) {
                        answer.classList.toggle('expanded', faqExpanded);
                        answer.setAttribute('aria-hidden', faqExpanded ? 'false' : 'true');
                        if (faqExpanded) answer.removeAttribute('inert');
                        else answer.setAttribute('inert', '');
                    }
                    break;
                case 'toggle-lifestyle-accordion':
                    var content = el.nextElementSibling;
                    if (content) {
                        content.classList.toggle('open');
                        el.classList.toggle('active');
                    }
                    break;

                // Product dropdowns (safe event delegation — replaces inline onclick)
                case 'select-option':
                    selectOption(el);
                    break;
                case 'change-variant':
                    onVariantSelectChange(el);
                    break;
                case 'remove-dropdown-row':
                    removeDropdownRow(el);
                    break;

                // Product recommendations slider
                case 'rec-slider-prev':
                case 'rec-slider-next':
                    var wrapper = el.closest('.rec-slider-wrapper');
                    if (!wrapper) break;
                    var slider = wrapper.querySelector('.rec-slider');
                    if (!slider) break;
                    var card = slider.querySelector('.fc-card');
                    if (!card) break;
                    var gap = parseFloat(getComputedStyle(slider).gap) || 16;
                    var scrollAmount = card.offsetWidth + gap;
                    if (action === 'rec-slider-prev') {
                        slider.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
                    } else {
                        slider.scrollBy({ left: scrollAmount, behavior: 'smooth' });
                    }
                    break;
            }
        });

        /* ---- Product Recommendations (fetch via Shopify API) ---- */
        document.querySelectorAll('[data-section-type="product-recommendations"]').forEach(function(section) {
            var url = section.dataset.url;
            if (!url) return;
            fetch(url)
                .then(function(r) {
                    if (!r.ok) throw new Error('Recommendations request failed: ' + r.status);
                    return r.text();
                })
                .then(function(html) {
                    var parser = new DOMParser();
                    var doc = parser.parseFromString(html, 'text/html');
                    var newContent = doc.querySelector('.product-recommendations');
                    if (newContent && newContent.innerHTML.trim().length > 0) {
                        section.innerHTML = newContent.innerHTML;
                    }
                })
                .catch(function(err) {
                    console.error('Failed to load product recommendations:', err);
                });
        });

        // Reviews carousel JS is now self-contained in reviews.liquid section
